/* eslint-disable */
import * as Types from '@amzn/elevate-graphql/types';
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type UpsertShepherdProfileCalibrationMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  input: Types.ShepherdProfileCalibrationInput;
}>;


export type UpsertShepherdProfileCalibrationMutation = { upsertShepherdProfileCalibration: boolean };

export type CreateShepherdProfileNoteMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  input: Types.CreateShepherdProfileNoteInput;
}>;


export type CreateShepherdProfileNoteMutation = { createShepherdProfileNote: string };

export type RemoveShepherdProfileAssignmentMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  profileId: Types.Scalars['ID']['input'];
  shepherdId: Types.Scalars['ID']['input'];
}>;


export type RemoveShepherdProfileAssignmentMutation = { removeShepherdProfileAssignment: boolean };

export type CreateOrgBarRaiserMutationVariables = Types.Exact<{
  alias: Types.Scalars['String']['input'];
  orgId: Types.Scalars['ID']['input'];
}>;


export type CreateOrgBarRaiserMutation = { createOrgBarRaiser: { __typename: 'CreateOrgBarRaiserResponse', alias: string, orgId: string, profileId: string } | null };

export type DeleteOrgBarRaiserMutationVariables = Types.Exact<{
  profileId: Types.Scalars['ID']['input'];
  orgId: Types.Scalars['ID']['input'];
}>;


export type DeleteOrgBarRaiserMutation = { deleteOrgBarRaiser: { __typename: 'DeleteOrgBarRaiserResponse', orgId: string, profileId: string, roles: Array<Types.Roles> | null } | null };

export type CreateElevateProfileMutationVariables = Types.Exact<{
  alias: Types.Scalars['String']['input'];
  orgId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  isSetTimezoneId?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CreateElevateProfileMutation = { createElevateProfile: { __typename: 'CreateElevateProfileResponse', alias: string, profileId: string, lastRefreshedAt: string | null } | null };

export type RefreshElevateProfileMutationVariables = Types.Exact<{
  alias: Types.Scalars['String']['input'];
  isForceRefresh?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type RefreshElevateProfileMutation = { refreshElevateProfile: { __typename: 'RefreshElevateProfileResponse', lastRefreshedAt: string | null, profileId: string } | null };

export type CreateManagedQuipMutationVariables = Types.Exact<{
  input: Types.CreateManagedQuipMutationInput;
}>;


export type CreateManagedQuipMutation = { createManagedQuip: { __typename: 'CreateManagedQuipResponse', quipId: string | null, quipLink: string } | null };

export type DeleteManagedQuipMutationVariables = Types.Exact<{
  input: Types.DeleteManagedQuipMutationInput;
}>;


export type DeleteManagedQuipMutation = { deleteManagedQuip: { __typename: 'DeleteManagedQuipResponse', quipLink: string | null, success: boolean } | null };

export type BackfillManagedTranscriptMutationVariables = Types.Exact<{
  input: Types.BackfillManagedTranscriptMutationInput;
}>;


export type BackfillManagedTranscriptMutation = { backfillManagedTranscript: { __typename: 'Transcript', id: string, cancelledAt: string | null, completedAt: string | null, createdAt: string | null, failedAt: string | null, status: Types.TranscriptStatus, trainingId: string, trainingVersion: string, userId: string } | null };

export type RestartPushRoutingMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID']['input'];
  eventType: Types.EventType;
  forBarRaiser?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type RestartPushRoutingMutation = { restartPushRouting: { __typename: 'RestartPushRoutingResponse', eventId: string, eventType: Types.EventType, success: boolean, participantType: string | null, message: string | null } | null };

export type CreateMeetingMutationVariables = Types.Exact<{
  input: Types.CreateMeetingInput;
}>;


export type CreateMeetingMutation = { createMeeting: { __typename: 'Meeting', id: string, subject: string, body: string | null, start: string, end: string, attendees: Array<string>, location: string | null, isOnlineMeeting: boolean | null, meetingLink: string | null, createdAt: string | null, updatedAt: string | null } };

export type UpdateMeetingMutationVariables = Types.Exact<{
  input: Types.UpdateMeetingInput;
}>;


export type UpdateMeetingMutation = { updateMeeting: { __typename: 'Meeting', id: string, subject: string, body: string | null, start: string, end: string, attendees: Array<string>, location: string | null, isOnlineMeeting: boolean | null, meetingLink: string | null, createdAt: string | null, updatedAt: string | null } };

export type DeleteMeetingMutationVariables = Types.Exact<{
  input: Types.DeleteMeetingInput;
}>;


export type DeleteMeetingMutation = { deleteMeeting: boolean };

export type CreateAnnouncementMutationVariables = Types.Exact<{
  input: Types.CreateAnnouncementInput;
  condition?: Types.InputMaybe<Types.ModelAnnouncementConditionInput>;
}>;


export type CreateAnnouncementMutation = { createAnnouncement: { __typename: 'Announcement', id: string, createdAt: string, orgId: string, group: string, viewers: Array<string> | null, title: string, text: string, status: Types.AnnouncementStatus, updatedAt: string, owner: string | null } | null };

export type UpdateAnnouncementMutationVariables = Types.Exact<{
  input: Types.UpdateAnnouncementInput;
  condition?: Types.InputMaybe<Types.ModelAnnouncementConditionInput>;
}>;


export type UpdateAnnouncementMutation = { updateAnnouncement: { __typename: 'Announcement', id: string, createdAt: string, orgId: string, group: string, viewers: Array<string> | null, title: string, text: string, status: Types.AnnouncementStatus, updatedAt: string, owner: string | null } | null };

export type DeleteAnnouncementMutationVariables = Types.Exact<{
  input: Types.DeleteAnnouncementInput;
  condition?: Types.InputMaybe<Types.ModelAnnouncementConditionInput>;
}>;


export type DeleteAnnouncementMutation = { deleteAnnouncement: { __typename: 'Announcement', id: string, createdAt: string, orgId: string, group: string, viewers: Array<string> | null, title: string, text: string, status: Types.AnnouncementStatus, updatedAt: string, owner: string | null } | null };

export type CreateAuditTrailsMutationVariables = Types.Exact<{
  input: Types.CreateAuditTrailsInput;
  condition?: Types.InputMaybe<Types.ModelAuditTrailsConditionInput>;
}>;


export type CreateAuditTrailsMutation = { createAuditTrails: { __typename: 'AuditTrails', id: string, createdAt: string, changeJustification: string | null, humanReadableLog: Array<string> | null, modifiedBy: string | null, rawOldRecord: string | null, rawNewRecord: string | null, recordType: Types.AuditTrailRecordType | null, orgID: string | null, profileID: string | null, eventType: Types.EventType | null, eventId: string | null, candidateId: string | null, interviewerId: string | null, updatedAt: string } | null };

export type UpdateAuditTrailsMutationVariables = Types.Exact<{
  input: Types.UpdateAuditTrailsInput;
  condition?: Types.InputMaybe<Types.ModelAuditTrailsConditionInput>;
}>;


export type UpdateAuditTrailsMutation = { updateAuditTrails: { __typename: 'AuditTrails', id: string, createdAt: string, changeJustification: string | null, humanReadableLog: Array<string> | null, modifiedBy: string | null, rawOldRecord: string | null, rawNewRecord: string | null, recordType: Types.AuditTrailRecordType | null, orgID: string | null, profileID: string | null, eventType: Types.EventType | null, eventId: string | null, candidateId: string | null, interviewerId: string | null, updatedAt: string } | null };

export type DeleteAuditTrailsMutationVariables = Types.Exact<{
  input: Types.DeleteAuditTrailsInput;
  condition?: Types.InputMaybe<Types.ModelAuditTrailsConditionInput>;
}>;


export type DeleteAuditTrailsMutation = { deleteAuditTrails: { __typename: 'AuditTrails', id: string, createdAt: string, changeJustification: string | null, humanReadableLog: Array<string> | null, modifiedBy: string | null, rawOldRecord: string | null, rawNewRecord: string | null, recordType: Types.AuditTrailRecordType | null, orgID: string | null, profileID: string | null, eventType: Types.EventType | null, eventId: string | null, candidateId: string | null, interviewerId: string | null, updatedAt: string } | null };

export type CreateCandidateMutationVariables = Types.Exact<{
  input: Types.CreateCandidateInput;
  condition?: Types.InputMaybe<Types.ModelCandidateConditionInput>;
}>;


export type CreateCandidateMutation = { createCandidate: { __typename: 'Candidate', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, canManage: Array<string> | null, canRead: Array<string> | null, city: string | null, country: string | null, decision: Types.HireDecision | null, hireurl: string | null, level: number | null, name: string, loopEventID: string | null, phoneScreenID: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateCandidateMutationVariables = Types.Exact<{
  input: Types.UpdateCandidateInput;
  condition?: Types.InputMaybe<Types.ModelCandidateConditionInput>;
}>;


export type UpdateCandidateMutation = { updateCandidate: { __typename: 'Candidate', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, canManage: Array<string> | null, canRead: Array<string> | null, city: string | null, country: string | null, decision: Types.HireDecision | null, hireurl: string | null, level: number | null, name: string, loopEventID: string | null, phoneScreenID: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteCandidateMutationVariables = Types.Exact<{
  input: Types.DeleteCandidateInput;
  condition?: Types.InputMaybe<Types.ModelCandidateConditionInput>;
}>;


export type DeleteCandidateMutation = { deleteCandidate: { __typename: 'Candidate', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, canManage: Array<string> | null, canRead: Array<string> | null, city: string | null, country: string | null, decision: Types.HireDecision | null, hireurl: string | null, level: number | null, name: string, loopEventID: string | null, phoneScreenID: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateCommentMutationVariables = Types.Exact<{
  input: Types.CreateCommentInput;
  condition?: Types.InputMaybe<Types.ModelCommentConditionInput>;
}>;


export type CreateCommentMutation = { createComment: { __typename: 'Comment', id: string, createdAt: string, honeycode_uid: number | null, group: string, owner: string | null, viewers: Array<string> | null, commentType: Types.CommentType, content: string, profileID: string, restricted: boolean | null, loopEventID: string | null, phoneScreenID: string | null, interviewerID: string | null, interviewerProfileID: string | null, interviewerAlias: string | null, rating: number | null, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, interviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateCommentMutationVariables = Types.Exact<{
  input: Types.UpdateCommentInput;
  condition?: Types.InputMaybe<Types.ModelCommentConditionInput>;
}>;


export type UpdateCommentMutation = { updateComment: { __typename: 'Comment', id: string, createdAt: string, honeycode_uid: number | null, group: string, owner: string | null, viewers: Array<string> | null, commentType: Types.CommentType, content: string, profileID: string, restricted: boolean | null, loopEventID: string | null, phoneScreenID: string | null, interviewerID: string | null, interviewerProfileID: string | null, interviewerAlias: string | null, rating: number | null, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, interviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteCommentMutationVariables = Types.Exact<{
  input: Types.DeleteCommentInput;
  condition?: Types.InputMaybe<Types.ModelCommentConditionInput>;
}>;


export type DeleteCommentMutation = { deleteComment: { __typename: 'Comment', id: string, createdAt: string, honeycode_uid: number | null, group: string, owner: string | null, viewers: Array<string> | null, commentType: Types.CommentType, content: string, profileID: string, restricted: boolean | null, loopEventID: string | null, phoneScreenID: string | null, interviewerID: string | null, interviewerProfileID: string | null, interviewerAlias: string | null, rating: number | null, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, interviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateInterviewerMutationVariables = Types.Exact<{
  input: Types.CreateInterviewerInput;
  condition?: Types.InputMaybe<Types.ModelInterviewerConditionInput>;
}>;


export type CreateInterviewerMutation = { createInterviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string, participantConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, sourceOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null } | null };

export type UpdateInterviewerMutationVariables = Types.Exact<{
  input: Types.UpdateInterviewerInput;
  condition?: Types.InputMaybe<Types.ModelInterviewerConditionInput>;
}>;


export type UpdateInterviewerMutation = { updateInterviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string, participantConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, sourceOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null } | null };

export type DeleteInterviewerMutationVariables = Types.Exact<{
  input: Types.DeleteInterviewerInput;
  condition?: Types.InputMaybe<Types.ModelInterviewerConditionInput>;
}>;


export type DeleteInterviewerMutation = { deleteInterviewer: { __typename: 'Interviewer', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, interviewerRole: Types.InterviewerRole, interviewType: Types.InterviewType | null, participantConfigID: string | null, profileID: string, acceptedAt: string | null, meetingsentryID: string | null, sendCalendarInvite: boolean | null, startDateTime: string | null, endDateTime: string | null, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, phoneScreenID: string | null, extLoopEventID: string | null, extPhoneScreenID: string | null, sourceOrgID: string | null, createdAt: string, updatedAt: string, participantConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, sourceOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null } | null };

export type CreateLanguageMutationVariables = Types.Exact<{
  input: Types.CreateLanguageInput;
  condition?: Types.InputMaybe<Types.ModelLanguageConditionInput>;
}>;


export type CreateLanguageMutation = { createLanguage: { __typename: 'Language', id: string, isoCode: string, recordType: Types.LanguageRecordType, profileId: string | null, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null, loopEventId: string | null, phoneScreenId: string | null, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateLanguageMutationVariables = Types.Exact<{
  input: Types.UpdateLanguageInput;
  condition?: Types.InputMaybe<Types.ModelLanguageConditionInput>;
}>;


export type UpdateLanguageMutation = { updateLanguage: { __typename: 'Language', id: string, isoCode: string, recordType: Types.LanguageRecordType, profileId: string | null, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null, loopEventId: string | null, phoneScreenId: string | null, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteLanguageMutationVariables = Types.Exact<{
  input: Types.DeleteLanguageInput;
  condition?: Types.InputMaybe<Types.ModelLanguageConditionInput>;
}>;


export type DeleteLanguageMutation = { deleteLanguage: { __typename: 'Language', id: string, isoCode: string, recordType: Types.LanguageRecordType, profileId: string | null, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null, loopEventId: string | null, phoneScreenId: string | null, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateLoopEventMutationVariables = Types.Exact<{
  input: Types.CreateLoopEventInput;
  condition?: Types.InputMaybe<Types.ModelLoopEventConditionInput>;
}>;


export type CreateLoopEventMutation = { createLoopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, lockedby: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, eventlead: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, recruitingPOC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiser: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiserRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type UpdateLoopEventMutationVariables = Types.Exact<{
  input: Types.UpdateLoopEventInput;
  condition?: Types.InputMaybe<Types.ModelLoopEventConditionInput>;
}>;


export type UpdateLoopEventMutation = { updateLoopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, lockedby: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, eventlead: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, recruitingPOC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiser: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiserRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type DeleteLoopEventMutationVariables = Types.Exact<{
  input: Types.DeleteLoopEventInput;
  condition?: Types.InputMaybe<Types.ModelLoopEventConditionInput>;
}>;


export type DeleteLoopEventMutation = { deleteLoopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, lockedby: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, eventlead: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, recruitingPOC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiser: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, barRaiserRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type CreateManagedTranscriptMutationVariables = Types.Exact<{
  input: Types.CreateManagedTranscriptInput;
  condition?: Types.InputMaybe<Types.ModelManagedTranscriptConditionInput>;
}>;


export type CreateManagedTranscriptMutation = { createManagedTranscript: { __typename: 'ManagedTranscript', completedAt: string | null, failedAt: string | null, learnTrainingId: string | null, learnTrainingVersion: string | null, learnUserId: string, status: Types.ManagedTranscriptStatus, trainingId: string, createdAt: string, updatedAt: string } | null };

export type UpdateManagedTranscriptMutationVariables = Types.Exact<{
  input: Types.UpdateManagedTranscriptInput;
  condition?: Types.InputMaybe<Types.ModelManagedTranscriptConditionInput>;
}>;


export type UpdateManagedTranscriptMutation = { updateManagedTranscript: { __typename: 'ManagedTranscript', completedAt: string | null, failedAt: string | null, learnTrainingId: string | null, learnTrainingVersion: string | null, learnUserId: string, status: Types.ManagedTranscriptStatus, trainingId: string, createdAt: string, updatedAt: string } | null };

export type DeleteManagedTranscriptMutationVariables = Types.Exact<{
  input: Types.DeleteManagedTranscriptInput;
  condition?: Types.InputMaybe<Types.ModelManagedTranscriptConditionInput>;
}>;


export type DeleteManagedTranscriptMutation = { deleteManagedTranscript: { __typename: 'ManagedTranscript', completedAt: string | null, failedAt: string | null, learnTrainingId: string | null, learnTrainingVersion: string | null, learnUserId: string, status: Types.ManagedTranscriptStatus, trainingId: string, createdAt: string, updatedAt: string } | null };

export type CreateOrgCollaborationsMutationVariables = Types.Exact<{
  input: Types.CreateOrgCollaborationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgCollaborationsConditionInput>;
}>;


export type CreateOrgCollaborationsMutation = { createOrgCollaborations: { __typename: 'OrgCollaborations', id: string, groups: Array<string>, isActive: boolean | null, isPendingAuthorization: boolean | null, pendingChangeSpec: string | null, originatingOrgID: string | null, targetOrgID: string | null, barRaisers: boolean | null, originParticipantIDs: Array<string> | null, targetParticipantIDs: Array<string> | null, createdAt: string, updatedAt: string, originatingOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, targetOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, sharedLoopParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, originParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, targetParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null } | null };

export type UpdateOrgCollaborationsMutationVariables = Types.Exact<{
  input: Types.UpdateOrgCollaborationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgCollaborationsConditionInput>;
}>;


export type UpdateOrgCollaborationsMutation = { updateOrgCollaborations: { __typename: 'OrgCollaborations', id: string, groups: Array<string>, isActive: boolean | null, isPendingAuthorization: boolean | null, pendingChangeSpec: string | null, originatingOrgID: string | null, targetOrgID: string | null, barRaisers: boolean | null, originParticipantIDs: Array<string> | null, targetParticipantIDs: Array<string> | null, createdAt: string, updatedAt: string, originatingOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, targetOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, sharedLoopParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, originParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, targetParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null } | null };

export type DeleteOrgCollaborationsMutationVariables = Types.Exact<{
  input: Types.DeleteOrgCollaborationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgCollaborationsConditionInput>;
}>;


export type DeleteOrgCollaborationsMutation = { deleteOrgCollaborations: { __typename: 'OrgCollaborations', id: string, groups: Array<string>, isActive: boolean | null, isPendingAuthorization: boolean | null, pendingChangeSpec: string | null, originatingOrgID: string | null, targetOrgID: string | null, barRaisers: boolean | null, originParticipantIDs: Array<string> | null, targetParticipantIDs: Array<string> | null, createdAt: string, updatedAt: string, originatingOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, targetOrg: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, sharedLoopParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, originParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, targetParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null } | null };

export type CreateOrgLoopPsConfigurationsMutationVariables = Types.Exact<{
  input: Types.CreateOrgLoopPsConfigurationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsConditionInput>;
}>;


export type CreateOrgLoopPsConfigurationsMutation = { createOrgLoopPSConfigurations: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, calibrationParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, calibrationConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, competencies: Array<{ __typename: 'CompetencyPair', level: number | null } | null> | null, participantConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null } | null };

export type UpdateOrgLoopPsConfigurationsMutationVariables = Types.Exact<{
  input: Types.UpdateOrgLoopPsConfigurationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsConditionInput>;
}>;


export type UpdateOrgLoopPsConfigurationsMutation = { updateOrgLoopPSConfigurations: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, calibrationParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, calibrationConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, competencies: Array<{ __typename: 'CompetencyPair', level: number | null } | null> | null, participantConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null } | null };

export type DeleteOrgLoopPsConfigurationsMutationVariables = Types.Exact<{
  input: Types.DeleteOrgLoopPsConfigurationsInput;
  condition?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsConditionInput>;
}>;


export type DeleteOrgLoopPsConfigurationsMutation = { deleteOrgLoopPSConfigurations: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, calibrationParticipants: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, calibrationConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, competencies: Array<{ __typename: 'CompetencyPair', level: number | null } | null> | null, participantConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null } | null };

export type CreateOrganizationMutationVariables = Types.Exact<{
  input: Types.CreateOrganizationInput;
  condition?: Types.InputMaybe<Types.ModelOrganizationConditionInput>;
}>;


export type CreateOrganizationMutation = { createOrganization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string, eventTags: Array<{ __typename: 'TagDefinition', group: string | null, value: string }> | null, orgCollaborationsInbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, orgCollaborationsOutbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, loopPSConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, members: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, roleLDAPGroups: { __typename: 'ModelOrgRoleLDAPGroupsConnection', nextToken: string | null } | null, roleGroups: { __typename: 'ModelRolePermissionGroupConnection', nextToken: string | null } | null, trainings: { __typename: 'ModelTrainingConnection', nextToken: string | null } | null, competencies: Array<{ __typename: 'Competency', name: string | null, description: string | null } | null> | null, advancedSettings: { __typename: 'OrgFeatureFlags', enablePromoHub: boolean | null, enableApss: boolean | null, enableInterviewManagement: boolean | null, enableLoopQuipExport: boolean | null, enablePhoneScreenQuipExport: boolean | null, enablePushRouting: boolean | null } | null } | null };

export type UpdateOrganizationMutationVariables = Types.Exact<{
  input: Types.UpdateOrganizationInput;
  condition?: Types.InputMaybe<Types.ModelOrganizationConditionInput>;
}>;


export type UpdateOrganizationMutation = { updateOrganization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string, eventTags: Array<{ __typename: 'TagDefinition', group: string | null, value: string }> | null, orgCollaborationsInbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, orgCollaborationsOutbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, loopPSConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, members: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, roleLDAPGroups: { __typename: 'ModelOrgRoleLDAPGroupsConnection', nextToken: string | null } | null, roleGroups: { __typename: 'ModelRolePermissionGroupConnection', nextToken: string | null } | null, trainings: { __typename: 'ModelTrainingConnection', nextToken: string | null } | null, competencies: Array<{ __typename: 'Competency', name: string | null, description: string | null } | null> | null, advancedSettings: { __typename: 'OrgFeatureFlags', enablePromoHub: boolean | null, enableApss: boolean | null, enableInterviewManagement: boolean | null, enableLoopQuipExport: boolean | null, enablePhoneScreenQuipExport: boolean | null, enablePushRouting: boolean | null } | null } | null };

export type DeleteOrganizationMutationVariables = Types.Exact<{
  input: Types.DeleteOrganizationInput;
  condition?: Types.InputMaybe<Types.ModelOrganizationConditionInput>;
}>;


export type DeleteOrganizationMutation = { deleteOrganization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string, eventTags: Array<{ __typename: 'TagDefinition', group: string | null, value: string }> | null, orgCollaborationsInbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, orgCollaborationsOutbound: { __typename: 'ModelOrgCollaborationsConnection', nextToken: string | null } | null, loopPSConfigs: { __typename: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null } | null, loopEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, phoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, interviews: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, members: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, roleLDAPGroups: { __typename: 'ModelOrgRoleLDAPGroupsConnection', nextToken: string | null } | null, roleGroups: { __typename: 'ModelRolePermissionGroupConnection', nextToken: string | null } | null, trainings: { __typename: 'ModelTrainingConnection', nextToken: string | null } | null, competencies: Array<{ __typename: 'Competency', name: string | null, description: string | null } | null> | null, advancedSettings: { __typename: 'OrgFeatureFlags', enablePromoHub: boolean | null, enableApss: boolean | null, enableInterviewManagement: boolean | null, enableLoopQuipExport: boolean | null, enablePhoneScreenQuipExport: boolean | null, enablePushRouting: boolean | null } | null } | null };

export type CreatePhoneScreenMutationVariables = Types.Exact<{
  input: Types.CreatePhoneScreenInput;
  condition?: Types.InputMaybe<Types.ModelPhoneScreenConditionInput>;
}>;


export type CreatePhoneScreenMutation = { createPhoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type UpdatePhoneScreenMutationVariables = Types.Exact<{
  input: Types.UpdatePhoneScreenInput;
  condition?: Types.InputMaybe<Types.ModelPhoneScreenConditionInput>;
}>;


export type UpdatePhoneScreenMutation = { updatePhoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type DeletePhoneScreenMutationVariables = Types.Exact<{
  input: Types.DeletePhoneScreenInput;
  condition?: Types.InputMaybe<Types.ModelPhoneScreenConditionInput>;
}>;


export type DeletePhoneScreenMutation = { deletePhoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string, eventConfig: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, designatedRC: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, candidates: { __typename: 'ModelCandidateConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, routingHistory: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null } | null };

export type CreateProfileMutationVariables = Types.Exact<{
  input: Types.CreateProfileInput;
  condition?: Types.InputMaybe<Types.ModelProfileConditionInput>;
}>;


export type CreateProfileMutation = { createProfile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string, shepherds: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, cohortMembers: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, availabilities: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null, routingAttempts: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null, designatedRCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, eventLeadLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, recruitingPOCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, designatedRCPhoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, lockedLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, orgs: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, barRaiserEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null } | null };

export type UpdateProfileMutationVariables = Types.Exact<{
  input: Types.UpdateProfileInput;
  condition?: Types.InputMaybe<Types.ModelProfileConditionInput>;
}>;


export type UpdateProfileMutation = { updateProfile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string, shepherds: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, cohortMembers: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, availabilities: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null, routingAttempts: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null, designatedRCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, eventLeadLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, recruitingPOCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, designatedRCPhoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, lockedLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, orgs: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, barRaiserEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null } | null };

export type DeleteProfileMutationVariables = Types.Exact<{
  input: Types.DeleteProfileInput;
  condition?: Types.InputMaybe<Types.ModelProfileConditionInput>;
}>;


export type DeleteProfileMutation = { deleteProfile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string, shepherds: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, calibrations: { __typename: 'ModelProfileCalibrationConnection', nextToken: string | null } | null, cohortMembers: { __typename: 'ModelShepherdProfileConnection', nextToken: string | null } | null, interviewers: { __typename: 'ModelInterviewerConnection', nextToken: string | null } | null, availabilities: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null, routingAttempts: { __typename: 'ModelRoutingAttemptConnection', nextToken: string | null } | null, designatedRCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, eventLeadLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, recruitingPOCLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, designatedRCPhoneScreens: { __typename: 'ModelPhoneScreenConnection', nextToken: string | null } | null, lockedLoops: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null, comments: { __typename: 'ModelCommentConnection', nextToken: string | null } | null, orgs: { __typename: 'ModelProfileOrganizationV2Connection', nextToken: string | null } | null, languages: { __typename: 'ModelLanguageConnection', nextToken: string | null } | null, barRaiserEvents: { __typename: 'ModelLoopEventConnection', nextToken: string | null } | null } | null };

export type CreateProfileAvailabilityMutationVariables = Types.Exact<{
  input: Types.CreateProfileAvailabilityInput;
  condition?: Types.InputMaybe<Types.ModelProfileAvailabilityConditionInput>;
}>;


export type CreateProfileAvailabilityMutation = { createProfileAvailability: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, availabilitySeries: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string } | null, occurrences: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null } | null };

export type UpdateProfileAvailabilityMutationVariables = Types.Exact<{
  input: Types.UpdateProfileAvailabilityInput;
  condition?: Types.InputMaybe<Types.ModelProfileAvailabilityConditionInput>;
}>;


export type UpdateProfileAvailabilityMutation = { updateProfileAvailability: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, availabilitySeries: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string } | null, occurrences: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null } | null };

export type DeleteProfileAvailabilityMutationVariables = Types.Exact<{
  input: Types.DeleteProfileAvailabilityInput;
  condition?: Types.InputMaybe<Types.ModelProfileAvailabilityConditionInput>;
}>;


export type DeleteProfileAvailabilityMutation = { deleteProfileAvailability: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, availabilitySeries: { __typename: 'ProfileAvailability', id: string, expired: boolean | null, hireurl: string | null, orgID: string | null, profileID: string, requester: string | null, state: Types.AvailabilityState, availabilityDate: string, availabilityOpen: string, availabilityClose: string, meetingsentryID: string | null, sendCalendarInvite: boolean | null, availabilitySeriesID: string | null, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string } | null, occurrences: { __typename: 'ModelProfileAvailabilityConnection', nextToken: string | null } | null } | null };

export type CreateProfileCalibrationMutationVariables = Types.Exact<{
  input: Types.CreateProfileCalibrationInput;
  condition?: Types.InputMaybe<Types.ModelProfileCalibrationConditionInput>;
}>;


export type CreateProfileCalibrationMutation = { createProfileCalibration: { __typename: 'ProfileCalibration', profileId: string, calibrationId: string, status: Types.CalibrationStatus, cohortEnteredAt: string | null, cohortExitedAt: string | null, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, calibratedAt: string | null, changeJustification: string | null, lastModifiedBy: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, calibration: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateProfileCalibrationMutationVariables = Types.Exact<{
  input: Types.UpdateProfileCalibrationInput;
  condition?: Types.InputMaybe<Types.ModelProfileCalibrationConditionInput>;
}>;


export type UpdateProfileCalibrationMutation = { updateProfileCalibration: { __typename: 'ProfileCalibration', profileId: string, calibrationId: string, status: Types.CalibrationStatus, cohortEnteredAt: string | null, cohortExitedAt: string | null, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, calibratedAt: string | null, changeJustification: string | null, lastModifiedBy: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, calibration: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteProfileCalibrationMutationVariables = Types.Exact<{
  input: Types.DeleteProfileCalibrationInput;
  condition?: Types.InputMaybe<Types.ModelProfileCalibrationConditionInput>;
}>;


export type DeleteProfileCalibrationMutation = { deleteProfileCalibration: { __typename: 'ProfileCalibration', profileId: string, calibrationId: string, status: Types.CalibrationStatus, cohortEnteredAt: string | null, cohortExitedAt: string | null, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, calibratedAt: string | null, changeJustification: string | null, lastModifiedBy: string | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, calibration: { __typename: 'OrgLoopPSConfigurations', id: string, group: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string, orgID: string, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, maxShadowPoolSize: number | null, calibrationConfigID: string | null, isPushRouting: boolean | null, concurrencyGroup: string | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, prebriefRequired: boolean | null, prebriefInformation: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateProfileOrganizationV2MutationVariables = Types.Exact<{
  input: Types.CreateProfileOrganizationV2Input;
  condition?: Types.InputMaybe<Types.ModelProfileOrganizationV2ConditionInput>;
}>;


export type CreateProfileOrganizationV2Mutation = { createProfileOrganizationV2: { __typename: 'ProfileOrganizationV2', profileID: string, group: string, orgID: string, role: Array<Types.Roles> | null, createdAt: string, updatedAt: string, organization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateProfileOrganizationV2MutationVariables = Types.Exact<{
  input: Types.UpdateProfileOrganizationV2Input;
  condition?: Types.InputMaybe<Types.ModelProfileOrganizationV2ConditionInput>;
}>;


export type UpdateProfileOrganizationV2Mutation = { updateProfileOrganizationV2: { __typename: 'ProfileOrganizationV2', profileID: string, group: string, orgID: string, role: Array<Types.Roles> | null, createdAt: string, updatedAt: string, organization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteProfileOrganizationV2MutationVariables = Types.Exact<{
  input: Types.DeleteProfileOrganizationV2Input;
  condition?: Types.InputMaybe<Types.ModelProfileOrganizationV2ConditionInput>;
}>;


export type DeleteProfileOrganizationV2Mutation = { deleteProfileOrganizationV2: { __typename: 'ProfileOrganizationV2', profileID: string, group: string, orgID: string, role: Array<Types.Roles> | null, createdAt: string, updatedAt: string, organization: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreatePromoPathMutationVariables = Types.Exact<{
  input: Types.CreatePromoPathInput;
  condition?: Types.InputMaybe<Types.ModelPromoPathConditionInput>;
}>;


export type CreatePromoPathMutation = { createPromoPath: { __typename: 'PromoPath', createdAt: string, id: string, owner: string | null, updatedAt: string, allowAttachments: boolean | null, categoryIds: Array<string> | null, name: string | null, pathType: Types.PathDefinitionType, role: string | null, startLevel: number | null, status: Types.PromoPathStatus, suggestedLPs: Array<string> | null, targetLevel: number | null, candidate: string | null, targetDate: string | null, totalCompleted: number | null, totalRequired: number | null, manager: string | null, templateId: string | null } | null };

export type UpdatePromoPathMutationVariables = Types.Exact<{
  input: Types.UpdatePromoPathInput;
  condition?: Types.InputMaybe<Types.ModelPromoPathConditionInput>;
}>;


export type UpdatePromoPathMutation = { updatePromoPath: { __typename: 'PromoPath', createdAt: string, id: string, owner: string | null, updatedAt: string, allowAttachments: boolean | null, categoryIds: Array<string> | null, name: string | null, pathType: Types.PathDefinitionType, role: string | null, startLevel: number | null, status: Types.PromoPathStatus, suggestedLPs: Array<string> | null, targetLevel: number | null, candidate: string | null, targetDate: string | null, totalCompleted: number | null, totalRequired: number | null, manager: string | null, templateId: string | null } | null };

export type DeletePromoPathMutationVariables = Types.Exact<{
  input: Types.DeletePromoPathInput;
  condition?: Types.InputMaybe<Types.ModelPromoPathConditionInput>;
}>;


export type DeletePromoPathMutation = { deletePromoPath: { __typename: 'PromoPath', createdAt: string, id: string, owner: string | null, updatedAt: string, allowAttachments: boolean | null, categoryIds: Array<string> | null, name: string | null, pathType: Types.PathDefinitionType, role: string | null, startLevel: number | null, status: Types.PromoPathStatus, suggestedLPs: Array<string> | null, targetLevel: number | null, candidate: string | null, targetDate: string | null, totalCompleted: number | null, totalRequired: number | null, manager: string | null, templateId: string | null } | null };

export type CreateCategoryMutationVariables = Types.Exact<{
  input: Types.CreateCategoryInput;
  condition?: Types.InputMaybe<Types.ModelCategoryConditionInput>;
}>;


export type CreateCategoryMutation = { createCategory: { __typename: 'Category', createdAt: string, id: string, owner: string | null, updatedAt: string, description: string, isDefault: string | null, name: string, role: string, status: Types.CategoryStatus } | null };

export type UpdateCategoryMutationVariables = Types.Exact<{
  input: Types.UpdateCategoryInput;
  condition?: Types.InputMaybe<Types.ModelCategoryConditionInput>;
}>;


export type UpdateCategoryMutation = { updateCategory: { __typename: 'Category', createdAt: string, id: string, owner: string | null, updatedAt: string, description: string, isDefault: string | null, name: string, role: string, status: Types.CategoryStatus } | null };

export type DeleteCategoryMutationVariables = Types.Exact<{
  input: Types.DeleteCategoryInput;
  condition?: Types.InputMaybe<Types.ModelCategoryConditionInput>;
}>;


export type DeleteCategoryMutation = { deleteCategory: { __typename: 'Category', createdAt: string, id: string, owner: string | null, updatedAt: string, description: string, isDefault: string | null, name: string, role: string, status: Types.CategoryStatus } | null };

export type CreateFileRecordMutationVariables = Types.Exact<{
  input: Types.CreateFileRecordInput;
  condition?: Types.InputMaybe<Types.ModelFileRecordConditionInput>;
}>;


export type CreateFileRecordMutation = { createFileRecord: { __typename: 'FileRecord', createdAt: string, id: string, owner: string | null, updatedAt: string, fileDateModified: string, fileName: string, fileSizeBytes: number, s3Key: string, storageIdKey: string, status: Types.FileRecordStatus } | null };

export type UpdateFileRecordMutationVariables = Types.Exact<{
  input: Types.UpdateFileRecordInput;
  condition?: Types.InputMaybe<Types.ModelFileRecordConditionInput>;
}>;


export type UpdateFileRecordMutation = { updateFileRecord: { __typename: 'FileRecord', createdAt: string, id: string, owner: string | null, updatedAt: string, fileDateModified: string, fileName: string, fileSizeBytes: number, s3Key: string, storageIdKey: string, status: Types.FileRecordStatus } | null };

export type DeleteFileRecordMutationVariables = Types.Exact<{
  input: Types.DeleteFileRecordInput;
  condition?: Types.InputMaybe<Types.ModelFileRecordConditionInput>;
}>;


export type DeleteFileRecordMutation = { deleteFileRecord: { __typename: 'FileRecord', createdAt: string, id: string, owner: string | null, updatedAt: string, fileDateModified: string, fileName: string, fileSizeBytes: number, s3Key: string, storageIdKey: string, status: Types.FileRecordStatus } | null };

export type CreatePeerReviewMutationVariables = Types.Exact<{
  input: Types.CreatePeerReviewInput;
  condition?: Types.InputMaybe<Types.ModelPeerReviewConditionInput>;
}>;


export type CreatePeerReviewMutation = { createPeerReview: { __typename: 'PeerReview', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, content: string | null, requiredBy: string, reviewedContentVersion: number | null, reviewStatus: Types.PeerReviewStatus | null, reviewType: Types.PeerReviewType, candidatePathId: string | null, reviewerAlias: string, workSummaryId: string | null } | null };

export type UpdatePeerReviewMutationVariables = Types.Exact<{
  input: Types.UpdatePeerReviewInput;
  condition?: Types.InputMaybe<Types.ModelPeerReviewConditionInput>;
}>;


export type UpdatePeerReviewMutation = { updatePeerReview: { __typename: 'PeerReview', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, content: string | null, requiredBy: string, reviewedContentVersion: number | null, reviewStatus: Types.PeerReviewStatus | null, reviewType: Types.PeerReviewType, candidatePathId: string | null, reviewerAlias: string, workSummaryId: string | null } | null };

export type DeletePeerReviewMutationVariables = Types.Exact<{
  input: Types.DeletePeerReviewInput;
  condition?: Types.InputMaybe<Types.ModelPeerReviewConditionInput>;
}>;


export type DeletePeerReviewMutation = { deletePeerReview: { __typename: 'PeerReview', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, content: string | null, requiredBy: string, reviewedContentVersion: number | null, reviewStatus: Types.PeerReviewStatus | null, reviewType: Types.PeerReviewType, candidatePathId: string | null, reviewerAlias: string, workSummaryId: string | null } | null };

export type CreateWorkSummaryMutationVariables = Types.Exact<{
  input: Types.CreateWorkSummaryInput;
  condition?: Types.InputMaybe<Types.ModelWorkSummaryConditionInput>;
}>;


export type CreateWorkSummaryMutation = { createWorkSummary: { __typename: 'WorkSummary', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, alias: string, candidatePathId: string | null, categoryIds: Array<string> | null, content: string, contentVersion: number | null, leadershipPrinciples: Array<string> | null, status: Types.WorkSummaryStatus | null, statusReason: Types.WorkSummaryStatusReason | null, submittedAt: string | null, title: string, type: Types.WorkSummaryType } | null };

export type UpdateWorkSummaryMutationVariables = Types.Exact<{
  input: Types.UpdateWorkSummaryInput;
  condition?: Types.InputMaybe<Types.ModelWorkSummaryConditionInput>;
}>;


export type UpdateWorkSummaryMutation = { updateWorkSummary: { __typename: 'WorkSummary', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, alias: string, candidatePathId: string | null, categoryIds: Array<string> | null, content: string, contentVersion: number | null, leadershipPrinciples: Array<string> | null, status: Types.WorkSummaryStatus | null, statusReason: Types.WorkSummaryStatusReason | null, submittedAt: string | null, title: string, type: Types.WorkSummaryType } | null };

export type DeleteWorkSummaryMutationVariables = Types.Exact<{
  input: Types.DeleteWorkSummaryInput;
  condition?: Types.InputMaybe<Types.ModelWorkSummaryConditionInput>;
}>;


export type DeleteWorkSummaryMutation = { deleteWorkSummary: { __typename: 'WorkSummary', createdAt: string, id: string, owner: string | null, coOwners: Array<string> | null, updatedAt: string, alias: string, candidatePathId: string | null, categoryIds: Array<string> | null, content: string, contentVersion: number | null, leadershipPrinciples: Array<string> | null, status: Types.WorkSummaryStatus | null, statusReason: Types.WorkSummaryStatusReason | null, submittedAt: string | null, title: string, type: Types.WorkSummaryType } | null };

export type CreateQuestionBankTeamMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankTeamInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankTeamConditionInput>;
}>;


export type CreateQuestionBankTeamMutation = { createQuestionBankTeam: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string, categories: { __typename: 'ModelQuestionBankCategoryConnection', nextToken: string | null } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, interviewerRoles: { __typename: 'ModelQuestionBankInterviewerRoleConnection', nextToken: string | null } | null, jobRoles: { __typename: 'ModelQuestionBankJobRoleConnection', nextToken: string | null } | null, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null } | null };

export type UpdateQuestionBankTeamMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankTeamInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankTeamConditionInput>;
}>;


export type UpdateQuestionBankTeamMutation = { updateQuestionBankTeam: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string, categories: { __typename: 'ModelQuestionBankCategoryConnection', nextToken: string | null } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, interviewerRoles: { __typename: 'ModelQuestionBankInterviewerRoleConnection', nextToken: string | null } | null, jobRoles: { __typename: 'ModelQuestionBankJobRoleConnection', nextToken: string | null } | null, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null } | null };

export type DeleteQuestionBankTeamMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankTeamInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankTeamConditionInput>;
}>;


export type DeleteQuestionBankTeamMutation = { deleteQuestionBankTeam: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string, categories: { __typename: 'ModelQuestionBankCategoryConnection', nextToken: string | null } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, interviewerRoles: { __typename: 'ModelQuestionBankInterviewerRoleConnection', nextToken: string | null } | null, jobRoles: { __typename: 'ModelQuestionBankJobRoleConnection', nextToken: string | null } | null, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null } | null };

export type CreateQuestionBankCategoryMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankCategoryInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankCategoryConditionInput>;
}>;


export type CreateQuestionBankCategoryMutation = { createQuestionBankCategory: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankCategoryMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankCategoryInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankCategoryConditionInput>;
}>;


export type UpdateQuestionBankCategoryMutation = { updateQuestionBankCategory: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankCategoryMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankCategoryInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankCategoryConditionInput>;
}>;


export type DeleteQuestionBankCategoryMutation = { deleteQuestionBankCategory: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, questions: { __typename: 'ModelQuestionBankQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateQuestionBankJobRoleMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankJobRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankJobRoleConditionInput>;
}>;


export type CreateQuestionBankJobRoleMutation = { createQuestionBankJobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankJobRoleMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankJobRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankJobRoleConditionInput>;
}>;


export type UpdateQuestionBankJobRoleMutation = { updateQuestionBankJobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankJobRoleMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankJobRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankJobRoleConditionInput>;
}>;


export type DeleteQuestionBankJobRoleMutation = { deleteQuestionBankJobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateQuestionBankInterviewerRoleMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankInterviewerRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewerRoleConditionInput>;
}>;


export type CreateQuestionBankInterviewerRoleMutation = { createQuestionBankInterviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankInterviewerRoleMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankInterviewerRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewerRoleConditionInput>;
}>;


export type UpdateQuestionBankInterviewerRoleMutation = { updateQuestionBankInterviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankInterviewerRoleMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankInterviewerRoleInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewerRoleConditionInput>;
}>;


export type DeleteQuestionBankInterviewerRoleMutation = { deleteQuestionBankInterviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateQuestionBankQuestionMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankQuestionConditionInput>;
}>;


export type CreateQuestionBankQuestionMutation = { createQuestionBankQuestion: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string, category: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankQuestionMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankQuestionConditionInput>;
}>;


export type UpdateQuestionBankQuestionMutation = { updateQuestionBankQuestion: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string, category: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankQuestionMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankQuestionConditionInput>;
}>;


export type DeleteQuestionBankQuestionMutation = { deleteQuestionBankQuestion: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string, category: { __typename: 'QuestionBankCategory', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, interviewTemplates: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateQuestionBankInterviewTemplateQuestionMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankInterviewTemplateQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateQuestionConditionInput>;
}>;


export type CreateQuestionBankInterviewTemplateQuestionMutation = { createQuestionBankInterviewTemplateQuestion: { __typename: 'QuestionBankInterviewTemplateQuestion', group: string, interviewTemplateID: string, questionID: string, createdAt: string, updatedAt: string, interviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string } | null, question: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankInterviewTemplateQuestionMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankInterviewTemplateQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateQuestionConditionInput>;
}>;


export type UpdateQuestionBankInterviewTemplateQuestionMutation = { updateQuestionBankInterviewTemplateQuestion: { __typename: 'QuestionBankInterviewTemplateQuestion', group: string, interviewTemplateID: string, questionID: string, createdAt: string, updatedAt: string, interviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string } | null, question: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankInterviewTemplateQuestionMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankInterviewTemplateQuestionInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateQuestionConditionInput>;
}>;


export type DeleteQuestionBankInterviewTemplateQuestionMutation = { deleteQuestionBankInterviewTemplateQuestion: { __typename: 'QuestionBankInterviewTemplateQuestion', group: string, interviewTemplateID: string, questionID: string, createdAt: string, updatedAt: string, interviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string } | null, question: { __typename: 'QuestionBankQuestion', group: string, id: string, categoryID: string, name: string, description: string | null, status: Types.QuestionStatus, shareability: Types.QuestionShareability, teamID: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateQuestionBankInterviewTemplateMutationVariables = Types.Exact<{
  input: Types.CreateQuestionBankInterviewTemplateInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateConditionInput>;
}>;


export type CreateQuestionBankInterviewTemplateMutation = { createQuestionBankInterviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string, interviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, jobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, questions: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type UpdateQuestionBankInterviewTemplateMutationVariables = Types.Exact<{
  input: Types.UpdateQuestionBankInterviewTemplateInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateConditionInput>;
}>;


export type UpdateQuestionBankInterviewTemplateMutation = { updateQuestionBankInterviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string, interviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, jobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, questions: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type DeleteQuestionBankInterviewTemplateMutationVariables = Types.Exact<{
  input: Types.DeleteQuestionBankInterviewTemplateInput;
  condition?: Types.InputMaybe<Types.ModelQuestionBankInterviewTemplateConditionInput>;
}>;


export type DeleteQuestionBankInterviewTemplateMutation = { deleteQuestionBankInterviewTemplate: { __typename: 'QuestionBankInterviewTemplate', group: string, id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string, interviewerRole: { __typename: 'QuestionBankInterviewerRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, jobRole: { __typename: 'QuestionBankJobRole', group: string, id: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string } | null, questions: { __typename: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null } | null, team: { __typename: 'QuestionBankTeam', group: string, id: string, name: string, createdAt: string, updatedAt: string } | null } | null };

export type CreateOrgRoleLdapGroupsMutationVariables = Types.Exact<{
  input: Types.CreateOrgRoleLdapGroupsInput;
  condition?: Types.InputMaybe<Types.ModelOrgRoleLdapGroupsConditionInput>;
}>;


export type CreateOrgRoleLdapGroupsMutation = { createOrgRoleLDAPGroups: { __typename: 'OrgRoleLDAPGroups', id: string, group: string, orgID: string, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateOrgRoleLdapGroupsMutationVariables = Types.Exact<{
  input: Types.UpdateOrgRoleLdapGroupsInput;
  condition?: Types.InputMaybe<Types.ModelOrgRoleLdapGroupsConditionInput>;
}>;


export type UpdateOrgRoleLdapGroupsMutation = { updateOrgRoleLDAPGroups: { __typename: 'OrgRoleLDAPGroups', id: string, group: string, orgID: string, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteOrgRoleLdapGroupsMutationVariables = Types.Exact<{
  input: Types.DeleteOrgRoleLdapGroupsInput;
  condition?: Types.InputMaybe<Types.ModelOrgRoleLdapGroupsConditionInput>;
}>;


export type DeleteOrgRoleLdapGroupsMutation = { deleteOrgRoleLDAPGroups: { __typename: 'OrgRoleLDAPGroups', id: string, group: string, orgID: string, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateRolePermissionGroupMutationVariables = Types.Exact<{
  input: Types.CreateRolePermissionGroupInput;
  condition?: Types.InputMaybe<Types.ModelRolePermissionGroupConditionInput>;
}>;


export type CreateRolePermissionGroupMutation = { createRolePermissionGroup: { __typename: 'RolePermissionGroup', id: string, app: Types.ElevateApps, displayName: string | null, teamId: string, orgID: string | null, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateRolePermissionGroupMutationVariables = Types.Exact<{
  input: Types.UpdateRolePermissionGroupInput;
  condition?: Types.InputMaybe<Types.ModelRolePermissionGroupConditionInput>;
}>;


export type UpdateRolePermissionGroupMutation = { updateRolePermissionGroup: { __typename: 'RolePermissionGroup', id: string, app: Types.ElevateApps, displayName: string | null, teamId: string, orgID: string | null, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteRolePermissionGroupMutationVariables = Types.Exact<{
  input: Types.DeleteRolePermissionGroupInput;
  condition?: Types.InputMaybe<Types.ModelRolePermissionGroupConditionInput>;
}>;


export type DeleteRolePermissionGroupMutation = { deleteRolePermissionGroup: { __typename: 'RolePermissionGroup', id: string, app: Types.ElevateApps, displayName: string | null, teamId: string, orgID: string | null, role: Types.Roles, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateRoutingAttemptMutationVariables = Types.Exact<{
  input: Types.CreateRoutingAttemptInput;
  condition?: Types.InputMaybe<Types.ModelRoutingAttemptConditionInput>;
}>;


export type CreateRoutingAttemptMutation = { createRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, normalizedPushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null } | null };

export type UpdateRoutingAttemptMutationVariables = Types.Exact<{
  input: Types.UpdateRoutingAttemptInput;
  condition?: Types.InputMaybe<Types.ModelRoutingAttemptConditionInput>;
}>;


export type UpdateRoutingAttemptMutation = { updateRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, normalizedPushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null } | null };

export type DeleteRoutingAttemptMutationVariables = Types.Exact<{
  input: Types.DeleteRoutingAttemptInput;
  condition?: Types.InputMaybe<Types.ModelRoutingAttemptConditionInput>;
}>;


export type DeleteRoutingAttemptMutation = { deleteRoutingAttempt: { __typename: 'RoutingAttempt', id: string, loopEventID: string | null, phoneScreenID: string | null, participantConfigID: string | null, isBarRaiser: boolean | null, profileID: string, role: Types.InterviewerRole, startDateTime: string | null, endDateTime: string | null, lastModifiedBy: string | null, state: Types.RoutingState, meetingsentryID: string | null, schedule: string | null, scheduleTime: string | null, createdAt: string, updatedAt: string, loopEvent: { __typename: 'LoopEvent', id: string, honeycode_uid: number | null, lastModifiedBy: string | null, eventConfigID: string | null, locked: boolean | null, lockChangedAt: string | null, lockedbyID: string | null, maxcandidates: number | null, orgID: string, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, eventleadID: string, recruitingPOCID: string, barRaiserID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, debriefbooked: string | null, debriefNote: string | null, debriefmeetingentryIDs: Array<string | null> | null, prebriefbooked: string | null, prebriefNote: string | null, prebriefmeetingentryIDs: Array<string | null> | null, location: string | null, virtualevent: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, eventType: Types.EventType | null, createdAt: string, updatedAt: string } | null, phoneScreen: { __typename: 'PhoneScreen', id: string, lastModifiedBy: string | null, eventConfigID: string | null, eventType: Types.EventType | null, locked: boolean | null, orgID: string, restrictedevent: boolean | null, status: Types.EventStatus | null, taglist: Array<string> | null, designatedRCID: string, availabilityID: string | null, calendarplaceholdersent: boolean | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, createdAt: string, updatedAt: string } | null, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, pushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null, normalizedPushRoutingWeight: { __typename: 'EventRecommendationWeight', timeSinceLastInterview: number | null, timeZoneMatch: number | null, diversityInterviewer: number | null, languageMatch: number | null, pendingRoutingAttempt: number | null, shadowCompletion: number | null, orgCollaborationInbound: number | null, randomness: number | null } | null } | null };

export type CreateShepherdProfileMutationVariables = Types.Exact<{
  input: Types.CreateShepherdProfileInput;
  condition?: Types.InputMaybe<Types.ModelShepherdProfileConditionInput>;
}>;


export type CreateShepherdProfileMutation = { createShepherdProfile: { __typename: 'ShepherdProfile', assignedAt: string, group: string, profileId: string, shepherdId: string, isOrgDefault: boolean | null, lastModifiedBy: string | null, priority: number | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, shepherd: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateShepherdProfileMutationVariables = Types.Exact<{
  input: Types.UpdateShepherdProfileInput;
  condition?: Types.InputMaybe<Types.ModelShepherdProfileConditionInput>;
}>;


export type UpdateShepherdProfileMutation = { updateShepherdProfile: { __typename: 'ShepherdProfile', assignedAt: string, group: string, profileId: string, shepherdId: string, isOrgDefault: boolean | null, lastModifiedBy: string | null, priority: number | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, shepherd: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteShepherdProfileMutationVariables = Types.Exact<{
  input: Types.DeleteShepherdProfileInput;
  condition?: Types.InputMaybe<Types.ModelShepherdProfileConditionInput>;
}>;


export type DeleteShepherdProfileMutation = { deleteShepherdProfile: { __typename: 'ShepherdProfile', assignedAt: string, group: string, profileId: string, shepherdId: string, isOrgDefault: boolean | null, lastModifiedBy: string | null, priority: number | null, createdAt: string, updatedAt: string, profile: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null, shepherd: { __typename: 'Profile', id: string, activeOrg: string | null, alias: string, learnUserId: string | null, identityId: string | null, status: Types.ProfileStatus | null, brStatus: Types.BarRaiserStatus | null, br: boolean | null, brit: boolean | null, city: string | null, email: string | null, firstName: string | null, hireDate: string | null, ismanager: boolean | null, lastName: string | null, level: number | null, name: string | null, site: string | null, title: string | null, manager: string | null, l2manager: string | null, l3manager: string | null, brInterest: boolean | null, diversityInterviewer: boolean | null, loopInterest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, notifyWeeklyDigest: boolean | null, phoneScreenInterest: boolean | null, preferredTimezoneId: string | null, lastRefreshedDate: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateTrainingMutationVariables = Types.Exact<{
  input: Types.CreateTrainingInput;
  condition?: Types.InputMaybe<Types.ModelTrainingConditionInput>;
}>;


export type CreateTrainingMutation = { createTraining: { __typename: 'Training', group: string, id: string, trainingId: string, calibrationIds: Array<string> | null, isActive: boolean | null, isManaged: boolean | null, isRequiredForloop: boolean | null, isRequiredForPhoneScreen: boolean | null, link: string, minAcceptedVersion: string | null, title: string, trainingVersion: string | null, orgId: string, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type UpdateTrainingMutationVariables = Types.Exact<{
  input: Types.UpdateTrainingInput;
  condition?: Types.InputMaybe<Types.ModelTrainingConditionInput>;
}>;


export type UpdateTrainingMutation = { updateTraining: { __typename: 'Training', group: string, id: string, trainingId: string, calibrationIds: Array<string> | null, isActive: boolean | null, isManaged: boolean | null, isRequiredForloop: boolean | null, isRequiredForPhoneScreen: boolean | null, link: string, minAcceptedVersion: string | null, title: string, trainingVersion: string | null, orgId: string, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type DeleteTrainingMutationVariables = Types.Exact<{
  input: Types.DeleteTrainingInput;
  condition?: Types.InputMaybe<Types.ModelTrainingConditionInput>;
}>;


export type DeleteTrainingMutation = { deleteTraining: { __typename: 'Training', group: string, id: string, trainingId: string, calibrationIds: Array<string> | null, isActive: boolean | null, isManaged: boolean | null, isRequiredForloop: boolean | null, isRequiredForPhoneScreen: boolean | null, link: string, minAcceptedVersion: string | null, title: string, trainingVersion: string | null, orgId: string, createdAt: string, updatedAt: string, org: { __typename: 'Organization', id: string, group: string, name: string, description: string | null, geoarea: string | null, georegion: string | null, status: Types.OrganizationStatus | null, availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, orgQuipFolderID: string | null, apssTeamId: string | null, alwaysRestrictLeadSignups: boolean | null, alwaysRestrictShadowSignups: boolean | null, createdAt: string, updatedAt: string } | null } | null };

export type ListAnnouncementsByOrganizationQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.ModelAnnouncementFilterInput>;
}>;


export type ListAnnouncementsByOrganizationQuery = { listAnnouncementsByOrganization: { __typename?: 'ModelAnnouncementConnection', items: Array<{ __typename?: 'Announcement', id: string, title: string, text: string, status: Types.AnnouncementStatus, createdAt: string, updatedAt: string }> } | null };

export type GetAuditTrailsByProfileQueryVariables = Types.Exact<{
  profileID: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.ModelAuditTrailsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAuditTrailsByProfileQuery = { listAuditTrailsByProfile: { __typename?: 'ModelAuditTrailsConnection', nextToken: string | null, items: Array<{ __typename?: 'AuditTrails', changeJustification: string | null, createdAt: string, humanReadableLog: Array<string> | null, id: string, modifiedBy: string | null, recordType: Types.AuditTrailRecordType | null }> } | null };

export type ListAuditTrailsByEventIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.ModelAuditTrailsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListAuditTrailsByEventIdQuery = { listAuditTrailsByEventId: { __typename?: 'ModelAuditTrailsConnection', nextToken: string | null, items: Array<{ __typename?: 'AuditTrails', changeJustification: string | null, createdAt: string, humanReadableLog: Array<string> | null, id: string, modifiedBy: string | null, recordType: Types.AuditTrailRecordType | null }> } | null };

export type ListOrgProfileShepherdsQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.ModelProfileOrganizationV2FilterInput>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListOrgProfileShepherdsQuery = { listProfilesByOrgV2: { __typename?: 'ModelProfileOrganizationV2Connection', nextToken: string | null, items: Array<{ __typename?: 'ProfileOrganizationV2', profile: { __typename?: 'Profile', alias: string, email: string | null, id: string, l2manager: string | null, level: number | null, manager: string | null, name: string | null, status: Types.ProfileStatus | null, title: string | null, shepherds: { __typename?: 'ModelShepherdProfileConnection', items: Array<{ __typename?: 'ShepherdProfile', shepherd: { __typename?: 'Profile', alias: string, email: string | null, id: string, name: string | null, title: string | null } | null }> } | null } | null }> } | null };

export type ListProfilesByShepherdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListProfilesByShepherdQuery = { getProfile: { __typename?: 'Profile', cohortMembers: { __typename?: 'ModelShepherdProfileConnection', nextToken: string | null, items: Array<{ __typename?: 'ShepherdProfile', profile: { __typename?: 'Profile', alias: string, brStatus: Types.BarRaiserStatus | null, email: string | null, id: string, l2manager: string | null, learnUserId: string | null, level: number | null, manager: string | null, name: string | null, preferredTimezoneId: string | null, title: string | null, status: Types.ProfileStatus | null, updatedAt: string, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null, orgs: { __typename?: 'ModelProfileOrganizationV2Connection', items: Array<{ __typename?: 'ProfileOrganizationV2', orgID: string }> } | null } | null }> } | null } | null };

export type CanManageShepherdProfileQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  profileId: Types.Scalars['ID']['input'];
}>;


export type CanManageShepherdProfileQuery = { canManageShepherdProfile: boolean };

export type ListShepherdProfileNotesQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID']['input'];
  profileId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListShepherdProfileNotesQuery = { listShepherdProfileNotes: { __typename?: 'ShepherdProfileNoteConnection', nextToken: string | null, items: Array<{ __typename?: 'ShepherdProfileNote', commentType: Types.CommentType, content: string, createdAt: string, id: string, interviewerID: string | null, loopEventID: string | null, phoneScreenID: string | null, rating: number | null, restricted: boolean | null, updatedAt: string, interviewer: { __typename?: 'ShepherdProfileNoteInterviewer', id: string, isBarRaiserInterviewer: boolean | null, interviewerRole: Types.InterviewerRole, participantConfig: { __typename?: 'ShepherdProfileNoteParticipantConfig', id: string, name: string } | null } | null, loopEvent: { __typename?: 'ShepherdProfileNoteEvent', date: string | null, eventstarttime: string | null, id: string, orgID: string } | null, phoneScreen: { __typename?: 'ShepherdProfileNoteEvent', date: string | null, eventstarttime: string | null, id: string, orgID: string } | null, profile: { __typename?: 'ShepherdProfileNoteAuthor', alias: string, email: string | null, id: string, name: string | null, title: string | null } }> } };

export type FeedbackByLoopEventAndAuthorQueryVariables = Types.Exact<{
  profileID: Types.Scalars['ID']['input'];
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  phoneScreenID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  commentFilter?: Types.InputMaybe<Types.ModelCommentFilterInput>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FeedbackByLoopEventAndAuthorQuery = { getProfile: { __typename?: 'Profile', alias: string, email: string | null, id: string, name: string | null, title: string | null, comments: { __typename?: 'ModelCommentConnection', nextToken: string | null, items: Array<{ __typename?: 'Comment', id: string, content: string, rating: number | null, interviewerID: string | null, restricted: boolean | null, createdAt: string, updatedAt: string }> } | null } | null };

export type ListFeedbackForProfileQueryVariables = Types.Exact<{
  interviewerProfileID: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.ModelCommentFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListFeedbackForProfileQuery = { listFeedbackForProfile: { __typename?: 'ModelCommentConnection', nextToken: string | null, items: Array<{ __typename?: 'Comment', commentType: Types.CommentType, content: string, createdAt: string, id: string, interviewerID: string | null, loopEventID: string | null, phoneScreenID: string | null, rating: number | null, restricted: boolean | null, updatedAt: string, interviewer: { __typename?: 'Interviewer', id: string, isBarRaiserInterviewer: boolean | null, interviewerRole: Types.InterviewerRole, participantConfig: { __typename?: 'OrgLoopPSConfigurations', description: string, id: string, name: string } | null } | null, loopEvent: { __typename?: 'LoopEvent', date: string | null, eventstarttime: string | null, id: string, orgID: string } | null, phoneScreen: { __typename?: 'PhoneScreen', date: string | null, eventstarttime: string | null, id: string, orgID: string } | null, profile: { __typename?: 'Profile', alias: string, email: string | null, id: string, name: string | null, title: string | null } | null }> } | null };

export type GetInterviewerProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetInterviewerProfileQuery = { getInterviewer: { __typename?: 'Interviewer', id: string, isBarRaiserInterviewer: boolean | null, loopEventID: string | null, participantConfigID: string | null, phoneScreenID: string | null, sourceOrgID: string | null, interviewerRole: Types.InterviewerRole, profile: { __typename?: 'Profile', alias: string, id: string, name: string | null } | null } | null };

export type LoopEventTemplatesByOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LoopEventTemplatesByOrgQuery = { getOrganization: { __typename?: 'Organization', loopEvents: { __typename?: 'ModelLoopEventConnection', nextToken: string | null, items: Array<{ __typename?: 'LoopEvent', orgID: string, date: string | null, id: string, is_template: boolean | null, template_name: string | null, template_description: string | null, eventleadID: string, designatedRCID: string, recruitingPOCID: string }> } | null } | null };

export type GetLoopEventsByInterviewerProfileQueryVariables = Types.Exact<{
  profileID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetLoopEventsByInterviewerProfileQuery = { listInterviewersByProfile: { __typename?: 'ModelInterviewerConnection', nextToken: string | null, items: Array<{ __typename?: 'Interviewer', loopEvent: { __typename?: 'LoopEvent', id: string, maxcandidates: number | null, taglist: Array<string> | null, status: Types.EventStatus | null, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, location: string | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, virtualevent: boolean | null, createdAt: string, orgID: string, locked: boolean | null, updatedAt: string, lockedby: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventlead: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, recruitingPOC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, updatedAt: string, createdAt: string, isActive: boolean | null, orgID: string, isPushRouting: boolean | null, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string }> } | null } | null, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, interviewerRole: Types.InterviewerRole, participantConfigID: string | null, isBarRaiserInterviewer: boolean | null, startDateTime: string | null, endDateTime: string | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null } | null }> } | null };

export type GetOrgLoopEventsQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  statusDate?: Types.InputMaybe<Types.ModelLoopEventByOrgStatusDateCompositeKeyConditionInput>;
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  loopsFilter?: Types.InputMaybe<Types.ModelLoopEventFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrgLoopEventsQuery = { getOrganization: { __typename?: 'Organization', id: string, name: string, loopEvents: { __typename?: 'ModelLoopEventConnection', nextToken: string | null, items: Array<{ __typename?: 'LoopEvent', id: string, maxcandidates: number | null, taglist: Array<string> | null, status: Types.EventStatus | null, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, location: string | null, date: string | null, eventstarttime: string | null, eventendtime: string | null, virtualevent: boolean | null, createdAt: string, orgID: string, locked: boolean | null, updatedAt: string, lockedby: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventlead: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, recruitingPOC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, createdAt: string, updatedAt: string, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, isActive: boolean | null, isPushRouting: boolean | null, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string }> } | null } | null, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, interviewerRole: Types.InterviewerRole, participantConfigID: string | null, isBarRaiserInterviewer: boolean | null, startDateTime: string | null, endDateTime: string | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null, routingHistory: { __typename?: 'ModelRoutingAttemptConnection', items: Array<{ __typename?: 'RoutingAttempt', createdAt: string, id: string, endDateTime: string | null, role: Types.InterviewerRole, participantConfigID: string | null, scheduleTime: string | null, startDateTime: string | null, state: Types.RoutingState, isBarRaiser: boolean | null, updatedAt: string, profile: { __typename?: 'Profile', alias: string, email: string | null, id: string, name: string | null, title: string | null } | null }> } | null }> } | null } | null };

export type GetCommentsByLoopEventQueryVariables = Types.Exact<{
  loopEventId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCommentsByLoopEventQuery = { getLoopEvent: { __typename?: 'LoopEvent', comments: { __typename?: 'ModelCommentConnection', nextToken: string | null, items: Array<{ __typename?: 'Comment', id: string, content: string, restricted: boolean | null, loopEventID: string | null, createdAt: string, updatedAt: string, profile: { __typename?: 'Profile', id: string, alias: string, email: string | null, name: string | null, title: string | null } | null }> } | null } | null };

export type GetLoopConfigsByOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsFilterInput>;
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetLoopConfigsByOrgQuery = { listConfigsByOrgType: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, isPushRouting: boolean | null, description: string, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, createdAt: string, updatedAt: string }> } | null }> } | null };

export type GetLoopEventConfigDefinitionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetLoopEventConfigDefinitionQuery = { getOrgLoopPSConfigurations: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, group: string, isActive: boolean | null, isPushRouting: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type GetLoopEventQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetLoopEventQuery = { getLoopEvent: { __typename?: 'LoopEvent', id: string, date: string | null, eventstarttime: string | null, eventendtime: string | null, status: Types.EventStatus | null, locked: boolean | null, prebriefbooked: string | null, prebriefNote: string | null, debriefbooked: string | null, debriefNote: string | null, calendarplaceholdersent: boolean | null, virtualevent: boolean | null, restrictedLeadSignup: boolean | null, restrictedShadowSignup: boolean | null, prebriefBookingEnabled: boolean | null, is_template: boolean | null, template_name: string | null, template_description: string | null, template_creator_alias: string | null, source_template_id: string | null, taglist: Array<string> | null, maxcandidates: number | null, orgID: string, location: string | null, createdAt: string, updatedAt: string, eventlead: { __typename?: 'Profile', id: string, alias: string, name: string | null, email: string | null, br: boolean | null } | null, lockedby: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, recruitingPOC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, interviewerRole: Types.InterviewerRole, isBarRaiserInterviewer: boolean | null, sendCalendarInvite: boolean | null, participantConfigID: string | null, startDateTime: string | null, endDateTime: string | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, isPushRouting: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, breakDuration: number | null, maxShadowParticipants: number | null, participantConfigIDs: Array<string> | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, candidateLevels: Array<number> | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, createdAt: string, updatedAt: string } | null }> } | null } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null, routingHistory: { __typename?: 'ModelRoutingAttemptConnection', items: Array<{ __typename?: 'RoutingAttempt', createdAt: string, endDateTime: string | null, id: string, isBarRaiser: boolean | null, participantConfigID: string | null, role: Types.InterviewerRole, scheduleTime: string | null, startDateTime: string | null, state: Types.RoutingState, updatedAt: string, profile: { __typename?: 'Profile', alias: string, id: string, name: string | null, email: string | null, title: string | null } | null }> } | null } | null };

export type GetInterviewersByLoopEventQueryVariables = Types.Exact<{
  eventID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelInterviewerFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetInterviewersByLoopEventQuery = { getLoopEvent: { __typename?: 'LoopEvent', interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, profileID: string, participantConfigID: string | null, interviewerRole: Types.InterviewerRole, createdAt: string, updatedAt: string }> } | null } | null };

export type ListLanguagesByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID']['input'];
}>;


export type ListLanguagesByEventQuery = { listLanguages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', id: string, isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null };

export type ListOrganizationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ModelOrganizationFilterInput>;
  collaborationsFilter?: Types.InputMaybe<Types.ModelOrgCollaborationsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListOrganizationsQuery = { listOrganizations: { __typename?: 'ModelOrganizationConnection', nextToken: string | null, items: Array<{ __typename?: 'Organization', id: string, name: string, description: string | null, createdAt: string, updatedAt: string, status: Types.OrganizationStatus | null, orgCollaborationsOutbound: { __typename?: 'ModelOrgCollaborationsConnection', items: Array<{ __typename?: 'OrgCollaborations', id: string }> } | null, orgCollaborationsInbound: { __typename?: 'ModelOrgCollaborationsConnection', items: Array<{ __typename?: 'OrgCollaborations', id: string }> } | null }> } | null };

export type ListOrganizationsSimpleQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ModelOrganizationFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListOrganizationsSimpleQuery = { listOrganizations: { __typename?: 'ModelOrganizationConnection', nextToken: string | null, items: Array<{ __typename?: 'Organization', id: string, name: string, description: string | null, createdAt: string, updatedAt: string, status: Types.OrganizationStatus | null }> } | null };

export type GetOrganizationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { getOrganization: { __typename?: 'Organization', availabilityMinDaysOut: number | null, shadowMinDaysOut: number | null, loopQuipID: string | null, loopsExportedAt: string | null, phoneScreenQuipID: string | null, phoneScreensExportedAt: string | null, advancedSettings: { __typename?: 'OrgFeatureFlags', enableLoopQuipExport: boolean | null, enablePhoneScreenQuipExport: boolean | null, enablePushRouting: boolean | null, enablePromoHub: boolean | null } | null } | null };

export type GetAllOrgEventParticipantConfigsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllOrgEventParticipantConfigsQuery = { getOrganization: { __typename?: 'Organization', id: string, loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type GetOrgEventParticipantConfigsByTypeQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  configType?: Types.InputMaybe<Types.ModelStringKeyConditionInput>;
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrgEventParticipantConfigsByTypeQuery = { listConfigsByOrgType: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', configType: Types.OrgConfigDefinitionType, createdAt: string, description: string, id: string, isActive: boolean | null, orgID: string, name: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, createdAt: string, updatedAt: string } | null, competencies: Array<{ __typename?: 'CompetencyPair', level: number | null, competency: { __typename?: 'Competency', name: string | null, description: string | null } | null } | null> | null }> } | null };

export type GetOrgEventCalibrationConfigsByTypeQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  configType?: Types.InputMaybe<Types.ModelStringKeyConditionInput>;
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrgEventCalibrationConfigsByTypeQuery = { listConfigsByOrgType: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, minIndependent: number | null, createdAt: string, updatedAt: string }> } | null };

export type GetCalibrationDefinitionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCalibrationDefinitionQuery = { getOrgLoopPSConfigurations: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, minIndependent: number | null, createdAt: string, updatedAt: string } | null };

export type GetActiveOrgEventCalibrationConfigsQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetActiveOrgEventCalibrationConfigsQuery = { getOrganization: { __typename?: 'Organization', loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, minIndependent: number | null, createdAt: string, updatedAt: string }> } | null } | null };

export type GetAllOrgCollaborationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetAllOrgCollaborationsQuery = { getOrganization: { __typename?: 'Organization', id: string, orgCollaborationsOutbound: { __typename?: 'ModelOrgCollaborationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgCollaborations', id: string, isActive: boolean | null, isPendingAuthorization: boolean | null, targetOrgID: string | null, barRaisers: boolean | null, pendingChangeSpec: string | null, createdAt: string, updatedAt: string, sharedLoopParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, originParticipants: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, calibrationConfigID: string | null }> } | null, targetParticipants: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, calibrationConfigID: string | null }> } | null }> } | null, orgCollaborationsInbound: { __typename?: 'ModelOrgCollaborationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgCollaborations', id: string, isActive: boolean | null, isPendingAuthorization: boolean | null, originatingOrgID: string | null, barRaisers: boolean | null, pendingChangeSpec: string | null, createdAt: string, updatedAt: string, sharedLoopParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, originParticipants: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, calibrationConfigID: string | null }> } | null, targetParticipants: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, calibrationConfigID: string | null }> } | null }> } | null } | null };

export type GetOrgCompetenciesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetOrgCompetenciesQuery = { getOrganization: { __typename?: 'Organization', competencies: Array<{ __typename?: 'Competency', name: string | null, description: string | null } | null> | null } | null };

export type GetOrgOutboundCollaborationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  loopPSConfigsLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetOrgOutboundCollaborationsQuery = { getOrganization: { __typename?: 'Organization', id: string, name: string, description: string | null, loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string }> } | null, orgCollaborationsOutbound: { __typename?: 'ModelOrgCollaborationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgCollaborations', id: string, isActive: boolean | null, isPendingAuthorization: boolean | null, barRaisers: boolean | null, pendingChangeSpec: string | null, createdAt: string, updatedAt: string, targetOrg: { __typename?: 'Organization', id: string, name: string, description: string | null, georegion: string | null, geoarea: string | null, createdAt: string, updatedAt: string, loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string }> } | null } | null, sharedLoopParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null }> } | null } | null };

export type GetOrgInboundCollaborationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  loopPSConfigsLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetOrgInboundCollaborationsQuery = { getOrganization: { __typename?: 'Organization', id: string, name: string, description: string | null, loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string }> } | null, orgCollaborationsInbound: { __typename?: 'ModelOrgCollaborationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgCollaborations', id: string, isActive: boolean | null, isPendingAuthorization: boolean | null, barRaisers: boolean | null, pendingChangeSpec: string | null, createdAt: string, updatedAt: string, originatingOrg: { __typename?: 'Organization', id: string, name: string, description: string | null, georegion: string | null, geoarea: string | null, createdAt: string, updatedAt: string, loopPSConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, configType: Types.OrgConfigDefinitionType, isActive: boolean | null, name: string, description: string }> } | null } | null, sharedLoopParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null, sharedPSParticipants: Array<{ __typename?: 'SharedParticipantDefinition', originParticipantId: string, targetParticipantId: string, mode: Types.EventParticipantMode | null }> | null }> } | null } | null };

export type GetOrgRoleLdapGroupsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  roleLDAPGroupsFilter?: Types.InputMaybe<Types.ModelOrgRoleLdapGroupsFilterInput>;
}>;


export type GetOrgRoleLdapGroupsQuery = { getOrganization: { __typename?: 'Organization', id: string, roleLDAPGroups: { __typename?: 'ModelOrgRoleLDAPGroupsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgRoleLDAPGroups', id: string, role: Types.Roles, group: string }> } | null } | null };

export type GetOrgRoleGroupsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  roleGroupsFilter?: Types.InputMaybe<Types.ModelRolePermissionGroupFilterInput>;
}>;


export type GetOrgRoleGroupsQuery = { getOrganization: { __typename?: 'Organization', id: string, roleGroups: { __typename?: 'ModelRolePermissionGroupConnection', nextToken: string | null, items: Array<{ __typename?: 'RolePermissionGroup', app: Types.ElevateApps, id: string, role: Types.Roles, teamId: string }> } | null } | null };

export type ListOrgTrainingsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  trainingFilter?: Types.InputMaybe<Types.ModelTrainingFilterInput>;
}>;


export type ListOrgTrainingsQuery = { getOrganization: { __typename?: 'Organization', id: string, name: string, trainings: { __typename?: 'ModelTrainingConnection', nextToken: string | null, items: Array<{ __typename?: 'Training', calibrationIds: Array<string> | null, createdAt: string, id: string, isActive: boolean | null, isManaged: boolean | null, link: string, minAcceptedVersion: string | null, title: string, trainingId: string, trainingVersion: string | null, isRequiredForloop: boolean | null, isRequiredForPhoneScreen: boolean | null, updatedAt: string }> } | null } | null };

export type GetOrgDefaultCalibrationShepherdDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetOrgDefaultCalibrationShepherdDetailsQuery = { getOrganization: { __typename?: 'Organization', calibrationShepherdMode: Types.OrgCalibrationShepherdMode | null, defaultCalibrationShepherd: string | null } | null };

export type GetOrgEventTagsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetOrgEventTagsQuery = { getOrganization: { __typename?: 'Organization', eventTags: Array<{ __typename?: 'TagDefinition', group: string | null, value: string }> | null } | null };

export type GetPhoneScreensbyOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  statusDate?: Types.InputMaybe<Types.ModelPhoneScreenByOrgStatusDateCompositeKeyConditionInput>;
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  phoneScreensFilter?: Types.InputMaybe<Types.ModelPhoneScreenFilterInput>;
  interviewersFilter?: Types.InputMaybe<Types.ModelInterviewerFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPhoneScreensbyOrgQuery = { getOrganization: { __typename?: 'Organization', id: string, name: string, phoneScreens: { __typename?: 'ModelPhoneScreenConnection', nextToken: string | null, items: Array<{ __typename?: 'PhoneScreen', id: string, date: string | null, createdAt: string, updatedAt: string, eventendtime: string | null, eventstarttime: string | null, designatedRCID: string, orgID: string, status: Types.EventStatus | null, locked: boolean | null, availabilityID: string | null, restrictedevent: boolean | null, taglist: Array<string> | null, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, createdAt: string, updatedAt: string, isActive: boolean | null, orgID: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string }> } | null } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, startDateTime: string | null, endDateTime: string | null, interviewerRole: Types.InterviewerRole, participantConfigID: string | null, isBarRaiserInterviewer: boolean | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null }> } | null } | null };

export type GetPhoneScreensByInterviewerProfileQueryVariables = Types.Exact<{
  profileID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPhoneScreensByInterviewerProfileQuery = { listInterviewersByProfile: { __typename?: 'ModelInterviewerConnection', nextToken: string | null, items: Array<{ __typename?: 'Interviewer', phoneScreen: { __typename?: 'PhoneScreen', id: string, date: string | null, createdAt: string, updatedAt: string, eventendtime: string | null, eventstarttime: string | null, designatedRCID: string, restrictedevent: boolean | null, orgID: string, status: Types.EventStatus | null, locked: boolean | null, availabilityID: string | null, taglist: Array<string> | null, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, createdAt: string, updatedAt: string, isActive: boolean | null, orgID: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string }> } | null } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, interviewerRole: Types.InterviewerRole, participantConfigID: string | null, isBarRaiserInterviewer: boolean | null, startDateTime: string | null, endDateTime: string | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null } | null }> } | null };

export type GetOrgPhoneScreenDurationConfigsQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrgPhoneScreenDurationConfigsQuery = { listConfigsByOrgType: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, duration: number | null }> } | null };

export type GetPhoneScreenConfigsByOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelOrgLoopPsConfigurationsFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPhoneScreenConfigsByOrgQuery = { listConfigsByOrgType: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', nextToken: string | null, items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, isPushRouting: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, createdAt: string, updatedAt: string }> } | null }> } | null };

export type GetOrgLoopPsConfigurationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetOrgLoopPsConfigurationsQuery = { getOrgLoopPSConfigurations: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, group: string, isActive: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, isPushRouting: boolean | null, participantConfigIDs: Array<string> | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, maxShadowPoolSize: number | null, minShadows: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, minIndependent: number | null, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type ListProfileAvailabilityByOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListProfileAvailabilityByOrgQuery = { listProfilesByOrgV2: { __typename?: 'ModelProfileOrganizationV2Connection', nextToken: string | null, items: Array<{ __typename?: 'ProfileOrganizationV2', profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, email: string | null, level: number | null, preferredTimezoneId: string | null, status: Types.ProfileStatus | null, title: string | null, availabilities: { __typename?: 'ModelProfileAvailabilityConnection', items: Array<{ __typename?: 'ProfileAvailability', availabilityClose: string, availabilityDate: string, availabilityOpen: string, availabilitySeriesID: string | null, createdAt: string, expired: boolean | null, hireurl: string | null, id: string, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, requester: string | null, rrule: string | null, sendCalendarInvite: boolean | null, state: Types.AvailabilityState, updatedAt: string }> } | null, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null } | null }> } | null };

export type GetProfileAvailabilityQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProfileAvailabilityQuery = { getProfileAvailability: { __typename?: 'ProfileAvailability', id: string, requester: string | null, hireurl: string | null, state: Types.AvailabilityState, sendCalendarInvite: boolean | null, expired: boolean | null, availabilitySeriesID: string | null, availabilityDate: string, recurringEndDate: string | null, availabilityOpen: string, availabilityClose: string, recursion: Types.RecursionInterval | null, rrule: string | null, createdAt: string, updatedAt: string, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, email: string | null, level: number | null, preferredTimezoneId: string | null, title: string | null, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null } | null } | null };

export type GetInterviewersByPhoneScreenQueryVariables = Types.Exact<{
  eventID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelInterviewerFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetInterviewersByPhoneScreenQuery = { getPhoneScreen: { __typename?: 'PhoneScreen', interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, profileID: string, participantConfigID: string | null, interviewerRole: Types.InterviewerRole, createdAt: string, updatedAt: string }> } | null } | null };

export type GetPhoneScreenQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetPhoneScreenQuery = { getPhoneScreen: { __typename?: 'PhoneScreen', availabilityID: string | null, id: string, orgID: string, date: string | null, eventstarttime: string | null, eventendtime: string | null, status: Types.EventStatus | null, locked: boolean | null, designatedRCID: string, restrictedevent: boolean | null, taglist: Array<string> | null, createdAt: string, updatedAt: string, candidates: { __typename?: 'ModelCandidateConnection', items: Array<{ __typename?: 'Candidate', city: string | null, hireurl: string | null, id: string, level: number | null, name: string }> } | null, comments: { __typename?: 'ModelCommentConnection', items: Array<{ __typename?: 'Comment', id: string }> } | null, designatedRC: { __typename?: 'Profile', id: string, alias: string, name: string | null } | null, interviewers: { __typename?: 'ModelInterviewerConnection', items: Array<{ __typename?: 'Interviewer', id: string, startDateTime: string | null, endDateTime: string | null, interviewerRole: Types.InterviewerRole, isBarRaiserInterviewer: boolean | null, sendCalendarInvite: boolean | null, participantConfigID: string | null, sourceOrgID: string | null, profile: { __typename?: 'Profile', id: string, alias: string, name: string | null, preferredTimezoneId: string | null, title: string | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null } | null }> } | null, eventConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, brMode: Types.LoopConfigBrMode | null, candidateLevels: Array<number> | null, name: string, description: string, duration: number | null, participantConfigIDs: Array<string> | null, createdAt: string, updatedAt: string, participantConfigs: { __typename?: 'ModelOrgLoopPSConfigurationsConnection', items: Array<{ __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, name: string, description: string, calibrationConfigID: string | null, createdAt: string, updatedAt: string, calibrationConfig: { __typename?: 'OrgLoopPSConfigurations', id: string, orgID: string, configType: Types.OrgConfigDefinitionType, group: string, isActive: boolean | null, candidateLevels: Array<number> | null, name: string, description: string, maxShadowPoolSize: number | null, minIndependent: number | null, minShadows: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, createdAt: string, updatedAt: string } | null }> } | null } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', isoCode: string, readingRequired: boolean | null, speakingRequired: boolean | null, writingRequired: boolean | null }> } | null } | null };

export type GetCommentsByPhoneScreenQueryVariables = Types.Exact<{
  phoneScreenId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCommentsByPhoneScreenQuery = { getPhoneScreen: { __typename?: 'PhoneScreen', comments: { __typename?: 'ModelCommentConnection', nextToken: string | null, items: Array<{ __typename?: 'Comment', id: string, content: string, restricted: boolean | null, loopEventID: string | null, createdAt: string, updatedAt: string, profile: { __typename?: 'Profile', id: string, alias: string, email: string | null, name: string | null, title: string | null } | null }> } | null } | null };

export type ProfileCalibrationsByConfigQueryVariables = Types.Exact<{
  calibrationId: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelProfileCalibrationFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ProfileCalibrationsByConfigQuery = { getOrgLoopPSConfigurations: { __typename?: 'OrgLoopPSConfigurations', calibrations: { __typename?: 'ModelProfileCalibrationConnection', nextToken: string | null, items: Array<{ __typename?: 'ProfileCalibration', createdAt: string, status: Types.CalibrationStatus, updatedAt: string, profile: { __typename?: 'Profile', activeOrg: string | null, alias: string, createdAt: string, email: string | null, id: string, level: number | null, manager: string | null, name: string | null, preferredTimezoneId: string | null, status: Types.ProfileStatus | null, title: string | null, updatedAt: string } | null }> } | null, org: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type GetProfilePreferencesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProfilePreferencesQuery = { getProfile: { __typename?: 'Profile', id: string, alias: string, name: string | null, email: string | null, level: number | null, br: boolean | null, brit: boolean | null, status: Types.ProfileStatus | null, loopInterest: boolean | null, phoneScreenInterest: boolean | null, brInterest: boolean | null, diversityInterviewer: boolean | null, notifyWeeklyDigest: boolean | null, notifyLoopOpportunity: boolean | null, notifyPhoneScreenOpportunity: boolean | null, preferredTimezoneId: string | null, activeOrg: string | null, createdAt: string, updatedAt: string } | null };

export type ListProfileAvailabilitiesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ListProfileAvailabilitiesQuery = { getProfile: { __typename?: 'Profile', alias: string, brStatus: Types.BarRaiserStatus | null, email: string | null, id: string, status: Types.ProfileStatus | null, level: number | null, manager: string | null, name: string | null, preferredTimezoneId: string | null, availabilities: { __typename?: 'ModelProfileAvailabilityConnection', nextToken: string | null, items: Array<{ __typename?: 'ProfileAvailability', availabilityClose: string, availabilityDate: string, availabilityOpen: string, availabilitySeriesID: string | null, createdAt: string, id: string, recurringEndDate: string | null, recursion: Types.RecursionInterval | null, rrule: string | null, sendCalendarInvite: boolean | null, state: Types.AvailabilityState, updatedAt: string }> } | null, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus, updatedAt: string, calibration: { __typename?: 'OrgLoopPSConfigurations', configType: Types.OrgConfigDefinitionType, id: string, orgID: string } | null }> } | null } | null };

export type GetProfileOrganizationV2QueryVariables = Types.Exact<{
  profileID: Types.Scalars['ID']['input'];
  orgID: Types.Scalars['ID']['input'];
}>;


export type GetProfileOrganizationV2Query = { getProfileOrganizationV2: { __typename?: 'ProfileOrganizationV2', profileID: string, orgID: string, role: Array<Types.Roles> | null } | null };

export type GetProfilesByOrgAndRoleQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelProfileOrganizationV2FilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProfilesByOrgAndRoleQuery = { listProfilesByOrgV2: { __typename?: 'ModelProfileOrganizationV2Connection', nextToken: string | null, items: Array<{ __typename?: 'ProfileOrganizationV2', profileID: string, orgID: string, role: Array<Types.Roles> | null, createdAt: string, updatedAt: string, organization: { __typename?: 'Organization', name: string } | null, profile: { __typename?: 'Profile', alias: string, createdAt: string, email: string | null, id: string, l2manager: string | null, level: number | null, manager: string | null, name: string | null, learnUserId: string | null, preferredTimezoneId: string | null, status: Types.ProfileStatus | null, title: string | null, updatedAt: string } | null }> } | null };

export type ListProfilesByManagerQueryVariables = Types.Exact<{
  managerAlias: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.ModelProfileFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListProfilesByManagerQuery = { listProfilesByManager: { __typename?: 'ModelProfileConnection', nextToken: string | null, items: Array<{ __typename?: 'Profile', id: string, alias: string, brStatus: Types.BarRaiserStatus | null, learnUserId: string | null, email: string | null, level: number | null, manager: string | null, l2manager: string | null, name: string | null, status: Types.ProfileStatus | null, title: string | null, updatedAt: string, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null }> } | null };

export type GetProfilesByOrgQueryVariables = Types.Exact<{
  orgID: Types.Scalars['ID']['input'];
  sortDirection?: Types.InputMaybe<Types.ModelSortDirection>;
  filter?: Types.InputMaybe<Types.ModelProfileOrganizationV2FilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProfilesByOrgQuery = { listProfilesByOrgV2: { __typename?: 'ModelProfileOrganizationV2Connection', nextToken: string | null, items: Array<{ __typename?: 'ProfileOrganizationV2', profile: { __typename?: 'Profile', id: string, alias: string, brStatus: Types.BarRaiserStatus | null, name: string | null, level: number | null, manager: string | null, l2manager: string | null, title: string | null, email: string | null, status: Types.ProfileStatus | null, learnUserId: string | null, preferredTimezoneId: string | null, updatedAt: string, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null } | null }> } | null };

export type GetProfileCalibrationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  calibrationsFilter?: Types.InputMaybe<Types.ModelProfileCalibrationFilterInput>;
}>;


export type GetProfileCalibrationsQuery = { getProfile: { __typename?: 'Profile', id: string, alias: string, name: string | null, level: number | null, br: boolean | null, brit: boolean | null, createdAt: string, updatedAt: string, calibrations: { __typename?: 'ModelProfileCalibrationConnection', nextToken: string | null, items: Array<{ __typename?: 'ProfileCalibration', calibratedAt: string | null, calibrationId: string, changeJustification: string | null, independentCount: number | null, lastModifiedBy: string | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus, calibration: { __typename?: 'OrgLoopPSConfigurations', configType: Types.OrgConfigDefinitionType, description: string, id: string, isActive: boolean | null, maxShadowPoolSize: number | null, minIndependent: number | null, minReverseShadows: number | null, minShepherdReviews: number | null, minShadows: number | null, name: string, orgID: string } | null }> } | null } | null };

export type GetProfileDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProfileDetailQuery = { getProfile: { __typename?: 'Profile', id: string, activeOrg: string | null, alias: string, brStatus: Types.BarRaiserStatus | null, city: string | null, email: string | null, hireDate: string | null, learnUserId: string | null, level: number | null, manager: string | null, l2manager: string | null, name: string | null, preferredTimezoneId: string | null, status: Types.ProfileStatus | null, title: string | null, updatedAt: string, shepherds: { __typename?: 'ModelShepherdProfileConnection', items: Array<{ __typename?: 'ShepherdProfile', lastModifiedBy: string | null, isOrgDefault: boolean | null, createdAt: string, updatedAt: string, shepherd: { __typename?: 'Profile', id: string, alias: string, name: string | null, email: string | null, level: number | null, title: string | null } | null }> } | null, languages: { __typename?: 'ModelLanguageConnection', items: Array<{ __typename?: 'Language', id: string, isoCode: string, reading: Types.LanguageProficiency | null, speaking: Types.LanguageProficiency | null, writing: Types.LanguageProficiency | null }> } | null, orgs: { __typename?: 'ModelProfileOrganizationV2Connection', items: Array<{ __typename?: 'ProfileOrganizationV2', orgID: string }> } | null } | null };

export type GetPeopleProfileQueryVariables = Types.Exact<{
  alias: Types.Scalars['String']['input'];
}>;


export type GetPeopleProfileQuery = { getPeopleProfile: { __typename?: 'PeopleProfile', alias: string, brit: boolean, isBarRaiser: boolean } | null };

export type GetCalibrationCohortQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCalibrationCohortQuery = { getOrgLoopPSConfigurations: { __typename?: 'OrgLoopPSConfigurations', calibrations: { __typename?: 'ModelProfileCalibrationConnection', nextToken: string | null, items: Array<{ __typename?: 'ProfileCalibration', profileId: string }> } | null } | null };

export type GetProfileClassicQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProfileClassicQuery = { getProfile: { __typename?: 'Profile', id: string, activeOrg: string | null, alias: string, name: string | null, title: string | null, email: string | null, level: number | null, br: boolean | null, brit: boolean | null, learnUserId: string | null, manager: string | null, preferredTimezoneId: string | null, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null, orgs: { __typename?: 'ModelProfileOrganizationV2Connection', items: Array<{ __typename?: 'ProfileOrganizationV2', organization: { __typename?: 'Organization', name: string, id: string, status: Types.OrganizationStatus | null, roleLDAPGroups: { __typename?: 'ModelOrgRoleLDAPGroupsConnection', items: Array<{ __typename?: 'OrgRoleLDAPGroups', group: string, role: Types.Roles }> } | null } | null }> } | null } | null };

export type GetProfilePlatformQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProfilePlatformQuery = { getProfile: { __typename?: 'Profile', id: string, activeOrg: string | null, alias: string, name: string | null, title: string | null, email: string | null, learnUserId: string | null, level: number | null, br: boolean | null, brit: boolean | null, manager: string | null, preferredTimezoneId: string | null, calibrations: { __typename?: 'ModelProfileCalibrationConnection', items: Array<{ __typename?: 'ProfileCalibration', calibrationId: string, independentCount: number | null, reverseShadowCount: number | null, reviewCount: number | null, shadowCount: number | null, status: Types.CalibrationStatus }> } | null, orgs: { __typename?: 'ModelProfileOrganizationV2Connection', items: Array<{ __typename?: 'ProfileOrganizationV2', organization: { __typename?: 'Organization', name: string, id: string, status: Types.OrganizationStatus | null, roleGroups: { __typename?: 'ModelRolePermissionGroupConnection', items: Array<{ __typename?: 'RolePermissionGroup', app: Types.ElevateApps, teamId: string, role: Types.Roles }> } | null } | null }> } | null } | null };

export type ListprofilesByBrStatusQueryVariables = Types.Exact<{
  brStatus: Types.BarRaiserStatus;
  brOrgFilter?: Types.InputMaybe<Types.ModelProfileOrganizationV2FilterInput>;
  filter?: Types.InputMaybe<Types.ModelProfileFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListprofilesByBrStatusQuery = { listProfilesByBrStatus: { __typename?: 'ModelProfileConnection', nextToken: string | null, items: Array<{ __typename?: 'Profile', activeOrg: string | null, alias: string, createdAt: string, email: string | null, id: string, level: number | null, manager: string | null, name: string | null, preferredTimezoneId: string | null, status: Types.ProfileStatus | null, title: string | null, updatedAt: string, orgs: { __typename?: 'ModelProfileOrganizationV2Connection', items: Array<{ __typename?: 'ProfileOrganizationV2', orgID: string }> } | null }> } | null };

export type LookupProfileByAliasQueryVariables = Types.Exact<{
  alias: Types.Scalars['String']['input'];
}>;


export type LookupProfileByAliasQuery = { findProfileByAlias: { __typename?: 'ModelProfileConnection', items: Array<{ __typename?: 'Profile', id: string, preferredTimezoneId: string | null }> } | null };

export type GetQuestionBankTeamQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetQuestionBankTeamQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null };

export type ListQuestionBankTeamsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankTeamsQuery = { listQuestionBankTeams: { __typename?: 'ModelQuestionBankTeamConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string }> } | null };

export type ListQuestionBankTeamCategoriesQueryVariables = Types.Exact<{
  teamID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankTeamCategoriesQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', categories: { __typename?: 'ModelQuestionBankCategoryConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankCategory', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type ListQuestionBankTeamJobRolesQueryVariables = Types.Exact<{
  teamID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankTeamJobRolesQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', jobRoles: { __typename?: 'ModelQuestionBankJobRoleConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankJobRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type ListQuestionBankTeamInterviewerRolesQueryVariables = Types.Exact<{
  teamID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankTeamInterviewerRolesQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', interviewerRoles: { __typename?: 'ModelQuestionBankInterviewerRoleConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankInterviewerRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type ListQuestionBankTeamQuestionsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  teamID: Types.Scalars['ID']['input'];
}>;


export type ListQuestionBankTeamQuestionsQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', questions: { __typename?: 'ModelQuestionBankQuestionConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankQuestion', id: string, categoryID: string, status: Types.QuestionStatus, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, shareability: Types.QuestionShareability, category: { __typename?: 'QuestionBankCategory', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null } | null };

export type ListQuestionBankTeamInterviewTemplatesQueryVariables = Types.Exact<{
  teamID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankTeamInterviewTemplatesQuery = { getQuestionBankTeam: { __typename?: 'QuestionBankTeam', interviewTemplates: { __typename?: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankInterviewTemplate', id: string, group: string, name: string, description: string | null, jobLevel: Types.JobLevel, createdAt: string, updatedAt: string, interviewerRole: { __typename?: 'QuestionBankInterviewerRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, jobRole: { __typename?: 'QuestionBankJobRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null }> } | null } | null };

export type ListQuestionBankInterviewTemplatesQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankInterviewTemplatesQuery = { listQuestionBankInterviewTemplates: { __typename?: 'ModelQuestionBankInterviewTemplateConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankInterviewTemplate', id: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRole: { __typename?: 'QuestionBankInterviewerRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, jobRole: { __typename?: 'QuestionBankJobRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null };

export type GetQuestionBankInterviewTemplateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetQuestionBankInterviewTemplateQuery = { getQuestionBankInterviewTemplate: { __typename?: 'QuestionBankInterviewTemplate', id: string, group: string, name: string, description: string | null, jobLevel: Types.JobLevel, interviewerRoleID: string, jobRoleID: string, teamID: string, createdAt: string, updatedAt: string, interviewerRole: { __typename?: 'QuestionBankInterviewerRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, jobRole: { __typename?: 'QuestionBankJobRole', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null, questions: { __typename?: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankInterviewTemplateQuestion', group: string, interviewTemplateID: string, questionID: string, createdAt: string, updatedAt: string }> } | null } | null };

export type GetQuestionBankQuestionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetQuestionBankQuestionQuery = { getQuestionBankQuestion: { __typename?: 'QuestionBankQuestion', id: string, group: string, status: Types.QuestionStatus, name: string, description: string | null, createdAt: string, updatedAt: string, categoryID: string, shareability: Types.QuestionShareability, teamID: string, category: { __typename?: 'QuestionBankCategory', id: string, group: string, name: string, description: string | null, createdAt: string, updatedAt: string, teamID: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null };

export type ListQuestionBankQuestionsByShareabilityQueryVariables = Types.Exact<{
  shareability: Types.QuestionShareability;
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankQuestionsByShareabilityQuery = { listQuestionBankQuestionsByShareability: { __typename?: 'ModelQuestionBankQuestionConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankQuestion', id: string, categoryID: string, status: Types.QuestionStatus, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, shareability: Types.QuestionShareability, category: { __typename?: 'QuestionBankCategory', id: string, group: string, name: string, description: string | null, teamID: string, createdAt: string, updatedAt: string, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null } | null, team: { __typename?: 'QuestionBankTeam', id: string, name: string, group: string, createdAt: string, updatedAt: string } | null }> } | null };

export type ListQuestionBankInterviewTemplateQuestionsQueryVariables = Types.Exact<{
  questionID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankInterviewTemplateQuestionsQuery = { listInterviewTemplatesByQuestion: { __typename?: 'ModelQuestionBankInterviewTemplateQuestionConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankInterviewTemplateQuestion', group: string, interviewTemplateID: string, questionID: string, createdAt: string, updatedAt: string }> } | null };

export type ListQuestionBankQuestionsByCategoryIdQueryVariables = Types.Exact<{
  categoryID: Types.Scalars['ID']['input'];
  nextToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ListQuestionBankQuestionsByCategoryIdQuery = { getQuestionBankCategory: { __typename?: 'QuestionBankCategory', questions: { __typename?: 'ModelQuestionBankQuestionConnection', nextToken: string | null, items: Array<{ __typename?: 'QuestionBankQuestion', id: string, name: string, description: string | null }> } | null } | null };

export type GetLearnTrainingQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetLearnTrainingQuery = { getLearnTraining: { __typename?: 'LearnCatalogTraining', id: string, provider: string | null, status: Types.TrainingStatus, type: Types.TrainingType, versions: Array<{ __typename?: 'LearnCatalogTrainingVersion', createdAt: string, description: string | null, isLatest: boolean, link: string | null, title: string, version: string }> } | null };

export type ListTranscriptsQueryVariables = Types.Exact<{
  learnUserId: Types.Scalars['ID']['input'];
  trainingIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type ListTranscriptsQuery = { listLearnAndManagedTranscripts: Array<{ __typename?: 'Transcript', id: string, completedAt: string | null, failedAt: string | null, status: Types.TranscriptStatus, trainingId: string, trainingVersion: string }> | null };

export type OnLoopCreateRoutingAttemptSubscriptionVariables = Types.Exact<{
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OnLoopCreateRoutingAttemptSubscription = { onCreateRoutingAttempt: { __typename?: 'RoutingAttempt', id: string } | null };

export type OnLoopUpdateRoutingAttemptSubscriptionVariables = Types.Exact<{
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OnLoopUpdateRoutingAttemptSubscription = { onUpdateRoutingAttempt: { __typename?: 'RoutingAttempt', id: string } | null };

export type OnLoopCreateInterviewerSubscriptionVariables = Types.Exact<{
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OnLoopCreateInterviewerSubscription = { onCreateInterviewer: { __typename?: 'Interviewer', id: string } | null };

export type OnLoopUpdateInterviewerSubscriptionVariables = Types.Exact<{
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OnLoopUpdateInterviewerSubscription = { onUpdateInterviewer: { __typename?: 'Interviewer', id: string } | null };

export type OnLoopDeleteInterviewerSubscriptionVariables = Types.Exact<{
  loopEventID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OnLoopDeleteInterviewerSubscription = { onDeleteInterviewer: { __typename?: 'Interviewer', id: string } | null };

export type OnUpdateLoopEventSubscriptionVariables = Types.Exact<{
  loopEventID: Types.Scalars['ID']['input'];
}>;


export type OnUpdateLoopEventSubscription = { onUpdateLoopEvent: { __typename?: 'LoopEvent', id: string } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const UpsertShepherdProfileCalibrationDocument = new TypedDocumentString(`
    mutation UpsertShepherdProfileCalibration($orgId: ID!, $input: ShepherdProfileCalibrationInput!) {
  upsertShepherdProfileCalibration(orgId: $orgId, input: $input)
}
    `) as unknown as TypedDocumentString<UpsertShepherdProfileCalibrationMutation, UpsertShepherdProfileCalibrationMutationVariables>;
export const CreateShepherdProfileNoteDocument = new TypedDocumentString(`
    mutation CreateShepherdProfileNote($orgId: ID!, $input: CreateShepherdProfileNoteInput!) {
  createShepherdProfileNote(orgId: $orgId, input: $input)
}
    `) as unknown as TypedDocumentString<CreateShepherdProfileNoteMutation, CreateShepherdProfileNoteMutationVariables>;
export const RemoveShepherdProfileAssignmentDocument = new TypedDocumentString(`
    mutation RemoveShepherdProfileAssignment($orgId: ID!, $profileId: ID!, $shepherdId: ID!) {
  removeShepherdProfileAssignment(
    orgId: $orgId
    profileId: $profileId
    shepherdId: $shepherdId
  )
}
    `) as unknown as TypedDocumentString<RemoveShepherdProfileAssignmentMutation, RemoveShepherdProfileAssignmentMutationVariables>;
export const CreateOrgBarRaiserDocument = new TypedDocumentString(`
    mutation CreateOrgBarRaiser($alias: String!, $orgId: ID!) {
  createOrgBarRaiser(alias: $alias, orgId: $orgId) {
    alias
    orgId
    profileId
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateOrgBarRaiserMutation, CreateOrgBarRaiserMutationVariables>;
export const DeleteOrgBarRaiserDocument = new TypedDocumentString(`
    mutation DeleteOrgBarRaiser($profileId: ID!, $orgId: ID!) {
  deleteOrgBarRaiser(profileId: $profileId, orgId: $orgId) {
    orgId
    profileId
    roles
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgBarRaiserMutation, DeleteOrgBarRaiserMutationVariables>;
export const CreateElevateProfileDocument = new TypedDocumentString(`
    mutation CreateElevateProfile($alias: String!, $orgId: ID, $isSetTimezoneId: Boolean) {
  createElevateProfile(
    alias: $alias
    orgId: $orgId
    isSetTimezoneId: $isSetTimezoneId
  ) {
    alias
    profileId
    lastRefreshedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateElevateProfileMutation, CreateElevateProfileMutationVariables>;
export const RefreshElevateProfileDocument = new TypedDocumentString(`
    mutation RefreshElevateProfile($alias: String!, $isForceRefresh: Boolean) {
  refreshElevateProfile(alias: $alias, isForceRefresh: $isForceRefresh) {
    lastRefreshedAt
    profileId
    __typename
  }
}
    `) as unknown as TypedDocumentString<RefreshElevateProfileMutation, RefreshElevateProfileMutationVariables>;
export const CreateManagedQuipDocument = new TypedDocumentString(`
    mutation CreateManagedQuip($input: CreateManagedQuipMutationInput!) {
  createManagedQuip(input: $input) {
    quipId
    quipLink
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateManagedQuipMutation, CreateManagedQuipMutationVariables>;
export const DeleteManagedQuipDocument = new TypedDocumentString(`
    mutation DeleteManagedQuip($input: DeleteManagedQuipMutationInput!) {
  deleteManagedQuip(input: $input) {
    quipLink
    success
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteManagedQuipMutation, DeleteManagedQuipMutationVariables>;
export const BackfillManagedTranscriptDocument = new TypedDocumentString(`
    mutation BackfillManagedTranscript($input: BackfillManagedTranscriptMutationInput!) {
  backfillManagedTranscript(input: $input) {
    id
    cancelledAt
    completedAt
    createdAt
    failedAt
    status
    trainingId
    trainingVersion
    userId
    __typename
  }
}
    `) as unknown as TypedDocumentString<BackfillManagedTranscriptMutation, BackfillManagedTranscriptMutationVariables>;
export const RestartPushRoutingDocument = new TypedDocumentString(`
    mutation RestartPushRouting($eventId: ID!, $eventType: EventType!, $forBarRaiser: Boolean) {
  restartPushRouting(
    eventId: $eventId
    eventType: $eventType
    forBarRaiser: $forBarRaiser
  ) {
    eventId
    eventType
    success
    participantType
    message
    __typename
  }
}
    `) as unknown as TypedDocumentString<RestartPushRoutingMutation, RestartPushRoutingMutationVariables>;
export const CreateMeetingDocument = new TypedDocumentString(`
    mutation CreateMeeting($input: CreateMeetingInput!) {
  createMeeting(input: $input) {
    id
    subject
    body
    start
    end
    attendees
    location
    isOnlineMeeting
    meetingLink
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDocument = new TypedDocumentString(`
    mutation UpdateMeeting($input: UpdateMeetingInput!) {
  updateMeeting(input: $input) {
    id
    subject
    body
    start
    end
    attendees
    location
    isOnlineMeeting
    meetingLink
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const DeleteMeetingDocument = new TypedDocumentString(`
    mutation DeleteMeeting($input: DeleteMeetingInput!) {
  deleteMeeting(input: $input)
}
    `) as unknown as TypedDocumentString<DeleteMeetingMutation, DeleteMeetingMutationVariables>;
export const CreateAnnouncementDocument = new TypedDocumentString(`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!, $condition: ModelAnnouncementConditionInput) {
  createAnnouncement(input: $input, condition: $condition) {
    id
    createdAt
    orgId
    group
    viewers
    title
    text
    status
    updatedAt
    owner
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const UpdateAnnouncementDocument = new TypedDocumentString(`
    mutation UpdateAnnouncement($input: UpdateAnnouncementInput!, $condition: ModelAnnouncementConditionInput) {
  updateAnnouncement(input: $input, condition: $condition) {
    id
    createdAt
    orgId
    group
    viewers
    title
    text
    status
    updatedAt
    owner
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = new TypedDocumentString(`
    mutation DeleteAnnouncement($input: DeleteAnnouncementInput!, $condition: ModelAnnouncementConditionInput) {
  deleteAnnouncement(input: $input, condition: $condition) {
    id
    createdAt
    orgId
    group
    viewers
    title
    text
    status
    updatedAt
    owner
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const CreateAuditTrailsDocument = new TypedDocumentString(`
    mutation CreateAuditTrails($input: CreateAuditTrailsInput!, $condition: ModelAuditTrailsConditionInput) {
  createAuditTrails(input: $input, condition: $condition) {
    id
    createdAt
    changeJustification
    humanReadableLog
    modifiedBy
    rawOldRecord
    rawNewRecord
    recordType
    orgID
    profileID
    eventType
    eventId
    candidateId
    interviewerId
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateAuditTrailsMutation, CreateAuditTrailsMutationVariables>;
export const UpdateAuditTrailsDocument = new TypedDocumentString(`
    mutation UpdateAuditTrails($input: UpdateAuditTrailsInput!, $condition: ModelAuditTrailsConditionInput) {
  updateAuditTrails(input: $input, condition: $condition) {
    id
    createdAt
    changeJustification
    humanReadableLog
    modifiedBy
    rawOldRecord
    rawNewRecord
    recordType
    orgID
    profileID
    eventType
    eventId
    candidateId
    interviewerId
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateAuditTrailsMutation, UpdateAuditTrailsMutationVariables>;
export const DeleteAuditTrailsDocument = new TypedDocumentString(`
    mutation DeleteAuditTrails($input: DeleteAuditTrailsInput!, $condition: ModelAuditTrailsConditionInput) {
  deleteAuditTrails(input: $input, condition: $condition) {
    id
    createdAt
    changeJustification
    humanReadableLog
    modifiedBy
    rawOldRecord
    rawNewRecord
    recordType
    orgID
    profileID
    eventType
    eventId
    candidateId
    interviewerId
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteAuditTrailsMutation, DeleteAuditTrailsMutationVariables>;
export const CreateCandidateDocument = new TypedDocumentString(`
    mutation CreateCandidate($input: CreateCandidateInput!, $condition: ModelCandidateConditionInput) {
  createCandidate(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    canManage
    canRead
    city
    country
    decision
    hireurl
    level
    name
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateCandidateMutation, CreateCandidateMutationVariables>;
export const UpdateCandidateDocument = new TypedDocumentString(`
    mutation UpdateCandidate($input: UpdateCandidateInput!, $condition: ModelCandidateConditionInput) {
  updateCandidate(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    canManage
    canRead
    city
    country
    decision
    hireurl
    level
    name
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateCandidateMutation, UpdateCandidateMutationVariables>;
export const DeleteCandidateDocument = new TypedDocumentString(`
    mutation DeleteCandidate($input: DeleteCandidateInput!, $condition: ModelCandidateConditionInput) {
  deleteCandidate(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    canManage
    canRead
    city
    country
    decision
    hireurl
    level
    name
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteCandidateMutation, DeleteCandidateMutationVariables>;
export const CreateCommentDocument = new TypedDocumentString(`
    mutation CreateComment($input: CreateCommentInput!, $condition: ModelCommentConditionInput) {
  createComment(input: $input, condition: $condition) {
    id
    createdAt
    honeycode_uid
    group
    owner
    viewers
    commentType
    content
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    restricted
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    interviewerID
    interviewer {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      profileID
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      phoneScreenID
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      createdAt
      updatedAt
      __typename
    }
    interviewerProfileID
    interviewerAlias
    rating
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateCommentMutation, CreateCommentMutationVariables>;
export const UpdateCommentDocument = new TypedDocumentString(`
    mutation UpdateComment($input: UpdateCommentInput!, $condition: ModelCommentConditionInput) {
  updateComment(input: $input, condition: $condition) {
    id
    createdAt
    honeycode_uid
    group
    owner
    viewers
    commentType
    content
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    restricted
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    interviewerID
    interviewer {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      profileID
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      phoneScreenID
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      createdAt
      updatedAt
      __typename
    }
    interviewerProfileID
    interviewerAlias
    rating
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DeleteCommentDocument = new TypedDocumentString(`
    mutation DeleteComment($input: DeleteCommentInput!, $condition: ModelCommentConditionInput) {
  deleteComment(input: $input, condition: $condition) {
    id
    createdAt
    honeycode_uid
    group
    owner
    viewers
    commentType
    content
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    restricted
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    interviewerID
    interviewer {
      id
      honeycode_uid
      lastModifiedBy
      interviewerRole
      interviewType
      participantConfigID
      profileID
      acceptedAt
      meetingsentryID
      sendCalendarInvite
      startDateTime
      endDateTime
      isBarRaiserInterviewer
      loopEventID
      phoneScreenID
      extLoopEventID
      extPhoneScreenID
      sourceOrgID
      createdAt
      updatedAt
      __typename
    }
    interviewerProfileID
    interviewerAlias
    rating
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CreateInterviewerDocument = new TypedDocumentString(`
    mutation CreateInterviewer($input: CreateInterviewerInput!, $condition: ModelInterviewerConditionInput) {
  createInterviewer(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    interviewerRole
    interviewType
    participantConfigID
    participantConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    acceptedAt
    meetingsentryID
    sendCalendarInvite
    startDateTime
    endDateTime
    isBarRaiserInterviewer
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    extLoopEventID
    extPhoneScreenID
    sourceOrgID
    sourceOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    comments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateInterviewerMutation, CreateInterviewerMutationVariables>;
export const UpdateInterviewerDocument = new TypedDocumentString(`
    mutation UpdateInterviewer($input: UpdateInterviewerInput!, $condition: ModelInterviewerConditionInput) {
  updateInterviewer(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    interviewerRole
    interviewType
    participantConfigID
    participantConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    acceptedAt
    meetingsentryID
    sendCalendarInvite
    startDateTime
    endDateTime
    isBarRaiserInterviewer
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    extLoopEventID
    extPhoneScreenID
    sourceOrgID
    sourceOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    comments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateInterviewerMutation, UpdateInterviewerMutationVariables>;
export const DeleteInterviewerDocument = new TypedDocumentString(`
    mutation DeleteInterviewer($input: DeleteInterviewerInput!, $condition: ModelInterviewerConditionInput) {
  deleteInterviewer(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    interviewerRole
    interviewType
    participantConfigID
    participantConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    acceptedAt
    meetingsentryID
    sendCalendarInvite
    startDateTime
    endDateTime
    isBarRaiserInterviewer
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    extLoopEventID
    extPhoneScreenID
    sourceOrgID
    sourceOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    comments {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteInterviewerMutation, DeleteInterviewerMutationVariables>;
export const CreateLanguageDocument = new TypedDocumentString(`
    mutation CreateLanguage($input: CreateLanguageInput!, $condition: ModelLanguageConditionInput) {
  createLanguage(input: $input, condition: $condition) {
    id
    isoCode
    recordType
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    profileId
    reading
    speaking
    writing
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    loopEventId
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    phoneScreenId
    readingRequired
    speakingRequired
    writingRequired
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateLanguageMutation, CreateLanguageMutationVariables>;
export const UpdateLanguageDocument = new TypedDocumentString(`
    mutation UpdateLanguage($input: UpdateLanguageInput!, $condition: ModelLanguageConditionInput) {
  updateLanguage(input: $input, condition: $condition) {
    id
    isoCode
    recordType
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    profileId
    reading
    speaking
    writing
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    loopEventId
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    phoneScreenId
    readingRequired
    speakingRequired
    writingRequired
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateLanguageMutation, UpdateLanguageMutationVariables>;
export const DeleteLanguageDocument = new TypedDocumentString(`
    mutation DeleteLanguage($input: DeleteLanguageInput!, $condition: ModelLanguageConditionInput) {
  deleteLanguage(input: $input, condition: $condition) {
    id
    isoCode
    recordType
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    profileId
    reading
    speaking
    writing
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    loopEventId
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    phoneScreenId
    readingRequired
    speakingRequired
    writingRequired
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteLanguageMutation, DeleteLanguageMutationVariables>;
export const CreateLoopEventDocument = new TypedDocumentString(`
    mutation CreateLoopEvent($input: CreateLoopEventInput!, $condition: ModelLoopEventConditionInput) {
  createLoopEvent(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    locked
    lockChangedAt
    lockedbyID
    lockedby {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    maxcandidates
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedLeadSignup
    restrictedShadowSignup
    prebriefBookingEnabled
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    eventleadID
    eventlead {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    recruitingPOCID
    recruitingPOC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserID
    barRaiser {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserRoutingAttempt {
      id
      loopEventID
      phoneScreenID
      participantConfigID
      isBarRaiser
      profileID
      role
      startDateTime
      endDateTime
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    debriefbooked
    debriefNote
    debriefmeetingentryIDs
    prebriefbooked
    prebriefNote
    prebriefmeetingentryIDs
    location
    virtualevent
    is_template
    template_name
    template_description
    template_creator_alias
    source_template_id
    eventType
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateLoopEventMutation, CreateLoopEventMutationVariables>;
export const UpdateLoopEventDocument = new TypedDocumentString(`
    mutation UpdateLoopEvent($input: UpdateLoopEventInput!, $condition: ModelLoopEventConditionInput) {
  updateLoopEvent(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    locked
    lockChangedAt
    lockedbyID
    lockedby {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    maxcandidates
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedLeadSignup
    restrictedShadowSignup
    prebriefBookingEnabled
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    eventleadID
    eventlead {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    recruitingPOCID
    recruitingPOC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserID
    barRaiser {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserRoutingAttempt {
      id
      loopEventID
      phoneScreenID
      participantConfigID
      isBarRaiser
      profileID
      role
      startDateTime
      endDateTime
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    debriefbooked
    debriefNote
    debriefmeetingentryIDs
    prebriefbooked
    prebriefNote
    prebriefmeetingentryIDs
    location
    virtualevent
    is_template
    template_name
    template_description
    template_creator_alias
    source_template_id
    eventType
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateLoopEventMutation, UpdateLoopEventMutationVariables>;
export const DeleteLoopEventDocument = new TypedDocumentString(`
    mutation DeleteLoopEvent($input: DeleteLoopEventInput!, $condition: ModelLoopEventConditionInput) {
  deleteLoopEvent(input: $input, condition: $condition) {
    id
    honeycode_uid
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    locked
    lockChangedAt
    lockedbyID
    lockedby {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    maxcandidates
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedLeadSignup
    restrictedShadowSignup
    prebriefBookingEnabled
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    eventleadID
    eventlead {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    recruitingPOCID
    recruitingPOC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserID
    barRaiser {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    barRaiserRoutingAttempt {
      id
      loopEventID
      phoneScreenID
      participantConfigID
      isBarRaiser
      profileID
      role
      startDateTime
      endDateTime
      lastModifiedBy
      state
      meetingsentryID
      schedule
      scheduleTime
      createdAt
      updatedAt
      __typename
    }
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    debriefbooked
    debriefNote
    debriefmeetingentryIDs
    prebriefbooked
    prebriefNote
    prebriefmeetingentryIDs
    location
    virtualevent
    is_template
    template_name
    template_description
    template_creator_alias
    source_template_id
    eventType
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteLoopEventMutation, DeleteLoopEventMutationVariables>;
export const CreateManagedTranscriptDocument = new TypedDocumentString(`
    mutation CreateManagedTranscript($input: CreateManagedTranscriptInput!, $condition: ModelManagedTranscriptConditionInput) {
  createManagedTranscript(input: $input, condition: $condition) {
    completedAt
    failedAt
    learnTrainingId
    learnTrainingVersion
    learnUserId
    status
    trainingId
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateManagedTranscriptMutation, CreateManagedTranscriptMutationVariables>;
export const UpdateManagedTranscriptDocument = new TypedDocumentString(`
    mutation UpdateManagedTranscript($input: UpdateManagedTranscriptInput!, $condition: ModelManagedTranscriptConditionInput) {
  updateManagedTranscript(input: $input, condition: $condition) {
    completedAt
    failedAt
    learnTrainingId
    learnTrainingVersion
    learnUserId
    status
    trainingId
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateManagedTranscriptMutation, UpdateManagedTranscriptMutationVariables>;
export const DeleteManagedTranscriptDocument = new TypedDocumentString(`
    mutation DeleteManagedTranscript($input: DeleteManagedTranscriptInput!, $condition: ModelManagedTranscriptConditionInput) {
  deleteManagedTranscript(input: $input, condition: $condition) {
    completedAt
    failedAt
    learnTrainingId
    learnTrainingVersion
    learnUserId
    status
    trainingId
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteManagedTranscriptMutation, DeleteManagedTranscriptMutationVariables>;
export const CreateOrgCollaborationsDocument = new TypedDocumentString(`
    mutation CreateOrgCollaborations($input: CreateOrgCollaborationsInput!, $condition: ModelOrgCollaborationsConditionInput) {
  createOrgCollaborations(input: $input, condition: $condition) {
    id
    groups
    isActive
    isPendingAuthorization
    pendingChangeSpec
    originatingOrgID
    originatingOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    targetOrgID
    targetOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    barRaisers
    sharedLoopParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    sharedPSParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    originParticipantIDs
    originParticipants {
      nextToken
      __typename
    }
    targetParticipantIDs
    targetParticipants {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateOrgCollaborationsMutation, CreateOrgCollaborationsMutationVariables>;
export const UpdateOrgCollaborationsDocument = new TypedDocumentString(`
    mutation UpdateOrgCollaborations($input: UpdateOrgCollaborationsInput!, $condition: ModelOrgCollaborationsConditionInput) {
  updateOrgCollaborations(input: $input, condition: $condition) {
    id
    groups
    isActive
    isPendingAuthorization
    pendingChangeSpec
    originatingOrgID
    originatingOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    targetOrgID
    targetOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    barRaisers
    sharedLoopParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    sharedPSParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    originParticipantIDs
    originParticipants {
      nextToken
      __typename
    }
    targetParticipantIDs
    targetParticipants {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgCollaborationsMutation, UpdateOrgCollaborationsMutationVariables>;
export const DeleteOrgCollaborationsDocument = new TypedDocumentString(`
    mutation DeleteOrgCollaborations($input: DeleteOrgCollaborationsInput!, $condition: ModelOrgCollaborationsConditionInput) {
  deleteOrgCollaborations(input: $input, condition: $condition) {
    id
    groups
    isActive
    isPendingAuthorization
    pendingChangeSpec
    originatingOrgID
    originatingOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    targetOrgID
    targetOrg {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    barRaisers
    sharedLoopParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    sharedPSParticipants {
      originParticipantId
      targetParticipantId
      mode
      __typename
    }
    originParticipantIDs
    originParticipants {
      nextToken
      __typename
    }
    targetParticipantIDs
    targetParticipants {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgCollaborationsMutation, DeleteOrgCollaborationsMutationVariables>;
export const CreateOrgLoopPsConfigurationsDocument = new TypedDocumentString(`
    mutation CreateOrgLoopPSConfigurations($input: CreateOrgLoopPSConfigurationsInput!, $condition: ModelOrgLoopPSConfigurationsConditionInput) {
  createOrgLoopPSConfigurations(input: $input, condition: $condition) {
    id
    group
    configType
    isActive
    name
    description
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    minShadows
    minIndependent
    minReverseShadows
    minShepherdReviews
    maxShadowPoolSize
    calibrationParticipants {
      nextToken
      __typename
    }
    calibrationConfigID
    calibrationConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    competencies {
      level
      __typename
    }
    isPushRouting
    concurrencyGroup
    brMode
    candidateLevels
    duration
    breakDuration
    maxShadowParticipants
    participantConfigIDs
    participantConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    prebriefRequired
    prebriefInformation
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateOrgLoopPsConfigurationsMutation, CreateOrgLoopPsConfigurationsMutationVariables>;
export const UpdateOrgLoopPsConfigurationsDocument = new TypedDocumentString(`
    mutation UpdateOrgLoopPSConfigurations($input: UpdateOrgLoopPSConfigurationsInput!, $condition: ModelOrgLoopPSConfigurationsConditionInput) {
  updateOrgLoopPSConfigurations(input: $input, condition: $condition) {
    id
    group
    configType
    isActive
    name
    description
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    minShadows
    minIndependent
    minReverseShadows
    minShepherdReviews
    maxShadowPoolSize
    calibrationParticipants {
      nextToken
      __typename
    }
    calibrationConfigID
    calibrationConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    competencies {
      level
      __typename
    }
    isPushRouting
    concurrencyGroup
    brMode
    candidateLevels
    duration
    breakDuration
    maxShadowParticipants
    participantConfigIDs
    participantConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    prebriefRequired
    prebriefInformation
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgLoopPsConfigurationsMutation, UpdateOrgLoopPsConfigurationsMutationVariables>;
export const DeleteOrgLoopPsConfigurationsDocument = new TypedDocumentString(`
    mutation DeleteOrgLoopPSConfigurations($input: DeleteOrgLoopPSConfigurationsInput!, $condition: ModelOrgLoopPSConfigurationsConditionInput) {
  deleteOrgLoopPSConfigurations(input: $input, condition: $condition) {
    id
    group
    configType
    isActive
    name
    description
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    minShadows
    minIndependent
    minReverseShadows
    minShepherdReviews
    maxShadowPoolSize
    calibrationParticipants {
      nextToken
      __typename
    }
    calibrationConfigID
    calibrationConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    competencies {
      level
      __typename
    }
    isPushRouting
    concurrencyGroup
    brMode
    candidateLevels
    duration
    breakDuration
    maxShadowParticipants
    participantConfigIDs
    participantConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    prebriefRequired
    prebriefInformation
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgLoopPsConfigurationsMutation, DeleteOrgLoopPsConfigurationsMutationVariables>;
export const CreateOrganizationDocument = new TypedDocumentString(`
    mutation CreateOrganization($input: CreateOrganizationInput!, $condition: ModelOrganizationConditionInput) {
  createOrganization(input: $input, condition: $condition) {
    id
    group
    name
    description
    geoarea
    georegion
    status
    availabilityMinDaysOut
    shadowMinDaysOut
    eventTags {
      group
      value
      __typename
    }
    orgCollaborationsInbound {
      nextToken
      __typename
    }
    orgCollaborationsOutbound {
      nextToken
      __typename
    }
    loopPSConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    roleLDAPGroups {
      nextToken
      __typename
    }
    roleGroups {
      nextToken
      __typename
    }
    calibrationShepherdMode
    defaultCalibrationShepherd
    trainings {
      nextToken
      __typename
    }
    competencies {
      name
      description
      __typename
    }
    advancedSettings {
      enablePromoHub
      enableApss
      enableInterviewManagement
      enableLoopQuipExport
      enablePhoneScreenQuipExport
      enablePushRouting
      __typename
    }
    loopQuipID
    loopsExportedAt
    phoneScreenQuipID
    phoneScreensExportedAt
    orgQuipFolderID
    apssTeamId
    alwaysRestrictLeadSignups
    alwaysRestrictShadowSignups
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = new TypedDocumentString(`
    mutation UpdateOrganization($input: UpdateOrganizationInput!, $condition: ModelOrganizationConditionInput) {
  updateOrganization(input: $input, condition: $condition) {
    id
    group
    name
    description
    geoarea
    georegion
    status
    availabilityMinDaysOut
    shadowMinDaysOut
    eventTags {
      group
      value
      __typename
    }
    orgCollaborationsInbound {
      nextToken
      __typename
    }
    orgCollaborationsOutbound {
      nextToken
      __typename
    }
    loopPSConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    roleLDAPGroups {
      nextToken
      __typename
    }
    roleGroups {
      nextToken
      __typename
    }
    calibrationShepherdMode
    defaultCalibrationShepherd
    trainings {
      nextToken
      __typename
    }
    competencies {
      name
      description
      __typename
    }
    advancedSettings {
      enablePromoHub
      enableApss
      enableInterviewManagement
      enableLoopQuipExport
      enablePhoneScreenQuipExport
      enablePushRouting
      __typename
    }
    loopQuipID
    loopsExportedAt
    phoneScreenQuipID
    phoneScreensExportedAt
    orgQuipFolderID
    apssTeamId
    alwaysRestrictLeadSignups
    alwaysRestrictShadowSignups
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = new TypedDocumentString(`
    mutation DeleteOrganization($input: DeleteOrganizationInput!, $condition: ModelOrganizationConditionInput) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    group
    name
    description
    geoarea
    georegion
    status
    availabilityMinDaysOut
    shadowMinDaysOut
    eventTags {
      group
      value
      __typename
    }
    orgCollaborationsInbound {
      nextToken
      __typename
    }
    orgCollaborationsOutbound {
      nextToken
      __typename
    }
    loopPSConfigs {
      nextToken
      __typename
    }
    loopEvents {
      nextToken
      __typename
    }
    phoneScreens {
      nextToken
      __typename
    }
    interviews {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    roleLDAPGroups {
      nextToken
      __typename
    }
    roleGroups {
      nextToken
      __typename
    }
    calibrationShepherdMode
    defaultCalibrationShepherd
    trainings {
      nextToken
      __typename
    }
    competencies {
      name
      description
      __typename
    }
    advancedSettings {
      enablePromoHub
      enableApss
      enableInterviewManagement
      enableLoopQuipExport
      enablePhoneScreenQuipExport
      enablePushRouting
      __typename
    }
    loopQuipID
    loopsExportedAt
    phoneScreenQuipID
    phoneScreensExportedAt
    orgQuipFolderID
    apssTeamId
    alwaysRestrictLeadSignups
    alwaysRestrictShadowSignups
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const CreatePhoneScreenDocument = new TypedDocumentString(`
    mutation CreatePhoneScreen($input: CreatePhoneScreenInput!, $condition: ModelPhoneScreenConditionInput) {
  createPhoneScreen(input: $input, condition: $condition) {
    id
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    eventType
    locked
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedevent
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    availabilityID
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreatePhoneScreenMutation, CreatePhoneScreenMutationVariables>;
export const UpdatePhoneScreenDocument = new TypedDocumentString(`
    mutation UpdatePhoneScreen($input: UpdatePhoneScreenInput!, $condition: ModelPhoneScreenConditionInput) {
  updatePhoneScreen(input: $input, condition: $condition) {
    id
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    eventType
    locked
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedevent
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    availabilityID
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdatePhoneScreenMutation, UpdatePhoneScreenMutationVariables>;
export const DeletePhoneScreenDocument = new TypedDocumentString(`
    mutation DeletePhoneScreen($input: DeletePhoneScreenInput!, $condition: ModelPhoneScreenConditionInput) {
  deletePhoneScreen(input: $input, condition: $condition) {
    id
    lastModifiedBy
    eventConfigID
    eventConfig {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    eventType
    locked
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    restrictedevent
    status
    taglist
    designatedRCID
    designatedRC {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    availabilityID
    calendarplaceholdersent
    date
    eventstarttime
    eventendtime
    candidates {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    languages {
      nextToken
      __typename
    }
    routingHistory {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeletePhoneScreenMutation, DeletePhoneScreenMutationVariables>;
export const CreateProfileDocument = new TypedDocumentString(`
    mutation CreateProfile($input: CreateProfileInput!, $condition: ModelProfileConditionInput) {
  createProfile(input: $input, condition: $condition) {
    id
    activeOrg
    alias
    learnUserId
    identityId
    status
    brStatus
    br
    brit
    city
    email
    firstName
    hireDate
    ismanager
    lastName
    level
    name
    site
    title
    manager
    l2manager
    l3manager
    brInterest
    diversityInterviewer
    loopInterest
    notifyLoopOpportunity
    notifyPhoneScreenOpportunity
    notifyWeeklyDigest
    phoneScreenInterest
    preferredTimezoneId
    shepherds {
      nextToken
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    cohortMembers {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    availabilities {
      nextToken
      __typename
    }
    routingAttempts {
      nextToken
      __typename
    }
    designatedRCLoops {
      nextToken
      __typename
    }
    eventLeadLoops {
      nextToken
      __typename
    }
    recruitingPOCLoops {
      nextToken
      __typename
    }
    designatedRCPhoneScreens {
      nextToken
      __typename
    }
    lockedLoops {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    orgs {
      nextToken
      __typename
    }
    lastRefreshedDate
    languages {
      nextToken
      __typename
    }
    barRaiserEvents {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateProfileMutation, CreateProfileMutationVariables>;
export const UpdateProfileDocument = new TypedDocumentString(`
    mutation UpdateProfile($input: UpdateProfileInput!, $condition: ModelProfileConditionInput) {
  updateProfile(input: $input, condition: $condition) {
    id
    activeOrg
    alias
    learnUserId
    identityId
    status
    brStatus
    br
    brit
    city
    email
    firstName
    hireDate
    ismanager
    lastName
    level
    name
    site
    title
    manager
    l2manager
    l3manager
    brInterest
    diversityInterviewer
    loopInterest
    notifyLoopOpportunity
    notifyPhoneScreenOpportunity
    notifyWeeklyDigest
    phoneScreenInterest
    preferredTimezoneId
    shepherds {
      nextToken
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    cohortMembers {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    availabilities {
      nextToken
      __typename
    }
    routingAttempts {
      nextToken
      __typename
    }
    designatedRCLoops {
      nextToken
      __typename
    }
    eventLeadLoops {
      nextToken
      __typename
    }
    recruitingPOCLoops {
      nextToken
      __typename
    }
    designatedRCPhoneScreens {
      nextToken
      __typename
    }
    lockedLoops {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    orgs {
      nextToken
      __typename
    }
    lastRefreshedDate
    languages {
      nextToken
      __typename
    }
    barRaiserEvents {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const DeleteProfileDocument = new TypedDocumentString(`
    mutation DeleteProfile($input: DeleteProfileInput!, $condition: ModelProfileConditionInput) {
  deleteProfile(input: $input, condition: $condition) {
    id
    activeOrg
    alias
    learnUserId
    identityId
    status
    brStatus
    br
    brit
    city
    email
    firstName
    hireDate
    ismanager
    lastName
    level
    name
    site
    title
    manager
    l2manager
    l3manager
    brInterest
    diversityInterviewer
    loopInterest
    notifyLoopOpportunity
    notifyPhoneScreenOpportunity
    notifyWeeklyDigest
    phoneScreenInterest
    preferredTimezoneId
    shepherds {
      nextToken
      __typename
    }
    calibrations {
      nextToken
      __typename
    }
    cohortMembers {
      nextToken
      __typename
    }
    interviewers {
      nextToken
      __typename
    }
    availabilities {
      nextToken
      __typename
    }
    routingAttempts {
      nextToken
      __typename
    }
    designatedRCLoops {
      nextToken
      __typename
    }
    eventLeadLoops {
      nextToken
      __typename
    }
    recruitingPOCLoops {
      nextToken
      __typename
    }
    designatedRCPhoneScreens {
      nextToken
      __typename
    }
    lockedLoops {
      nextToken
      __typename
    }
    comments {
      nextToken
      __typename
    }
    orgs {
      nextToken
      __typename
    }
    lastRefreshedDate
    languages {
      nextToken
      __typename
    }
    barRaiserEvents {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteProfileMutation, DeleteProfileMutationVariables>;
export const CreateProfileAvailabilityDocument = new TypedDocumentString(`
    mutation CreateProfileAvailability($input: CreateProfileAvailabilityInput!, $condition: ModelProfileAvailabilityConditionInput) {
  createProfileAvailability(input: $input, condition: $condition) {
    id
    expired
    hireurl
    orgID
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    requester
    state
    availabilityDate
    availabilityOpen
    availabilityClose
    meetingsentryID
    sendCalendarInvite
    availabilitySeriesID
    availabilitySeries {
      id
      expired
      hireurl
      orgID
      profileID
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      recurringEndDate
      recursion
      rrule
      createdAt
      updatedAt
      __typename
    }
    recurringEndDate
    recursion
    rrule
    occurrences {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateProfileAvailabilityMutation, CreateProfileAvailabilityMutationVariables>;
export const UpdateProfileAvailabilityDocument = new TypedDocumentString(`
    mutation UpdateProfileAvailability($input: UpdateProfileAvailabilityInput!, $condition: ModelProfileAvailabilityConditionInput) {
  updateProfileAvailability(input: $input, condition: $condition) {
    id
    expired
    hireurl
    orgID
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    requester
    state
    availabilityDate
    availabilityOpen
    availabilityClose
    meetingsentryID
    sendCalendarInvite
    availabilitySeriesID
    availabilitySeries {
      id
      expired
      hireurl
      orgID
      profileID
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      recurringEndDate
      recursion
      rrule
      createdAt
      updatedAt
      __typename
    }
    recurringEndDate
    recursion
    rrule
    occurrences {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateProfileAvailabilityMutation, UpdateProfileAvailabilityMutationVariables>;
export const DeleteProfileAvailabilityDocument = new TypedDocumentString(`
    mutation DeleteProfileAvailability($input: DeleteProfileAvailabilityInput!, $condition: ModelProfileAvailabilityConditionInput) {
  deleteProfileAvailability(input: $input, condition: $condition) {
    id
    expired
    hireurl
    orgID
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    requester
    state
    availabilityDate
    availabilityOpen
    availabilityClose
    meetingsentryID
    sendCalendarInvite
    availabilitySeriesID
    availabilitySeries {
      id
      expired
      hireurl
      orgID
      profileID
      requester
      state
      availabilityDate
      availabilityOpen
      availabilityClose
      meetingsentryID
      sendCalendarInvite
      availabilitySeriesID
      recurringEndDate
      recursion
      rrule
      createdAt
      updatedAt
      __typename
    }
    recurringEndDate
    recursion
    rrule
    occurrences {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteProfileAvailabilityMutation, DeleteProfileAvailabilityMutationVariables>;
export const CreateProfileCalibrationDocument = new TypedDocumentString(`
    mutation CreateProfileCalibration($input: CreateProfileCalibrationInput!, $condition: ModelProfileCalibrationConditionInput) {
  createProfileCalibration(input: $input, condition: $condition) {
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    calibrationId
    calibration {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    status
    cohortEnteredAt
    cohortExitedAt
    independentCount
    reverseShadowCount
    reviewCount
    shadowCount
    calibratedAt
    changeJustification
    lastModifiedBy
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateProfileCalibrationMutation, CreateProfileCalibrationMutationVariables>;
export const UpdateProfileCalibrationDocument = new TypedDocumentString(`
    mutation UpdateProfileCalibration($input: UpdateProfileCalibrationInput!, $condition: ModelProfileCalibrationConditionInput) {
  updateProfileCalibration(input: $input, condition: $condition) {
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    calibrationId
    calibration {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    status
    cohortEnteredAt
    cohortExitedAt
    independentCount
    reverseShadowCount
    reviewCount
    shadowCount
    calibratedAt
    changeJustification
    lastModifiedBy
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateProfileCalibrationMutation, UpdateProfileCalibrationMutationVariables>;
export const DeleteProfileCalibrationDocument = new TypedDocumentString(`
    mutation DeleteProfileCalibration($input: DeleteProfileCalibrationInput!, $condition: ModelProfileCalibrationConditionInput) {
  deleteProfileCalibration(input: $input, condition: $condition) {
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    calibrationId
    calibration {
      id
      group
      configType
      isActive
      name
      description
      orgID
      minShadows
      minIndependent
      minReverseShadows
      minShepherdReviews
      maxShadowPoolSize
      calibrationConfigID
      isPushRouting
      concurrencyGroup
      brMode
      candidateLevels
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      prebriefRequired
      prebriefInformation
      createdAt
      updatedAt
      __typename
    }
    status
    cohortEnteredAt
    cohortExitedAt
    independentCount
    reverseShadowCount
    reviewCount
    shadowCount
    calibratedAt
    changeJustification
    lastModifiedBy
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteProfileCalibrationMutation, DeleteProfileCalibrationMutationVariables>;
export const CreateProfileOrganizationV2Document = new TypedDocumentString(`
    mutation CreateProfileOrganizationV2($input: CreateProfileOrganizationV2Input!, $condition: ModelProfileOrganizationV2ConditionInput) {
  createProfileOrganizationV2(input: $input, condition: $condition) {
    profileID
    group
    orgID
    organization {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateProfileOrganizationV2Mutation, CreateProfileOrganizationV2MutationVariables>;
export const UpdateProfileOrganizationV2Document = new TypedDocumentString(`
    mutation UpdateProfileOrganizationV2($input: UpdateProfileOrganizationV2Input!, $condition: ModelProfileOrganizationV2ConditionInput) {
  updateProfileOrganizationV2(input: $input, condition: $condition) {
    profileID
    group
    orgID
    organization {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateProfileOrganizationV2Mutation, UpdateProfileOrganizationV2MutationVariables>;
export const DeleteProfileOrganizationV2Document = new TypedDocumentString(`
    mutation DeleteProfileOrganizationV2($input: DeleteProfileOrganizationV2Input!, $condition: ModelProfileOrganizationV2ConditionInput) {
  deleteProfileOrganizationV2(input: $input, condition: $condition) {
    profileID
    group
    orgID
    organization {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteProfileOrganizationV2Mutation, DeleteProfileOrganizationV2MutationVariables>;
export const CreatePromoPathDocument = new TypedDocumentString(`
    mutation CreatePromoPath($input: CreatePromoPathInput!, $condition: ModelPromoPathConditionInput) {
  createPromoPath(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    allowAttachments
    categoryIds
    name
    pathType
    role
    startLevel
    status
    suggestedLPs
    targetLevel
    candidate
    targetDate
    totalCompleted
    totalRequired
    manager
    templateId
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreatePromoPathMutation, CreatePromoPathMutationVariables>;
export const UpdatePromoPathDocument = new TypedDocumentString(`
    mutation UpdatePromoPath($input: UpdatePromoPathInput!, $condition: ModelPromoPathConditionInput) {
  updatePromoPath(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    allowAttachments
    categoryIds
    name
    pathType
    role
    startLevel
    status
    suggestedLPs
    targetLevel
    candidate
    targetDate
    totalCompleted
    totalRequired
    manager
    templateId
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdatePromoPathMutation, UpdatePromoPathMutationVariables>;
export const DeletePromoPathDocument = new TypedDocumentString(`
    mutation DeletePromoPath($input: DeletePromoPathInput!, $condition: ModelPromoPathConditionInput) {
  deletePromoPath(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    allowAttachments
    categoryIds
    name
    pathType
    role
    startLevel
    status
    suggestedLPs
    targetLevel
    candidate
    targetDate
    totalCompleted
    totalRequired
    manager
    templateId
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeletePromoPathMutation, DeletePromoPathMutationVariables>;
export const CreateCategoryDocument = new TypedDocumentString(`
    mutation CreateCategory($input: CreateCategoryInput!, $condition: ModelCategoryConditionInput) {
  createCategory(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    description
    isDefault
    name
    role
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = new TypedDocumentString(`
    mutation UpdateCategory($input: UpdateCategoryInput!, $condition: ModelCategoryConditionInput) {
  updateCategory(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    description
    isDefault
    name
    role
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = new TypedDocumentString(`
    mutation DeleteCategory($input: DeleteCategoryInput!, $condition: ModelCategoryConditionInput) {
  deleteCategory(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    description
    isDefault
    name
    role
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const CreateFileRecordDocument = new TypedDocumentString(`
    mutation CreateFileRecord($input: CreateFileRecordInput!, $condition: ModelFileRecordConditionInput) {
  createFileRecord(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    fileDateModified
    fileName
    fileSizeBytes
    s3Key
    storageIdKey
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateFileRecordMutation, CreateFileRecordMutationVariables>;
export const UpdateFileRecordDocument = new TypedDocumentString(`
    mutation UpdateFileRecord($input: UpdateFileRecordInput!, $condition: ModelFileRecordConditionInput) {
  updateFileRecord(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    fileDateModified
    fileName
    fileSizeBytes
    s3Key
    storageIdKey
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateFileRecordMutation, UpdateFileRecordMutationVariables>;
export const DeleteFileRecordDocument = new TypedDocumentString(`
    mutation DeleteFileRecord($input: DeleteFileRecordInput!, $condition: ModelFileRecordConditionInput) {
  deleteFileRecord(input: $input, condition: $condition) {
    createdAt
    id
    owner
    updatedAt
    fileDateModified
    fileName
    fileSizeBytes
    s3Key
    storageIdKey
    status
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteFileRecordMutation, DeleteFileRecordMutationVariables>;
export const CreatePeerReviewDocument = new TypedDocumentString(`
    mutation CreatePeerReview($input: CreatePeerReviewInput!, $condition: ModelPeerReviewConditionInput) {
  createPeerReview(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    content
    requiredBy
    reviewedContentVersion
    reviewStatus
    reviewType
    candidatePathId
    reviewerAlias
    workSummaryId
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreatePeerReviewMutation, CreatePeerReviewMutationVariables>;
export const UpdatePeerReviewDocument = new TypedDocumentString(`
    mutation UpdatePeerReview($input: UpdatePeerReviewInput!, $condition: ModelPeerReviewConditionInput) {
  updatePeerReview(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    content
    requiredBy
    reviewedContentVersion
    reviewStatus
    reviewType
    candidatePathId
    reviewerAlias
    workSummaryId
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdatePeerReviewMutation, UpdatePeerReviewMutationVariables>;
export const DeletePeerReviewDocument = new TypedDocumentString(`
    mutation DeletePeerReview($input: DeletePeerReviewInput!, $condition: ModelPeerReviewConditionInput) {
  deletePeerReview(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    content
    requiredBy
    reviewedContentVersion
    reviewStatus
    reviewType
    candidatePathId
    reviewerAlias
    workSummaryId
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeletePeerReviewMutation, DeletePeerReviewMutationVariables>;
export const CreateWorkSummaryDocument = new TypedDocumentString(`
    mutation CreateWorkSummary($input: CreateWorkSummaryInput!, $condition: ModelWorkSummaryConditionInput) {
  createWorkSummary(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    alias
    candidatePathId
    categoryIds
    content
    contentVersion
    leadershipPrinciples
    status
    statusReason
    submittedAt
    title
    type
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateWorkSummaryMutation, CreateWorkSummaryMutationVariables>;
export const UpdateWorkSummaryDocument = new TypedDocumentString(`
    mutation UpdateWorkSummary($input: UpdateWorkSummaryInput!, $condition: ModelWorkSummaryConditionInput) {
  updateWorkSummary(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    alias
    candidatePathId
    categoryIds
    content
    contentVersion
    leadershipPrinciples
    status
    statusReason
    submittedAt
    title
    type
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateWorkSummaryMutation, UpdateWorkSummaryMutationVariables>;
export const DeleteWorkSummaryDocument = new TypedDocumentString(`
    mutation DeleteWorkSummary($input: DeleteWorkSummaryInput!, $condition: ModelWorkSummaryConditionInput) {
  deleteWorkSummary(input: $input, condition: $condition) {
    createdAt
    id
    owner
    coOwners
    updatedAt
    alias
    candidatePathId
    categoryIds
    content
    contentVersion
    leadershipPrinciples
    status
    statusReason
    submittedAt
    title
    type
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteWorkSummaryMutation, DeleteWorkSummaryMutationVariables>;
export const CreateQuestionBankTeamDocument = new TypedDocumentString(`
    mutation CreateQuestionBankTeam($input: CreateQuestionBankTeamInput!, $condition: ModelQuestionBankTeamConditionInput) {
  createQuestionBankTeam(input: $input, condition: $condition) {
    group
    id
    name
    categories {
      nextToken
      __typename
    }
    interviewTemplates {
      nextToken
      __typename
    }
    interviewerRoles {
      nextToken
      __typename
    }
    jobRoles {
      nextToken
      __typename
    }
    questions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankTeamMutation, CreateQuestionBankTeamMutationVariables>;
export const UpdateQuestionBankTeamDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankTeam($input: UpdateQuestionBankTeamInput!, $condition: ModelQuestionBankTeamConditionInput) {
  updateQuestionBankTeam(input: $input, condition: $condition) {
    group
    id
    name
    categories {
      nextToken
      __typename
    }
    interviewTemplates {
      nextToken
      __typename
    }
    interviewerRoles {
      nextToken
      __typename
    }
    jobRoles {
      nextToken
      __typename
    }
    questions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankTeamMutation, UpdateQuestionBankTeamMutationVariables>;
export const DeleteQuestionBankTeamDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankTeam($input: DeleteQuestionBankTeamInput!, $condition: ModelQuestionBankTeamConditionInput) {
  deleteQuestionBankTeam(input: $input, condition: $condition) {
    group
    id
    name
    categories {
      nextToken
      __typename
    }
    interviewTemplates {
      nextToken
      __typename
    }
    interviewerRoles {
      nextToken
      __typename
    }
    jobRoles {
      nextToken
      __typename
    }
    questions {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankTeamMutation, DeleteQuestionBankTeamMutationVariables>;
export const CreateQuestionBankCategoryDocument = new TypedDocumentString(`
    mutation CreateQuestionBankCategory($input: CreateQuestionBankCategoryInput!, $condition: ModelQuestionBankCategoryConditionInput) {
  createQuestionBankCategory(input: $input, condition: $condition) {
    group
    id
    name
    description
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankCategoryMutation, CreateQuestionBankCategoryMutationVariables>;
export const UpdateQuestionBankCategoryDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankCategory($input: UpdateQuestionBankCategoryInput!, $condition: ModelQuestionBankCategoryConditionInput) {
  updateQuestionBankCategory(input: $input, condition: $condition) {
    group
    id
    name
    description
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankCategoryMutation, UpdateQuestionBankCategoryMutationVariables>;
export const DeleteQuestionBankCategoryDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankCategory($input: DeleteQuestionBankCategoryInput!, $condition: ModelQuestionBankCategoryConditionInput) {
  deleteQuestionBankCategory(input: $input, condition: $condition) {
    group
    id
    name
    description
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankCategoryMutation, DeleteQuestionBankCategoryMutationVariables>;
export const CreateQuestionBankJobRoleDocument = new TypedDocumentString(`
    mutation CreateQuestionBankJobRole($input: CreateQuestionBankJobRoleInput!, $condition: ModelQuestionBankJobRoleConditionInput) {
  createQuestionBankJobRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankJobRoleMutation, CreateQuestionBankJobRoleMutationVariables>;
export const UpdateQuestionBankJobRoleDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankJobRole($input: UpdateQuestionBankJobRoleInput!, $condition: ModelQuestionBankJobRoleConditionInput) {
  updateQuestionBankJobRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankJobRoleMutation, UpdateQuestionBankJobRoleMutationVariables>;
export const DeleteQuestionBankJobRoleDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankJobRole($input: DeleteQuestionBankJobRoleInput!, $condition: ModelQuestionBankJobRoleConditionInput) {
  deleteQuestionBankJobRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankJobRoleMutation, DeleteQuestionBankJobRoleMutationVariables>;
export const CreateQuestionBankInterviewerRoleDocument = new TypedDocumentString(`
    mutation CreateQuestionBankInterviewerRole($input: CreateQuestionBankInterviewerRoleInput!, $condition: ModelQuestionBankInterviewerRoleConditionInput) {
  createQuestionBankInterviewerRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankInterviewerRoleMutation, CreateQuestionBankInterviewerRoleMutationVariables>;
export const UpdateQuestionBankInterviewerRoleDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankInterviewerRole($input: UpdateQuestionBankInterviewerRoleInput!, $condition: ModelQuestionBankInterviewerRoleConditionInput) {
  updateQuestionBankInterviewerRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankInterviewerRoleMutation, UpdateQuestionBankInterviewerRoleMutationVariables>;
export const DeleteQuestionBankInterviewerRoleDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankInterviewerRole($input: DeleteQuestionBankInterviewerRoleInput!, $condition: ModelQuestionBankInterviewerRoleConditionInput) {
  deleteQuestionBankInterviewerRole(input: $input, condition: $condition) {
    group
    id
    name
    description
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankInterviewerRoleMutation, DeleteQuestionBankInterviewerRoleMutationVariables>;
export const CreateQuestionBankQuestionDocument = new TypedDocumentString(`
    mutation CreateQuestionBankQuestion($input: CreateQuestionBankQuestionInput!, $condition: ModelQuestionBankQuestionConditionInput) {
  createQuestionBankQuestion(input: $input, condition: $condition) {
    group
    id
    category {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    categoryID
    name
    description
    status
    shareability
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankQuestionMutation, CreateQuestionBankQuestionMutationVariables>;
export const UpdateQuestionBankQuestionDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankQuestion($input: UpdateQuestionBankQuestionInput!, $condition: ModelQuestionBankQuestionConditionInput) {
  updateQuestionBankQuestion(input: $input, condition: $condition) {
    group
    id
    category {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    categoryID
    name
    description
    status
    shareability
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankQuestionMutation, UpdateQuestionBankQuestionMutationVariables>;
export const DeleteQuestionBankQuestionDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankQuestion($input: DeleteQuestionBankQuestionInput!, $condition: ModelQuestionBankQuestionConditionInput) {
  deleteQuestionBankQuestion(input: $input, condition: $condition) {
    group
    id
    category {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    categoryID
    name
    description
    status
    shareability
    interviewTemplates {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankQuestionMutation, DeleteQuestionBankQuestionMutationVariables>;
export const CreateQuestionBankInterviewTemplateQuestionDocument = new TypedDocumentString(`
    mutation CreateQuestionBankInterviewTemplateQuestion($input: CreateQuestionBankInterviewTemplateQuestionInput!, $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput) {
  createQuestionBankInterviewTemplateQuestion(
    input: $input
    condition: $condition
  ) {
    group
    interviewTemplate {
      group
      id
      name
      description
      jobLevel
      interviewerRoleID
      jobRoleID
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewTemplateID
    question {
      group
      id
      categoryID
      name
      description
      status
      shareability
      teamID
      createdAt
      updatedAt
      __typename
    }
    questionID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankInterviewTemplateQuestionMutation, CreateQuestionBankInterviewTemplateQuestionMutationVariables>;
export const UpdateQuestionBankInterviewTemplateQuestionDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankInterviewTemplateQuestion($input: UpdateQuestionBankInterviewTemplateQuestionInput!, $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput) {
  updateQuestionBankInterviewTemplateQuestion(
    input: $input
    condition: $condition
  ) {
    group
    interviewTemplate {
      group
      id
      name
      description
      jobLevel
      interviewerRoleID
      jobRoleID
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewTemplateID
    question {
      group
      id
      categoryID
      name
      description
      status
      shareability
      teamID
      createdAt
      updatedAt
      __typename
    }
    questionID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankInterviewTemplateQuestionMutation, UpdateQuestionBankInterviewTemplateQuestionMutationVariables>;
export const DeleteQuestionBankInterviewTemplateQuestionDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankInterviewTemplateQuestion($input: DeleteQuestionBankInterviewTemplateQuestionInput!, $condition: ModelQuestionBankInterviewTemplateQuestionConditionInput) {
  deleteQuestionBankInterviewTemplateQuestion(
    input: $input
    condition: $condition
  ) {
    group
    interviewTemplate {
      group
      id
      name
      description
      jobLevel
      interviewerRoleID
      jobRoleID
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewTemplateID
    question {
      group
      id
      categoryID
      name
      description
      status
      shareability
      teamID
      createdAt
      updatedAt
      __typename
    }
    questionID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankInterviewTemplateQuestionMutation, DeleteQuestionBankInterviewTemplateQuestionMutationVariables>;
export const CreateQuestionBankInterviewTemplateDocument = new TypedDocumentString(`
    mutation CreateQuestionBankInterviewTemplate($input: CreateQuestionBankInterviewTemplateInput!, $condition: ModelQuestionBankInterviewTemplateConditionInput) {
  createQuestionBankInterviewTemplate(input: $input, condition: $condition) {
    group
    id
    name
    description
    jobLevel
    interviewerRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewerRoleID
    jobRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    jobRoleID
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateQuestionBankInterviewTemplateMutation, CreateQuestionBankInterviewTemplateMutationVariables>;
export const UpdateQuestionBankInterviewTemplateDocument = new TypedDocumentString(`
    mutation UpdateQuestionBankInterviewTemplate($input: UpdateQuestionBankInterviewTemplateInput!, $condition: ModelQuestionBankInterviewTemplateConditionInput) {
  updateQuestionBankInterviewTemplate(input: $input, condition: $condition) {
    group
    id
    name
    description
    jobLevel
    interviewerRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewerRoleID
    jobRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    jobRoleID
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionBankInterviewTemplateMutation, UpdateQuestionBankInterviewTemplateMutationVariables>;
export const DeleteQuestionBankInterviewTemplateDocument = new TypedDocumentString(`
    mutation DeleteQuestionBankInterviewTemplate($input: DeleteQuestionBankInterviewTemplateInput!, $condition: ModelQuestionBankInterviewTemplateConditionInput) {
  deleteQuestionBankInterviewTemplate(input: $input, condition: $condition) {
    group
    id
    name
    description
    jobLevel
    interviewerRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    interviewerRoleID
    jobRole {
      group
      id
      name
      description
      teamID
      createdAt
      updatedAt
      __typename
    }
    jobRoleID
    questions {
      nextToken
      __typename
    }
    team {
      group
      id
      name
      createdAt
      updatedAt
      __typename
    }
    teamID
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteQuestionBankInterviewTemplateMutation, DeleteQuestionBankInterviewTemplateMutationVariables>;
export const CreateOrgRoleLdapGroupsDocument = new TypedDocumentString(`
    mutation CreateOrgRoleLDAPGroups($input: CreateOrgRoleLDAPGroupsInput!, $condition: ModelOrgRoleLDAPGroupsConditionInput) {
  createOrgRoleLDAPGroups(input: $input, condition: $condition) {
    id
    group
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateOrgRoleLdapGroupsMutation, CreateOrgRoleLdapGroupsMutationVariables>;
export const UpdateOrgRoleLdapGroupsDocument = new TypedDocumentString(`
    mutation UpdateOrgRoleLDAPGroups($input: UpdateOrgRoleLDAPGroupsInput!, $condition: ModelOrgRoleLDAPGroupsConditionInput) {
  updateOrgRoleLDAPGroups(input: $input, condition: $condition) {
    id
    group
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgRoleLdapGroupsMutation, UpdateOrgRoleLdapGroupsMutationVariables>;
export const DeleteOrgRoleLdapGroupsDocument = new TypedDocumentString(`
    mutation DeleteOrgRoleLDAPGroups($input: DeleteOrgRoleLDAPGroupsInput!, $condition: ModelOrgRoleLDAPGroupsConditionInput) {
  deleteOrgRoleLDAPGroups(input: $input, condition: $condition) {
    id
    group
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgRoleLdapGroupsMutation, DeleteOrgRoleLdapGroupsMutationVariables>;
export const CreateRolePermissionGroupDocument = new TypedDocumentString(`
    mutation CreateRolePermissionGroup($input: CreateRolePermissionGroupInput!, $condition: ModelRolePermissionGroupConditionInput) {
  createRolePermissionGroup(input: $input, condition: $condition) {
    id
    app
    displayName
    teamId
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateRolePermissionGroupMutation, CreateRolePermissionGroupMutationVariables>;
export const UpdateRolePermissionGroupDocument = new TypedDocumentString(`
    mutation UpdateRolePermissionGroup($input: UpdateRolePermissionGroupInput!, $condition: ModelRolePermissionGroupConditionInput) {
  updateRolePermissionGroup(input: $input, condition: $condition) {
    id
    app
    displayName
    teamId
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateRolePermissionGroupMutation, UpdateRolePermissionGroupMutationVariables>;
export const DeleteRolePermissionGroupDocument = new TypedDocumentString(`
    mutation DeleteRolePermissionGroup($input: DeleteRolePermissionGroupInput!, $condition: ModelRolePermissionGroupConditionInput) {
  deleteRolePermissionGroup(input: $input, condition: $condition) {
    id
    app
    displayName
    teamId
    orgID
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    role
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteRolePermissionGroupMutation, DeleteRolePermissionGroupMutationVariables>;
export const CreateRoutingAttemptDocument = new TypedDocumentString(`
    mutation CreateRoutingAttempt($input: CreateRoutingAttemptInput!, $condition: ModelRoutingAttemptConditionInput) {
  createRoutingAttempt(input: $input, condition: $condition) {
    id
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    participantConfigID
    isBarRaiser
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    startDateTime
    endDateTime
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    normalizedPushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    lastModifiedBy
    state
    meetingsentryID
    schedule
    scheduleTime
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateRoutingAttemptMutation, CreateRoutingAttemptMutationVariables>;
export const UpdateRoutingAttemptDocument = new TypedDocumentString(`
    mutation UpdateRoutingAttempt($input: UpdateRoutingAttemptInput!, $condition: ModelRoutingAttemptConditionInput) {
  updateRoutingAttempt(input: $input, condition: $condition) {
    id
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    participantConfigID
    isBarRaiser
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    startDateTime
    endDateTime
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    normalizedPushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    lastModifiedBy
    state
    meetingsentryID
    schedule
    scheduleTime
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateRoutingAttemptMutation, UpdateRoutingAttemptMutationVariables>;
export const DeleteRoutingAttemptDocument = new TypedDocumentString(`
    mutation DeleteRoutingAttempt($input: DeleteRoutingAttemptInput!, $condition: ModelRoutingAttemptConditionInput) {
  deleteRoutingAttempt(input: $input, condition: $condition) {
    id
    loopEventID
    loopEvent {
      id
      honeycode_uid
      lastModifiedBy
      eventConfigID
      locked
      lockChangedAt
      lockedbyID
      maxcandidates
      orgID
      restrictedLeadSignup
      restrictedShadowSignup
      prebriefBookingEnabled
      status
      taglist
      designatedRCID
      eventleadID
      recruitingPOCID
      barRaiserID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      debriefbooked
      debriefNote
      debriefmeetingentryIDs
      prebriefbooked
      prebriefNote
      prebriefmeetingentryIDs
      location
      virtualevent
      is_template
      template_name
      template_description
      template_creator_alias
      source_template_id
      eventType
      createdAt
      updatedAt
      __typename
    }
    phoneScreenID
    phoneScreen {
      id
      lastModifiedBy
      eventConfigID
      eventType
      locked
      orgID
      restrictedevent
      status
      taglist
      designatedRCID
      availabilityID
      calendarplaceholdersent
      date
      eventstarttime
      eventendtime
      createdAt
      updatedAt
      __typename
    }
    participantConfigID
    isBarRaiser
    profileID
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    role
    startDateTime
    endDateTime
    pushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    normalizedPushRoutingWeight {
      timeSinceLastInterview
      timeZoneMatch
      diversityInterviewer
      languageMatch
      pendingRoutingAttempt
      shadowCompletion
      orgCollaborationInbound
      randomness
      __typename
    }
    lastModifiedBy
    state
    meetingsentryID
    schedule
    scheduleTime
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteRoutingAttemptMutation, DeleteRoutingAttemptMutationVariables>;
export const CreateShepherdProfileDocument = new TypedDocumentString(`
    mutation CreateShepherdProfile($input: CreateShepherdProfileInput!, $condition: ModelShepherdProfileConditionInput) {
  createShepherdProfile(input: $input, condition: $condition) {
    assignedAt
    group
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    shepherdId
    shepherd {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    isOrgDefault
    lastModifiedBy
    priority
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateShepherdProfileMutation, CreateShepherdProfileMutationVariables>;
export const UpdateShepherdProfileDocument = new TypedDocumentString(`
    mutation UpdateShepherdProfile($input: UpdateShepherdProfileInput!, $condition: ModelShepherdProfileConditionInput) {
  updateShepherdProfile(input: $input, condition: $condition) {
    assignedAt
    group
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    shepherdId
    shepherd {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    isOrgDefault
    lastModifiedBy
    priority
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateShepherdProfileMutation, UpdateShepherdProfileMutationVariables>;
export const DeleteShepherdProfileDocument = new TypedDocumentString(`
    mutation DeleteShepherdProfile($input: DeleteShepherdProfileInput!, $condition: ModelShepherdProfileConditionInput) {
  deleteShepherdProfile(input: $input, condition: $condition) {
    assignedAt
    group
    profileId
    profile {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    shepherdId
    shepherd {
      id
      activeOrg
      alias
      learnUserId
      identityId
      status
      brStatus
      br
      brit
      city
      email
      firstName
      hireDate
      ismanager
      lastName
      level
      name
      site
      title
      manager
      l2manager
      l3manager
      brInterest
      diversityInterviewer
      loopInterest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      notifyWeeklyDigest
      phoneScreenInterest
      preferredTimezoneId
      lastRefreshedDate
      createdAt
      updatedAt
      __typename
    }
    isOrgDefault
    lastModifiedBy
    priority
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteShepherdProfileMutation, DeleteShepherdProfileMutationVariables>;
export const CreateTrainingDocument = new TypedDocumentString(`
    mutation CreateTraining($input: CreateTrainingInput!, $condition: ModelTrainingConditionInput) {
  createTraining(input: $input, condition: $condition) {
    group
    id
    trainingId
    calibrationIds
    isActive
    isManaged
    isRequiredForloop
    isRequiredForPhoneScreen
    link
    minAcceptedVersion
    title
    trainingVersion
    orgId
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<CreateTrainingMutation, CreateTrainingMutationVariables>;
export const UpdateTrainingDocument = new TypedDocumentString(`
    mutation UpdateTraining($input: UpdateTrainingInput!, $condition: ModelTrainingConditionInput) {
  updateTraining(input: $input, condition: $condition) {
    group
    id
    trainingId
    calibrationIds
    isActive
    isManaged
    isRequiredForloop
    isRequiredForPhoneScreen
    link
    minAcceptedVersion
    title
    trainingVersion
    orgId
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<UpdateTrainingMutation, UpdateTrainingMutationVariables>;
export const DeleteTrainingDocument = new TypedDocumentString(`
    mutation DeleteTraining($input: DeleteTrainingInput!, $condition: ModelTrainingConditionInput) {
  deleteTraining(input: $input, condition: $condition) {
    group
    id
    trainingId
    calibrationIds
    isActive
    isManaged
    isRequiredForloop
    isRequiredForPhoneScreen
    link
    minAcceptedVersion
    title
    trainingVersion
    orgId
    org {
      id
      group
      name
      description
      geoarea
      georegion
      status
      availabilityMinDaysOut
      shadowMinDaysOut
      calibrationShepherdMode
      defaultCalibrationShepherd
      loopQuipID
      loopsExportedAt
      phoneScreenQuipID
      phoneScreensExportedAt
      orgQuipFolderID
      apssTeamId
      alwaysRestrictLeadSignups
      alwaysRestrictShadowSignups
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
    `) as unknown as TypedDocumentString<DeleteTrainingMutation, DeleteTrainingMutationVariables>;
export const ListAnnouncementsByOrganizationDocument = new TypedDocumentString(`
    query ListAnnouncementsByOrganization($orgId: ID!, $filter: ModelAnnouncementFilterInput) {
  listAnnouncementsByOrganization(orgId: $orgId, filter: $filter) {
    items {
      id
      title
      text
      status
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ListAnnouncementsByOrganizationQuery, ListAnnouncementsByOrganizationQueryVariables>;
export const GetAuditTrailsByProfileDocument = new TypedDocumentString(`
    query GetAuditTrailsByProfile($profileID: ID!, $filter: ModelAuditTrailsFilterInput, $limit: Int, $nextToken: String) {
  listAuditTrailsByProfile(
    profileID: $profileID
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: DESC
  ) {
    items {
      changeJustification
      createdAt
      humanReadableLog
      id
      modifiedBy
      recordType
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetAuditTrailsByProfileQuery, GetAuditTrailsByProfileQueryVariables>;
export const ListAuditTrailsByEventIdDocument = new TypedDocumentString(`
    query ListAuditTrailsByEventId($eventId: ID!, $filter: ModelAuditTrailsFilterInput, $limit: Int, $nextToken: String) {
  listAuditTrailsByEventId(
    eventId: $eventId
    createdAt: {ge: "2024-05-13T00:00:00.000Z"}
    sortDirection: DESC
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      changeJustification
      createdAt
      humanReadableLog
      id
      modifiedBy
      recordType
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListAuditTrailsByEventIdQuery, ListAuditTrailsByEventIdQueryVariables>;
export const ListOrgProfileShepherdsDocument = new TypedDocumentString(`
    query listOrgProfileShepherds($orgId: ID!, $limit: Int, $filter: ModelProfileOrganizationV2FilterInput, $nextToken: String) {
  listProfilesByOrgV2(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    orgID: $orgId
  ) {
    items {
      profile {
        alias
        email
        id
        l2manager
        level
        manager
        name
        shepherds(limit: 1000) {
          items {
            shepherd {
              alias
              email
              id
              name
              title
            }
          }
        }
        status
        title
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListOrgProfileShepherdsQuery, ListOrgProfileShepherdsQueryVariables>;
export const ListProfilesByShepherdDocument = new TypedDocumentString(`
    query listProfilesByShepherd($id: ID!, $limit: Int, $nextToken: String) {
  getProfile(id: $id) {
    cohortMembers(nextToken: $nextToken, limit: $limit) {
      items {
        profile {
          alias
          brStatus
          calibrations(limit: 1000) {
            items {
              calibrationId
              independentCount
              reverseShadowCount
              reviewCount
              shadowCount
              status
            }
          }
          email
          id
          l2manager
          learnUserId
          level
          manager
          name
          orgs(limit: 1000) {
            items {
              orgID
            }
          }
          preferredTimezoneId
          title
          status
          updatedAt
        }
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<ListProfilesByShepherdQuery, ListProfilesByShepherdQueryVariables>;
export const CanManageShepherdProfileDocument = new TypedDocumentString(`
    query CanManageShepherdProfile($orgId: ID!, $profileId: ID!) {
  canManageShepherdProfile(orgId: $orgId, profileId: $profileId)
}
    `) as unknown as TypedDocumentString<CanManageShepherdProfileQuery, CanManageShepherdProfileQueryVariables>;
export const ListShepherdProfileNotesDocument = new TypedDocumentString(`
    query ListShepherdProfileNotes($orgId: ID!, $profileId: ID!, $limit: Int, $nextToken: String) {
  listShepherdProfileNotes(
    orgId: $orgId
    profileId: $profileId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      commentType
      content
      createdAt
      id
      interviewerID
      interviewer {
        id
        isBarRaiserInterviewer
        participantConfig {
          id
          name
        }
        interviewerRole
      }
      loopEventID
      loopEvent {
        date
        eventstarttime
        id
        orgID
      }
      phoneScreenID
      phoneScreen {
        date
        eventstarttime
        id
        orgID
      }
      profile {
        alias
        email
        id
        name
        title
      }
      rating
      restricted
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListShepherdProfileNotesQuery, ListShepherdProfileNotesQueryVariables>;
export const FeedbackByLoopEventAndAuthorDocument = new TypedDocumentString(`
    query FeedbackByLoopEventAndAuthor($profileID: ID!, $loopEventID: ID, $phoneScreenID: ID, $limit: Int, $commentFilter: ModelCommentFilterInput, $nextToken: String) {
  getProfile(id: $profileID) {
    alias
    comments(
      commentTypeLoopEventIDPhoneScreenID: {eq: {commentType: FEEDBACK, loopEventID: $loopEventID, phoneScreenID: $phoneScreenID}}
      filter: $commentFilter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        rating
        interviewerID
        restricted
        createdAt
        updatedAt
      }
      nextToken
    }
    email
    id
    name
    title
  }
}
    `) as unknown as TypedDocumentString<FeedbackByLoopEventAndAuthorQuery, FeedbackByLoopEventAndAuthorQueryVariables>;
export const ListFeedbackForProfileDocument = new TypedDocumentString(`
    query ListFeedbackForProfile($interviewerProfileID: ID!, $filter: ModelCommentFilterInput, $limit: Int, $nextToken: String) {
  listFeedbackForProfile(
    interviewerProfileID: $interviewerProfileID
    commentType: {between: ["FEEDBACK", "PROFILE"]}
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      commentType
      content
      createdAt
      id
      interviewerID
      interviewer {
        id
        isBarRaiserInterviewer
        participantConfig {
          description
          id
          name
        }
        interviewerRole
      }
      loopEventID
      loopEvent {
        date
        eventstarttime
        id
        orgID
      }
      phoneScreenID
      phoneScreen {
        date
        eventstarttime
        id
        orgID
      }
      profile {
        alias
        email
        id
        name
        title
      }
      rating
      restricted
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListFeedbackForProfileQuery, ListFeedbackForProfileQueryVariables>;
export const GetInterviewerProfileDocument = new TypedDocumentString(`
    query GetInterviewerProfile($id: ID!) {
  getInterviewer(id: $id) {
    id
    isBarRaiserInterviewer
    loopEventID
    participantConfigID
    phoneScreenID
    profile {
      alias
      id
      name
    }
    sourceOrgID
    interviewerRole
  }
}
    `) as unknown as TypedDocumentString<GetInterviewerProfileQuery, GetInterviewerProfileQueryVariables>;
export const LoopEventTemplatesByOrgDocument = new TypedDocumentString(`
    query LoopEventTemplatesByOrg($orgID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  getOrganization(id: $orgID) {
    loopEvents(
      sortDirection: $sortDirection
      filter: {and: [{is_template: {eq: true}}, {eventConfigID: {attributeExists: true}}]}
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orgID
        date
        id
        is_template
        template_name
        template_description
        eventleadID
        designatedRCID
        recruitingPOCID
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<LoopEventTemplatesByOrgQuery, LoopEventTemplatesByOrgQueryVariables>;
export const GetLoopEventsByInterviewerProfileDocument = new TypedDocumentString(`
    query getLoopEventsByInterviewerProfile($profileID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  listInterviewersByProfile(
    profileID: $profileID
    sortDirection: $sortDirection
    filter: {loopEventID: {attributeExists: true}}
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      loopEvent {
        id
        maxcandidates
        taglist
        status
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        location
        date
        eventstarttime
        eventendtime
        virtualevent
        createdAt
        orgID
        locked
        lockedby {
          id
          alias
          name
        }
        eventlead {
          id
          alias
          name
        }
        designatedRC {
          id
          alias
          name
        }
        recruitingPOC {
          id
          alias
          name
        }
        eventConfig {
          id
          brMode
          candidateLevels
          name
          description
          duration
          breakDuration
          maxShadowParticipants
          updatedAt
          createdAt
          isActive
          orgID
          isPushRouting
          participantConfigs {
            items {
              id
              orgID
              isActive
              name
              description
              calibrationConfigID
              createdAt
              updatedAt
            }
          }
        }
        candidates {
          items {
            city
            hireurl
            id
            level
            name
          }
        }
        comments(
          filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
        ) {
          items {
            id
          }
        }
        interviewers {
          items {
            id
            interviewerRole
            participantConfigID
            isBarRaiserInterviewer
            startDateTime
            endDateTime
            sourceOrgID
            profile {
              id
              alias
              languages(
                limit: 1000
                filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
              ) {
                items {
                  isoCode
                  reading
                  speaking
                  writing
                }
              }
              name
              preferredTimezoneId
              title
            }
          }
        }
        languages {
          items {
            isoCode
            readingRequired
            speakingRequired
            writingRequired
          }
        }
        updatedAt
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetLoopEventsByInterviewerProfileQuery, GetLoopEventsByInterviewerProfileQueryVariables>;
export const GetOrgLoopEventsDocument = new TypedDocumentString(`
    query GetOrgLoopEvents($orgID: ID!, $statusDate: ModelLoopEventByOrgStatusDateCompositeKeyConditionInput, $sortDirection: ModelSortDirection, $loopsFilter: ModelLoopEventFilterInput, $limit: Int, $nextToken: String) {
  getOrganization(id: $orgID) {
    id
    name
    loopEvents(
      statusDate: $statusDate
      filter: $loopsFilter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        maxcandidates
        taglist
        status
        restrictedLeadSignup
        restrictedShadowSignup
        prebriefBookingEnabled
        location
        date
        eventstarttime
        eventendtime
        virtualevent
        createdAt
        orgID
        locked
        lockedby {
          id
          alias
          name
        }
        eventlead {
          id
          alias
          name
        }
        designatedRC {
          id
          alias
          name
        }
        recruitingPOC {
          id
          alias
          name
        }
        eventConfig {
          id
          orgID
          createdAt
          updatedAt
          brMode
          candidateLevels
          name
          description
          duration
          breakDuration
          maxShadowParticipants
          isActive
          isPushRouting
          participantConfigs {
            items {
              id
              orgID
              isActive
              name
              description
              calibrationConfigID
              createdAt
              updatedAt
            }
          }
        }
        candidates {
          items {
            city
            hireurl
            id
            level
            name
          }
        }
        comments(
          filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
        ) {
          items {
            id
          }
        }
        interviewers {
          items {
            id
            interviewerRole
            participantConfigID
            isBarRaiserInterviewer
            startDateTime
            endDateTime
            sourceOrgID
            profile {
              id
              alias
              languages(
                limit: 1000
                filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
              ) {
                items {
                  isoCode
                  reading
                  speaking
                  writing
                }
              }
              name
              preferredTimezoneId
              title
            }
          }
        }
        languages {
          items {
            isoCode
            readingRequired
            speakingRequired
            writingRequired
          }
        }
        routingHistory {
          items {
            createdAt
            id
            endDateTime
            role
            participantConfigID
            createdAt
            profile {
              alias
              email
              id
              name
              title
            }
            scheduleTime
            startDateTime
            state
            isBarRaiser
            updatedAt
          }
        }
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgLoopEventsQuery, GetOrgLoopEventsQueryVariables>;
export const GetCommentsByLoopEventDocument = new TypedDocumentString(`
    query getCommentsByLoopEvent($loopEventId: ID!, $limit: Int, $nextToken: String) {
  getLoopEvent(id: $loopEventId) {
    comments(
      filter: {or: [{commentType: {eq: CANCELLATION}}, {commentType: {eq: EVENT}}]}
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        profile {
          id
          alias
          email
          name
          title
        }
        restricted
        loopEventID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetCommentsByLoopEventQuery, GetCommentsByLoopEventQueryVariables>;
export const GetLoopConfigsByOrgDocument = new TypedDocumentString(`
    query GetLoopConfigsByOrg($orgID: ID!, $filter: ModelOrgLoopPSConfigurationsFilterInput, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  listConfigsByOrgType(
    orgID: $orgID
    configType: {eq: "LOOP_CONFIG"}
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orgID
      configType
      group
      isActive
      brMode
      candidateLevels
      name
      isPushRouting
      description
      duration
      breakDuration
      maxShadowParticipants
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetLoopConfigsByOrgQuery, GetLoopConfigsByOrgQueryVariables>;
export const GetLoopEventConfigDefinitionDocument = new TypedDocumentString(`
    query GetLoopEventConfigDefinition($id: ID!) {
  getOrgLoopPSConfigurations(id: $id) {
    id
    orgID
    group
    isActive
    isPushRouting
    brMode
    candidateLevels
    name
    description
    duration
    breakDuration
    maxShadowParticipants
    participantConfigIDs
    participantConfigs {
      items {
        id
        orgID
        configType
        group
        isActive
        name
        description
        calibrationConfigID
        calibrationConfig {
          id
          orgID
          configType
          group
          isActive
          name
          description
          maxShadowPoolSize
          minShadows
          minIndependent
          minReverseShadows
          minShepherdReviews
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetLoopEventConfigDefinitionQuery, GetLoopEventConfigDefinitionQueryVariables>;
export const GetLoopEventDocument = new TypedDocumentString(`
    query GetLoopEvent($id: ID!) {
  getLoopEvent(id: $id) {
    id
    date
    eventstarttime
    eventendtime
    eventlead {
      id
      alias
      name
      email
      br
    }
    status
    locked
    lockedby {
      id
      alias
      name
    }
    prebriefbooked
    prebriefNote
    debriefbooked
    debriefNote
    calendarplaceholdersent
    virtualevent
    recruitingPOC {
      id
      alias
      name
    }
    designatedRC {
      id
      alias
      name
    }
    restrictedLeadSignup
    restrictedShadowSignup
    prebriefBookingEnabled
    is_template
    template_name
    template_description
    template_creator_alias
    source_template_id
    taglist
    maxcandidates
    orgID
    candidates {
      items {
        city
        hireurl
        id
        level
        name
      }
    }
    comments(
      filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
    ) {
      items {
        id
      }
    }
    interviewers {
      items {
        id
        profile {
          id
          alias
          languages(
            limit: 1000
            filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
          ) {
            items {
              isoCode
              reading
              speaking
              writing
            }
          }
          name
          preferredTimezoneId
          title
        }
        interviewerRole
        isBarRaiserInterviewer
        sendCalendarInvite
        participantConfigID
        startDateTime
        endDateTime
        sourceOrgID
      }
    }
    eventConfig {
      id
      orgID
      configType
      group
      isActive
      isPushRouting
      brMode
      candidateLevels
      name
      description
      duration
      breakDuration
      maxShadowParticipants
      participantConfigIDs
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          calibrationConfigID
          calibrationConfig {
            id
            orgID
            configType
            group
            isActive
            candidateLevels
            name
            description
            maxShadowPoolSize
            minShadows
            minIndependent
            minReverseShadows
            minShepherdReviews
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
    languages {
      items {
        isoCode
        readingRequired
        speakingRequired
        writingRequired
      }
    }
    location
    createdAt
    updatedAt
    routingHistory {
      items {
        createdAt
        endDateTime
        id
        isBarRaiser
        participantConfigID
        profile {
          alias
          id
          name
          email
          title
        }
        role
        scheduleTime
        startDateTime
        state
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLoopEventQuery, GetLoopEventQueryVariables>;
export const GetInterviewersByLoopEventDocument = new TypedDocumentString(`
    query GetInterviewersByLoopEvent($eventID: ID!, $sortDirection: ModelSortDirection, $filter: ModelInterviewerFilterInput, $limit: Int, $nextToken: String) {
  getLoopEvent(id: $eventID) {
    interviewers(
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        profileID
        participantConfigID
        interviewerRole
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInterviewersByLoopEventQuery, GetInterviewersByLoopEventQueryVariables>;
export const ListLanguagesByEventDocument = new TypedDocumentString(`
    query listLanguagesByEvent($eventId: ID!) {
  listLanguages(
    id: $eventId
    recordTypeIsoCode: {beginsWith: {recordType: REQUIREMENT}}
  ) {
    items {
      id
      isoCode
      readingRequired
      speakingRequired
      writingRequired
    }
  }
}
    `) as unknown as TypedDocumentString<ListLanguagesByEventQuery, ListLanguagesByEventQueryVariables>;
export const ListOrganizationsDocument = new TypedDocumentString(`
    query ListOrganizations($filter: ModelOrganizationFilterInput, $collaborationsFilter: ModelOrgCollaborationsFilterInput, $limit: Int, $nextToken: String) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      createdAt
      updatedAt
      orgCollaborationsOutbound(filter: $collaborationsFilter, limit: $limit) {
        items {
          id
        }
      }
      orgCollaborationsInbound(filter: $collaborationsFilter, limit: $limit) {
        items {
          id
        }
      }
      status
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListOrganizationsQuery, ListOrganizationsQueryVariables>;
export const ListOrganizationsSimpleDocument = new TypedDocumentString(`
    query ListOrganizationsSimple($filter: ModelOrganizationFilterInput, $limit: Int, $nextToken: String) {
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      createdAt
      updatedAt
      status
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListOrganizationsSimpleQuery, ListOrganizationsSimpleQueryVariables>;
export const GetOrganizationDocument = new TypedDocumentString(`
    query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    availabilityMinDaysOut
    shadowMinDaysOut
    advancedSettings {
      enableLoopQuipExport
      enablePhoneScreenQuipExport
      enablePushRouting
      enablePromoHub
    }
    loopQuipID
    loopsExportedAt
    phoneScreenQuipID
    phoneScreensExportedAt
  }
}
    `) as unknown as TypedDocumentString<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetAllOrgEventParticipantConfigsDocument = new TypedDocumentString(`
    query GetAllOrgEventParticipantConfigs($id: ID!, $limit: Int, $nextToken: String) {
  getOrganization(id: $id) {
    id
    loopPSConfigs(
      filter: {or: [{configType: {eq: LOOP_PARTICIPANT}}, {configType: {eq: PHONESCREEN_PARTICIPANT}}]}
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        configType
        group
        isActive
        name
        description
        calibrationConfigID
        calibrationConfig {
          id
          configType
          group
          isActive
          name
          description
          maxShadowPoolSize
          minShadows
          minIndependent
          minReverseShadows
          minShepherdReviews
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrgEventParticipantConfigsQuery, GetAllOrgEventParticipantConfigsQueryVariables>;
export const GetOrgEventParticipantConfigsByTypeDocument = new TypedDocumentString(`
    query GetOrgEventParticipantConfigsByType($orgID: ID!, $configType: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelOrgLoopPSConfigurationsFilterInput, $limit: Int, $nextToken: String) {
  listConfigsByOrgType(
    orgID: $orgID
    configType: $configType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      calibrationConfig {
        id
        orgID
        configType
        group
        isActive
        name
        description
        maxShadowPoolSize
        minShadows
        minIndependent
        minReverseShadows
        minShepherdReviews
        createdAt
        updatedAt
      }
      competencies {
        competency {
          name
          description
        }
        level
      }
      configType
      createdAt
      description
      id
      isActive
      orgID
      name
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetOrgEventParticipantConfigsByTypeQuery, GetOrgEventParticipantConfigsByTypeQueryVariables>;
export const GetOrgEventCalibrationConfigsByTypeDocument = new TypedDocumentString(`
    query GetOrgEventCalibrationConfigsByType($orgID: ID!, $configType: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelOrgLoopPSConfigurationsFilterInput, $limit: Int, $nextToken: String) {
  listConfigsByOrgType(
    orgID: $orgID
    configType: $configType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orgID
      configType
      group
      isActive
      name
      description
      maxShadowPoolSize
      minShadows
      minReverseShadows
      minShepherdReviews
      minIndependent
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetOrgEventCalibrationConfigsByTypeQuery, GetOrgEventCalibrationConfigsByTypeQueryVariables>;
export const GetCalibrationDefinitionDocument = new TypedDocumentString(`
    query GetCalibrationDefinition($id: ID!) {
  getOrgLoopPSConfigurations(id: $id) {
    id
    orgID
    configType
    group
    isActive
    name
    description
    maxShadowPoolSize
    minShadows
    minReverseShadows
    minShepherdReviews
    minIndependent
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetCalibrationDefinitionQuery, GetCalibrationDefinitionQueryVariables>;
export const GetActiveOrgEventCalibrationConfigsDocument = new TypedDocumentString(`
    query GetActiveOrgEventCalibrationConfigs($orgID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  getOrganization(id: $orgID) {
    loopPSConfigs(
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
      filter: {and: [{isActive: {eq: true}}, {or: [{configType: {eq: LOOP_CALIBRATION}}, {configType: {eq: PHONESCREEN_CALIBRATION}}]}]}
    ) {
      items {
        id
        orgID
        configType
        group
        isActive
        name
        description
        maxShadowPoolSize
        minShadows
        minReverseShadows
        minShepherdReviews
        minIndependent
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetActiveOrgEventCalibrationConfigsQuery, GetActiveOrgEventCalibrationConfigsQueryVariables>;
export const GetAllOrgCollaborationsDocument = new TypedDocumentString(`
    query GetAllOrgCollaborations($id: ID!) {
  getOrganization(id: $id) {
    id
    orgCollaborationsOutbound(filter: {isActive: {eq: true}}) {
      items {
        id
        isActive
        isPendingAuthorization
        targetOrgID
        barRaisers
        sharedLoopParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        sharedPSParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        originParticipants {
          items {
            id
            calibrationConfigID
          }
        }
        targetParticipants {
          items {
            id
            calibrationConfigID
          }
        }
        pendingChangeSpec
        createdAt
        updatedAt
      }
      nextToken
    }
    orgCollaborationsInbound(filter: {isActive: {eq: true}}) {
      items {
        id
        isActive
        isPendingAuthorization
        originatingOrgID
        barRaisers
        sharedLoopParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        sharedPSParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        originParticipants {
          items {
            id
            calibrationConfigID
          }
        }
        targetParticipants {
          items {
            id
            calibrationConfigID
          }
        }
        pendingChangeSpec
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrgCollaborationsQuery, GetAllOrgCollaborationsQueryVariables>;
export const GetOrgCompetenciesDocument = new TypedDocumentString(`
    query GetOrgCompetencies($id: ID!) {
  getOrganization(id: $id) {
    competencies {
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgCompetenciesQuery, GetOrgCompetenciesQueryVariables>;
export const GetOrgOutboundCollaborationsDocument = new TypedDocumentString(`
    query GetOrgOutboundCollaborations($id: ID!, $loopPSConfigsLimit: Int) {
  getOrganization(id: $id) {
    id
    name
    description
    loopPSConfigs(
      filter: {or: [{configType: {eq: LOOP_PARTICIPANT}}, {configType: {eq: PHONESCREEN_PARTICIPANT}}]}
      limit: $loopPSConfigsLimit
    ) {
      items {
        id
        configType
        isActive
        name
        description
      }
      nextToken
    }
    orgCollaborationsOutbound {
      items {
        id
        isActive
        isPendingAuthorization
        targetOrg {
          id
          name
          description
          loopPSConfigs(
            filter: {or: [{configType: {eq: LOOP_PARTICIPANT}}, {configType: {eq: PHONESCREEN_PARTICIPANT}}]}
            limit: $loopPSConfigsLimit
          ) {
            items {
              id
              configType
              isActive
              name
              description
            }
            nextToken
          }
          georegion
          geoarea
          createdAt
          updatedAt
        }
        barRaisers
        sharedLoopParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        sharedPSParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        pendingChangeSpec
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgOutboundCollaborationsQuery, GetOrgOutboundCollaborationsQueryVariables>;
export const GetOrgInboundCollaborationsDocument = new TypedDocumentString(`
    query GetOrgInboundCollaborations($id: ID!, $loopPSConfigsLimit: Int) {
  getOrganization(id: $id) {
    id
    name
    description
    loopPSConfigs(
      filter: {or: [{configType: {eq: LOOP_PARTICIPANT}}, {configType: {eq: PHONESCREEN_PARTICIPANT}}]}
      limit: $loopPSConfigsLimit
    ) {
      items {
        id
        configType
        isActive
        name
        description
      }
      nextToken
    }
    orgCollaborationsInbound {
      items {
        id
        isActive
        isPendingAuthorization
        originatingOrg {
          id
          name
          description
          loopPSConfigs(
            filter: {or: [{configType: {eq: LOOP_PARTICIPANT}}, {configType: {eq: PHONESCREEN_PARTICIPANT}}]}
            limit: $loopPSConfigsLimit
          ) {
            items {
              id
              configType
              isActive
              name
              description
            }
            nextToken
          }
          georegion
          geoarea
          createdAt
          updatedAt
        }
        barRaisers
        sharedLoopParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        sharedPSParticipants {
          originParticipantId
          targetParticipantId
          mode
        }
        pendingChangeSpec
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgInboundCollaborationsQuery, GetOrgInboundCollaborationsQueryVariables>;
export const GetOrgRoleLdapGroupsDocument = new TypedDocumentString(`
    query GetOrgRoleLDAPGroups($id: ID!, $roleLDAPGroupsFilter: ModelOrgRoleLDAPGroupsFilterInput) {
  getOrganization(id: $id) {
    id
    roleLDAPGroups(filter: $roleLDAPGroupsFilter) {
      items {
        id
        role
        group
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgRoleLdapGroupsQuery, GetOrgRoleLdapGroupsQueryVariables>;
export const GetOrgRoleGroupsDocument = new TypedDocumentString(`
    query GetOrgRoleGroups($id: ID!, $roleGroupsFilter: ModelRolePermissionGroupFilterInput) {
  getOrganization(id: $id) {
    id
    roleGroups(filter: $roleGroupsFilter) {
      items {
        app
        id
        role
        teamId
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgRoleGroupsQuery, GetOrgRoleGroupsQueryVariables>;
export const ListOrgTrainingsDocument = new TypedDocumentString(`
    query listOrgTrainings($id: ID!, $limit: Int, $nextToken: String, $trainingFilter: ModelTrainingFilterInput) {
  getOrganization(id: $id) {
    id
    name
    trainings(limit: $limit, nextToken: $nextToken, filter: $trainingFilter) {
      items {
        calibrationIds
        createdAt
        id
        isActive
        isManaged
        link
        minAcceptedVersion
        title
        trainingId
        trainingVersion
        isRequiredForloop
        isRequiredForPhoneScreen
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<ListOrgTrainingsQuery, ListOrgTrainingsQueryVariables>;
export const GetOrgDefaultCalibrationShepherdDetailsDocument = new TypedDocumentString(`
    query GetOrgDefaultCalibrationShepherdDetails($id: ID!) {
  getOrganization(id: $id) {
    calibrationShepherdMode
    defaultCalibrationShepherd
  }
}
    `) as unknown as TypedDocumentString<GetOrgDefaultCalibrationShepherdDetailsQuery, GetOrgDefaultCalibrationShepherdDetailsQueryVariables>;
export const GetOrgEventTagsDocument = new TypedDocumentString(`
    query getOrgEventTags($id: ID!) {
  getOrganization(id: $id) {
    eventTags {
      group
      value
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgEventTagsQuery, GetOrgEventTagsQueryVariables>;
export const GetPhoneScreensbyOrgDocument = new TypedDocumentString(`
    query GetPhoneScreensbyOrg($orgID: ID!, $statusDate: ModelPhoneScreenByOrgStatusDateCompositeKeyConditionInput, $sortDirection: ModelSortDirection, $phoneScreensFilter: ModelPhoneScreenFilterInput, $interviewersFilter: ModelInterviewerFilterInput, $limit: Int, $nextToken: String) {
  getOrganization(id: $orgID) {
    id
    name
    phoneScreens(
      statusDate: $statusDate
      filter: $phoneScreensFilter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        date
        createdAt
        candidates {
          items {
            city
            hireurl
            id
            level
            name
          }
        }
        comments(
          filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
        ) {
          items {
            id
          }
        }
        updatedAt
        eventendtime
        eventstarttime
        designatedRCID
        designatedRC {
          id
          alias
          name
        }
        orgID
        status
        locked
        availabilityID
        restrictedevent
        eventConfig {
          id
          candidateLevels
          name
          description
          duration
          createdAt
          updatedAt
          isActive
          orgID
          participantConfigs {
            items {
              id
              orgID
              isActive
              name
              description
              calibrationConfigID
              createdAt
              updatedAt
            }
          }
        }
        interviewers(filter: $interviewersFilter) {
          items {
            id
            startDateTime
            endDateTime
            interviewerRole
            participantConfigID
            isBarRaiserInterviewer
            sourceOrgID
            profile {
              id
              alias
              languages(
                limit: 1000
                filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
              ) {
                items {
                  isoCode
                  reading
                  speaking
                  writing
                }
              }
              name
              preferredTimezoneId
              title
            }
          }
        }
        languages {
          items {
            isoCode
            readingRequired
            speakingRequired
            writingRequired
          }
        }
        taglist
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetPhoneScreensbyOrgQuery, GetPhoneScreensbyOrgQueryVariables>;
export const GetPhoneScreensByInterviewerProfileDocument = new TypedDocumentString(`
    query getPhoneScreensByInterviewerProfile($profileID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  listInterviewersByProfile(
    profileID: $profileID
    sortDirection: $sortDirection
    filter: {phoneScreenID: {attributeExists: true}}
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      phoneScreen {
        id
        date
        createdAt
        candidates {
          items {
            city
            hireurl
            id
            level
            name
          }
        }
        comments(
          filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
        ) {
          items {
            id
          }
        }
        updatedAt
        eventendtime
        eventstarttime
        designatedRCID
        restrictedevent
        designatedRC {
          id
          alias
          name
        }
        orgID
        status
        locked
        availabilityID
        eventConfig {
          id
          candidateLevels
          name
          description
          duration
          createdAt
          updatedAt
          isActive
          orgID
          participantConfigs {
            items {
              id
              orgID
              isActive
              name
              description
              calibrationConfigID
              createdAt
              updatedAt
            }
          }
        }
        interviewers {
          items {
            id
            interviewerRole
            participantConfigID
            isBarRaiserInterviewer
            startDateTime
            endDateTime
            sourceOrgID
            profile {
              id
              alias
              languages(
                limit: 1000
                filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
              ) {
                items {
                  isoCode
                  reading
                  speaking
                  writing
                }
              }
              name
              preferredTimezoneId
              title
            }
          }
        }
        languages {
          items {
            isoCode
            readingRequired
            speakingRequired
            writingRequired
          }
        }
        taglist
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetPhoneScreensByInterviewerProfileQuery, GetPhoneScreensByInterviewerProfileQueryVariables>;
export const GetOrgPhoneScreenDurationConfigsDocument = new TypedDocumentString(`
    query GetOrgPhoneScreenDurationConfigs($orgID: ID!, $sortDirection: ModelSortDirection, $limit: Int, $nextToken: String) {
  listConfigsByOrgType(
    orgID: $orgID
    configType: {eq: "PHONESCREEN_CONFIG"}
    sortDirection: $sortDirection
    filter: {and: [{isActive: {eq: true}}, {duration: {gt: 60}}]}
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      duration
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetOrgPhoneScreenDurationConfigsQuery, GetOrgPhoneScreenDurationConfigsQueryVariables>;
export const GetPhoneScreenConfigsByOrgDocument = new TypedDocumentString(`
    query GetPhoneScreenConfigsByOrg($orgID: ID!, $sortDirection: ModelSortDirection, $filter: ModelOrgLoopPSConfigurationsFilterInput, $limit: Int, $nextToken: String) {
  listConfigsByOrgType(
    orgID: $orgID
    configType: {eq: "PHONESCREEN_CONFIG"}
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orgID
      configType
      group
      isActive
      isPushRouting
      brMode
      candidateLevels
      name
      description
      duration
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetPhoneScreenConfigsByOrgQuery, GetPhoneScreenConfigsByOrgQueryVariables>;
export const GetOrgLoopPsConfigurationsDocument = new TypedDocumentString(`
    query GetOrgLoopPSConfigurations($id: ID!) {
  getOrgLoopPSConfigurations(id: $id) {
    id
    orgID
    group
    isActive
    brMode
    candidateLevels
    name
    description
    duration
    isPushRouting
    participantConfigIDs
    participantConfigs {
      items {
        id
        orgID
        configType
        group
        isActive
        name
        description
        calibrationConfigID
        calibrationConfig {
          id
          orgID
          configType
          group
          isActive
          name
          description
          maxShadowPoolSize
          minShadows
          minReverseShadows
          minShepherdReviews
          minIndependent
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetOrgLoopPsConfigurationsQuery, GetOrgLoopPsConfigurationsQueryVariables>;
export const ListProfileAvailabilityByOrgDocument = new TypedDocumentString(`
    query listProfileAvailabilityByOrg($orgID: ID!, $limit: Int, $nextToken: String) {
  listProfilesByOrgV2(
    orgID: $orgID
    filter: {role: {contains: INTERVIEWER}}
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      profile {
        id
        alias
        name
        email
        level
        preferredTimezoneId
        availabilities(filter: {expired: {ne: true}}, limit: 1000) {
          items {
            availabilityClose
            availabilityDate
            availabilityOpen
            availabilitySeriesID
            createdAt
            expired
            hireurl
            id
            recurringEndDate
            recursion
            requester
            rrule
            sendCalendarInvite
            state
            updatedAt
          }
        }
        calibrations(filter: {status: {ne: NOT_CALIBRATED}}, limit: 1000) {
          items {
            calibrationId
            independentCount
            reverseShadowCount
            reviewCount
            shadowCount
            status
          }
        }
        status
        title
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListProfileAvailabilityByOrgQuery, ListProfileAvailabilityByOrgQueryVariables>;
export const GetProfileAvailabilityDocument = new TypedDocumentString(`
    query GetProfileAvailability($id: ID!) {
  getProfileAvailability(id: $id) {
    id
    profile {
      id
      alias
      name
      email
      level
      preferredTimezoneId
      calibrations {
        items {
          calibrationId
          independentCount
          reverseShadowCount
          reviewCount
          shadowCount
          status
        }
      }
      title
    }
    requester
    hireurl
    state
    sendCalendarInvite
    expired
    availabilitySeriesID
    availabilityDate
    recurringEndDate
    availabilityOpen
    availabilityClose
    recursion
    rrule
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProfileAvailabilityQuery, GetProfileAvailabilityQueryVariables>;
export const GetInterviewersByPhoneScreenDocument = new TypedDocumentString(`
    query GetInterviewersByPhoneScreen($eventID: ID!, $sortDirection: ModelSortDirection, $filter: ModelInterviewerFilterInput, $limit: Int, $nextToken: String) {
  getPhoneScreen(id: $eventID) {
    interviewers(
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        profileID
        participantConfigID
        interviewerRole
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInterviewersByPhoneScreenQuery, GetInterviewersByPhoneScreenQueryVariables>;
export const GetPhoneScreenDocument = new TypedDocumentString(`
    query GetPhoneScreen($id: ID!) {
  getPhoneScreen(id: $id) {
    availabilityID
    id
    candidates {
      items {
        city
        hireurl
        id
        level
        name
      }
    }
    comments(
      filter: {or: [{commentType: {eq: EVENT}}, {commentType: {eq: CANCELLATION}}]}
    ) {
      items {
        id
      }
    }
    orgID
    date
    eventstarttime
    eventendtime
    status
    locked
    designatedRCID
    designatedRC {
      id
      alias
      name
    }
    interviewers {
      items {
        id
        profile {
          id
          alias
          languages(
            limit: 1000
            filter: {or: [{reading: {eq: FLUENT_OR_NATIVE}}, {speaking: {eq: FLUENT_OR_NATIVE}}, {writing: {eq: FLUENT_OR_NATIVE}}]}
          ) {
            items {
              isoCode
              reading
              speaking
              writing
            }
          }
          name
          preferredTimezoneId
          title
        }
        startDateTime
        endDateTime
        interviewerRole
        isBarRaiserInterviewer
        sendCalendarInvite
        participantConfigID
        sourceOrgID
      }
    }
    eventConfig {
      id
      orgID
      configType
      group
      isActive
      brMode
      candidateLevels
      name
      description
      duration
      participantConfigIDs
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          calibrationConfigID
          calibrationConfig {
            id
            orgID
            configType
            group
            isActive
            candidateLevels
            name
            description
            maxShadowPoolSize
            minIndependent
            minShadows
            minReverseShadows
            minShepherdReviews
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
    languages {
      items {
        isoCode
        readingRequired
        speakingRequired
        writingRequired
      }
    }
    restrictedevent
    taglist
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetPhoneScreenQuery, GetPhoneScreenQueryVariables>;
export const GetCommentsByPhoneScreenDocument = new TypedDocumentString(`
    query getCommentsByPhoneScreen($phoneScreenId: ID!, $limit: Int, $nextToken: String) {
  getPhoneScreen(id: $phoneScreenId) {
    comments(
      filter: {or: [{commentType: {eq: CANCELLATION}}, {commentType: {eq: EVENT}}]}
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        profile {
          id
          alias
          email
          name
          title
        }
        restricted
        loopEventID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetCommentsByPhoneScreenQuery, GetCommentsByPhoneScreenQueryVariables>;
export const ProfileCalibrationsByConfigDocument = new TypedDocumentString(`
    query ProfileCalibrationsByConfig($calibrationId: ID!, $sortDirection: ModelSortDirection, $filter: ModelProfileCalibrationFilterInput, $limit: Int, $nextToken: String) {
  getOrgLoopPSConfigurations(id: $calibrationId) {
    calibrations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        profile {
          activeOrg
          alias
          createdAt
          email
          id
          level
          manager
          name
          preferredTimezoneId
          status
          title
          updatedAt
        }
        status
        updatedAt
      }
      nextToken
    }
    org {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ProfileCalibrationsByConfigQuery, ProfileCalibrationsByConfigQueryVariables>;
export const GetProfilePreferencesDocument = new TypedDocumentString(`
    query GetProfilePreferences($id: ID!) {
  getProfile(id: $id) {
    id
    alias
    name
    email
    level
    br
    brit
    status
    loopInterest
    phoneScreenInterest
    brInterest
    diversityInterviewer
    notifyWeeklyDigest
    notifyLoopOpportunity
    notifyPhoneScreenOpportunity
    preferredTimezoneId
    activeOrg
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProfilePreferencesQuery, GetProfilePreferencesQueryVariables>;
export const ListProfileAvailabilitiesDocument = new TypedDocumentString(`
    query listProfileAvailabilities($id: ID!) {
  getProfile(id: $id) {
    alias
    availabilities(filter: {expired: {eq: false}}, limit: 1000) {
      items {
        availabilityClose
        availabilityDate
        availabilityOpen
        availabilitySeriesID
        createdAt
        id
        recurringEndDate
        recursion
        rrule
        sendCalendarInvite
        state
        updatedAt
      }
      nextToken
    }
    brStatus
    calibrations(filter: {status: {eq: CALIBRATED}}, limit: 100) {
      items {
        calibrationId
        calibration {
          configType
          id
          orgID
        }
        independentCount
        reverseShadowCount
        reviewCount
        shadowCount
        status
        updatedAt
      }
    }
    email
    id
    status
    level
    manager
    name
    preferredTimezoneId
    status
  }
}
    `) as unknown as TypedDocumentString<ListProfileAvailabilitiesQuery, ListProfileAvailabilitiesQueryVariables>;
export const GetProfileOrganizationV2Document = new TypedDocumentString(`
    query GetProfileOrganizationV2($profileID: ID!, $orgID: ID!) {
  getProfileOrganizationV2(profileID: $profileID, orgID: $orgID) {
    profileID
    orgID
    role
  }
}
    `) as unknown as TypedDocumentString<GetProfileOrganizationV2Query, GetProfileOrganizationV2QueryVariables>;
export const GetProfilesByOrgAndRoleDocument = new TypedDocumentString(`
    query GetProfilesByOrgAndRole($orgID: ID!, $sortDirection: ModelSortDirection, $filter: ModelProfileOrganizationV2FilterInput, $limit: Int, $nextToken: String) {
  listProfilesByOrgV2(
    orgID: $orgID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      profileID
      orgID
      organization {
        name
      }
      role
      createdAt
      updatedAt
      profile {
        alias
        createdAt
        email
        id
        l2manager
        level
        manager
        name
        learnUserId
        preferredTimezoneId
        status
        title
        updatedAt
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetProfilesByOrgAndRoleQuery, GetProfilesByOrgAndRoleQueryVariables>;
export const ListProfilesByManagerDocument = new TypedDocumentString(`
    query listProfilesByManager($managerAlias: String!, $filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
  listProfilesByManager(
    manager: $managerAlias
    status: {eq: "ACTIVE"}
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      alias
      brStatus
      learnUserId
      calibrations(limit: $limit) {
        items {
          calibrationId
          independentCount
          reverseShadowCount
          reviewCount
          shadowCount
          status
        }
      }
      email
      level
      manager
      l2manager
      name
      status
      title
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListProfilesByManagerQuery, ListProfilesByManagerQueryVariables>;
export const GetProfilesByOrgDocument = new TypedDocumentString(`
    query GetProfilesByOrg($orgID: ID!, $sortDirection: ModelSortDirection, $filter: ModelProfileOrganizationV2FilterInput, $limit: Int, $nextToken: String) {
  listProfilesByOrgV2(
    orgID: $orgID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      profile {
        id
        alias
        brStatus
        name
        level
        manager
        l2manager
        title
        email
        status
        learnUserId
        preferredTimezoneId
        calibrations(limit: $limit) {
          items {
            calibrationId
            independentCount
            reverseShadowCount
            reviewCount
            shadowCount
            status
          }
        }
        updatedAt
      }
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<GetProfilesByOrgQuery, GetProfilesByOrgQueryVariables>;
export const GetProfileCalibrationsDocument = new TypedDocumentString(`
    query GetProfileCalibrations($id: ID!, $limit: Int, $nextToken: String, $calibrationsFilter: ModelProfileCalibrationFilterInput) {
  getProfile(id: $id) {
    id
    alias
    name
    level
    br
    brit
    calibrations(filter: $calibrationsFilter, limit: $limit, nextToken: $nextToken) {
      items {
        calibratedAt
        calibrationId
        calibration {
          configType
          description
          id
          isActive
          maxShadowPoolSize
          minIndependent
          minReverseShadows
          minShepherdReviews
          minShadows
          name
          orgID
        }
        changeJustification
        independentCount
        lastModifiedBy
        reverseShadowCount
        reviewCount
        shadowCount
        status
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProfileCalibrationsQuery, GetProfileCalibrationsQueryVariables>;
export const GetProfileDetailDocument = new TypedDocumentString(`
    query GetProfileDetail($id: ID!) {
  getProfile(id: $id) {
    id
    activeOrg
    alias
    shepherds {
      items {
        shepherd {
          id
          alias
          name
          email
          level
          title
        }
        lastModifiedBy
        isOrgDefault
        createdAt
        updatedAt
      }
    }
    brStatus
    city
    email
    hireDate
    languages(limit: 1000) {
      items {
        id
        isoCode
        reading
        speaking
        writing
      }
    }
    learnUserId
    level
    manager
    l2manager
    name
    preferredTimezoneId
    orgs(limit: 1000) {
      items {
        orgID
      }
    }
    status
    title
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProfileDetailQuery, GetProfileDetailQueryVariables>;
export const GetPeopleProfileDocument = new TypedDocumentString(`
    query GetPeopleProfile($alias: String!) {
  getPeopleProfile(alias: $alias) {
    alias
    brit
    isBarRaiser
  }
}
    `) as unknown as TypedDocumentString<GetPeopleProfileQuery, GetPeopleProfileQueryVariables>;
export const GetCalibrationCohortDocument = new TypedDocumentString(`
    query getCalibrationCohort($id: ID!, $limit: Int, $nextToken: String) {
  getOrgLoopPSConfigurations(id: $id) {
    calibrations(
      filter: {status: {eq: IN_CALIBRATION}}
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        profileId
      }
      nextToken
    }
  }
}
    `) as unknown as TypedDocumentString<GetCalibrationCohortQuery, GetCalibrationCohortQueryVariables>;
export const GetProfileClassicDocument = new TypedDocumentString(`
    query getProfileClassic($id: ID!) {
  getProfile(id: $id) {
    id
    activeOrg
    alias
    name
    title
    email
    level
    br
    brit
    learnUserId
    manager
    preferredTimezoneId
    calibrations {
      items {
        calibrationId
        independentCount
        reverseShadowCount
        reviewCount
        shadowCount
        status
      }
    }
    orgs {
      items {
        organization {
          name
          id
          roleLDAPGroups {
            items {
              group
              role
            }
          }
          status
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfileClassicQuery, GetProfileClassicQueryVariables>;
export const GetProfilePlatformDocument = new TypedDocumentString(`
    query getProfilePlatform($id: ID!) {
  getProfile(id: $id) {
    id
    activeOrg
    alias
    name
    title
    email
    learnUserId
    level
    br
    brit
    manager
    preferredTimezoneId
    calibrations {
      items {
        calibrationId
        independentCount
        reverseShadowCount
        reviewCount
        shadowCount
        status
      }
    }
    orgs {
      items {
        organization {
          name
          id
          roleGroups {
            items {
              app
              teamId
              role
            }
          }
          status
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfilePlatformQuery, GetProfilePlatformQueryVariables>;
export const ListprofilesByBrStatusDocument = new TypedDocumentString(`
    query listprofilesByBRStatus($brStatus: BarRaiserStatus!, $brOrgFilter: ModelProfileOrganizationV2FilterInput, $filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
  listProfilesByBrStatus(
    brStatus: $brStatus
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      activeOrg
      alias
      createdAt
      email
      id
      level
      manager
      name
      orgs(filter: $brOrgFilter, limit: 1000) {
        items {
          orgID
        }
      }
      preferredTimezoneId
      status
      title
      updatedAt
    }
    nextToken
  }
}
    `) as unknown as TypedDocumentString<ListprofilesByBrStatusQuery, ListprofilesByBrStatusQueryVariables>;
export const LookupProfileByAliasDocument = new TypedDocumentString(`
    query lookupProfileByAlias($alias: String!) {
  findProfileByAlias(alias: $alias, limit: 1) {
    items {
      id
      preferredTimezoneId
    }
  }
}
    `) as unknown as TypedDocumentString<LookupProfileByAliasQuery, LookupProfileByAliasQueryVariables>;
export const GetQuestionBankTeamDocument = new TypedDocumentString(`
    query GetQuestionBankTeam($id: ID!) {
  getQuestionBankTeam(id: $id) {
    id
    name
    group
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetQuestionBankTeamQuery, GetQuestionBankTeamQueryVariables>;
export const ListQuestionBankTeamsDocument = new TypedDocumentString(`
    query ListQuestionBankTeams($limit: Int, $nextToken: String) {
  listQuestionBankTeams(limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      id
      name
      group
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamsQuery, ListQuestionBankTeamsQueryVariables>;
export const ListQuestionBankTeamCategoriesDocument = new TypedDocumentString(`
    query ListQuestionBankTeamCategories($teamID: ID!, $nextToken: String) {
  getQuestionBankTeam(id: $teamID) {
    categories(nextToken: $nextToken) {
      nextToken
      items {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamCategoriesQuery, ListQuestionBankTeamCategoriesQueryVariables>;
export const ListQuestionBankTeamJobRolesDocument = new TypedDocumentString(`
    query ListQuestionBankTeamJobRoles($teamID: ID!, $nextToken: String) {
  getQuestionBankTeam(id: $teamID) {
    jobRoles(nextToken: $nextToken) {
      nextToken
      items {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamJobRolesQuery, ListQuestionBankTeamJobRolesQueryVariables>;
export const ListQuestionBankTeamInterviewerRolesDocument = new TypedDocumentString(`
    query ListQuestionBankTeamInterviewerRoles($teamID: ID!, $nextToken: String) {
  getQuestionBankTeam(id: $teamID) {
    interviewerRoles(nextToken: $nextToken) {
      nextToken
      items {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamInterviewerRolesQuery, ListQuestionBankTeamInterviewerRolesQueryVariables>;
export const ListQuestionBankTeamQuestionsDocument = new TypedDocumentString(`
    query ListQuestionBankTeamQuestions($limit: Int, $nextToken: String, $teamID: ID!) {
  getQuestionBankTeam(id: $teamID) {
    questions(limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        id
        category {
          id
          group
          name
          description
          teamID
          createdAt
          updatedAt
          team {
            id
            name
            group
            createdAt
            updatedAt
          }
        }
        categoryID
        status
        group
        name
        description
        teamID
        createdAt
        updatedAt
        shareability
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamQuestionsQuery, ListQuestionBankTeamQuestionsQueryVariables>;
export const ListQuestionBankTeamInterviewTemplatesDocument = new TypedDocumentString(`
    query ListQuestionBankTeamInterviewTemplates($teamID: ID!, $nextToken: String) {
  getQuestionBankTeam(id: $teamID) {
    interviewTemplates(nextToken: $nextToken) {
      nextToken
      items {
        id
        group
        name
        description
        jobLevel
        createdAt
        updatedAt
        interviewerRole {
          id
          group
          name
          description
          teamID
          createdAt
          updatedAt
          team {
            id
            name
            group
            createdAt
            updatedAt
          }
        }
        jobRole {
          id
          group
          name
          description
          teamID
          createdAt
          updatedAt
          team {
            id
            name
            group
            createdAt
            updatedAt
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankTeamInterviewTemplatesQuery, ListQuestionBankTeamInterviewTemplatesQueryVariables>;
export const ListQuestionBankInterviewTemplatesDocument = new TypedDocumentString(`
    query ListQuestionBankInterviewTemplates($limit: Int, $nextToken: String) {
  listQuestionBankInterviewTemplates(limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      id
      name
      description
      jobLevel
      interviewerRole {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
      jobRole {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
      team {
        id
        name
        group
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankInterviewTemplatesQuery, ListQuestionBankInterviewTemplatesQueryVariables>;
export const GetQuestionBankInterviewTemplateDocument = new TypedDocumentString(`
    query GetQuestionBankInterviewTemplate($id: ID!, $nextToken: String) {
  getQuestionBankInterviewTemplate(id: $id) {
    id
    group
    name
    description
    jobLevel
    interviewerRoleID
    interviewerRole {
      id
      group
      name
      description
      teamID
      createdAt
      updatedAt
      team {
        id
        name
        group
        createdAt
        updatedAt
      }
    }
    jobRoleID
    jobRole {
      id
      group
      name
      description
      teamID
      createdAt
      updatedAt
      team {
        id
        name
        group
        createdAt
        updatedAt
      }
    }
    teamID
    team {
      id
      name
      group
      createdAt
      updatedAt
    }
    questions(nextToken: $nextToken) {
      nextToken
      items {
        group
        interviewTemplateID
        questionID
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetQuestionBankInterviewTemplateQuery, GetQuestionBankInterviewTemplateQueryVariables>;
export const GetQuestionBankQuestionDocument = new TypedDocumentString(`
    query GetQuestionBankQuestion($id: ID!) {
  getQuestionBankQuestion(id: $id) {
    id
    group
    status
    name
    description
    createdAt
    updatedAt
    categoryID
    shareability
    category {
      id
      group
      name
      description
      createdAt
      updatedAt
      teamID
      team {
        id
        name
        group
        createdAt
        updatedAt
      }
    }
    teamID
    team {
      id
      name
      group
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetQuestionBankQuestionQuery, GetQuestionBankQuestionQueryVariables>;
export const ListQuestionBankQuestionsByShareabilityDocument = new TypedDocumentString(`
    query ListQuestionBankQuestionsByShareability($shareability: QuestionShareability!, $nextToken: String) {
  listQuestionBankQuestionsByShareability(
    shareability: $shareability
    nextToken: $nextToken
  ) {
    nextToken
    items {
      id
      category {
        id
        group
        name
        description
        teamID
        createdAt
        updatedAt
        team {
          id
          name
          group
          createdAt
          updatedAt
        }
      }
      categoryID
      status
      group
      name
      description
      teamID
      createdAt
      updatedAt
      shareability
      team {
        id
        name
        group
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankQuestionsByShareabilityQuery, ListQuestionBankQuestionsByShareabilityQueryVariables>;
export const ListQuestionBankInterviewTemplateQuestionsDocument = new TypedDocumentString(`
    query ListQuestionBankInterviewTemplateQuestions($questionID: ID!, $nextToken: String) {
  listInterviewTemplatesByQuestion(questionID: $questionID, nextToken: $nextToken) {
    nextToken
    items {
      group
      interviewTemplateID
      questionID
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankInterviewTemplateQuestionsQuery, ListQuestionBankInterviewTemplateQuestionsQueryVariables>;
export const ListQuestionBankQuestionsByCategoryIdDocument = new TypedDocumentString(`
    query ListQuestionBankQuestionsByCategoryID($categoryID: ID!, $nextToken: String) {
  getQuestionBankCategory(id: $categoryID) {
    questions(nextToken: $nextToken) {
      nextToken
      items {
        id
        name
        description
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListQuestionBankQuestionsByCategoryIdQuery, ListQuestionBankQuestionsByCategoryIdQueryVariables>;
export const GetLearnTrainingDocument = new TypedDocumentString(`
    query getLearnTraining($id: String!) {
  getLearnTraining(id: $id) {
    id
    provider
    status
    type
    versions {
      createdAt
      description
      isLatest
      link
      title
      version
    }
  }
}
    `) as unknown as TypedDocumentString<GetLearnTrainingQuery, GetLearnTrainingQueryVariables>;
export const ListTranscriptsDocument = new TypedDocumentString(`
    query listTranscripts($learnUserId: ID!, $trainingIds: [String!]) {
  listLearnAndManagedTranscripts(
    learnUserId: $learnUserId
    trainingIds: $trainingIds
  ) {
    id
    completedAt
    failedAt
    status
    trainingId
    trainingVersion
  }
}
    `) as unknown as TypedDocumentString<ListTranscriptsQuery, ListTranscriptsQueryVariables>;
export const OnLoopCreateRoutingAttemptDocument = new TypedDocumentString(`
    subscription onLoopCreateRoutingAttempt($loopEventID: ID) {
  onCreateRoutingAttempt(filter: {loopEventID: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnLoopCreateRoutingAttemptSubscription, OnLoopCreateRoutingAttemptSubscriptionVariables>;
export const OnLoopUpdateRoutingAttemptDocument = new TypedDocumentString(`
    subscription onLoopUpdateRoutingAttempt($loopEventID: ID) {
  onUpdateRoutingAttempt(filter: {loopEventID: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnLoopUpdateRoutingAttemptSubscription, OnLoopUpdateRoutingAttemptSubscriptionVariables>;
export const OnLoopCreateInterviewerDocument = new TypedDocumentString(`
    subscription onLoopCreateInterviewer($loopEventID: ID) {
  onCreateInterviewer(filter: {loopEventID: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnLoopCreateInterviewerSubscription, OnLoopCreateInterviewerSubscriptionVariables>;
export const OnLoopUpdateInterviewerDocument = new TypedDocumentString(`
    subscription onLoopUpdateInterviewer($loopEventID: ID) {
  onUpdateInterviewer(filter: {loopEventID: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnLoopUpdateInterviewerSubscription, OnLoopUpdateInterviewerSubscriptionVariables>;
export const OnLoopDeleteInterviewerDocument = new TypedDocumentString(`
    subscription onLoopDeleteInterviewer($loopEventID: ID) {
  onDeleteInterviewer(filter: {loopEventID: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnLoopDeleteInterviewerSubscription, OnLoopDeleteInterviewerSubscriptionVariables>;
export const OnUpdateLoopEventDocument = new TypedDocumentString(`
    subscription onUpdateLoopEvent($loopEventID: ID!) {
  onUpdateLoopEvent(filter: {id: {eq: $loopEventID}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<OnUpdateLoopEventSubscription, OnUpdateLoopEventSubscriptionVariables>;